/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import { AccessTokenJsConstantsCrossModel } from "../models/index";
export class AuthorizationConfig {
    getAuthorization() {
        const bplayV2 = window.localStorage.getItem(AccessTokenJsConstantsCrossModel.localStorageVariableName);
        if (bplayV2) {
            const auth = JSON.parse(bplayV2);
            return auth[AccessTokenJsConstantsCrossModel.accessTokenKey] ? `${auth[AccessTokenJsConstantsCrossModel.tokenTypeKey]} ${auth[AccessTokenJsConstantsCrossModel.accessTokenKey]}` : undefined;
        }
        return undefined;
    }
}
export class AuthorizationHeader {
    constructor(config) {
        this.transformOptions = (options) => {
            const auth = this.config.getAuthorization();
            if (auth) {
                options.headers = Object.assign(Object.assign({}, options.headers), { Authorization: auth });
            }
            return Promise.resolve(options);
        };
        if (!config)
            config = new AuthorizationConfig();
        this.config = config;
    }
    transformResult(url, response, processor) {
        // TODO: Return own result or throw exception to change default processing behavior, 
        // or call processor function to run the default processing logic
        return processor(response);
    }
}
export class AgeGroupClient extends AuthorizationHeader {
    constructor(configuration, baseUrl, http) {
        super(configuration);
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    getAll() {
        let url_ = this.baseUrl + "/agegroup/get";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetAll(_response));
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AgeGroupApiViewModel.fromJS(item));
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    get(id) {
        let url_ = this.baseUrl + "/agegroup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGet(_response));
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AgeGroupApiViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class IdentityClient extends AuthorizationHeader {
    constructor(configuration, baseUrl, http) {
        super(configuration);
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    get() {
        let url_ = this.baseUrl + "/identity";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGet(_response));
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UsersClient extends AuthorizationHeader {
    constructor(configuration, baseUrl, http) {
        super(configuration);
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    test(userId) {
        let url_ = this.baseUrl + "/users/test?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processTest(_response));
        });
    }
    processTest(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetUserByIdCrossModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getUserById(userId) {
        let url_ = this.baseUrl + "/users/getuserbyid?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetUserById(_response));
        });
    }
    processGetUserById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetUserByIdCrossModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getIdentityServerRoles(email, password) {
        let url_ = this.baseUrl + "/users/getidentityserverroles?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetIdentityServerRoles(_response));
        });
    }
    processGetIdentityServerRoles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TokenResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getUserRoles(userId) {
        let url_ = this.baseUrl + "/users/getuserroles?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetUserRoles(_response));
        });
    }
    processGetUserRoles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserRolesApiModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class PlayersClient extends AuthorizationHeader {
    constructor(configuration, baseUrl, http) {
        super(configuration);
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    search(name, clubName, playerId, playerGender, ageGroupId, matchDateTime) {
        let url_ = this.baseUrl + "/players/search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (clubName !== undefined && clubName !== null)
            url_ += "ClubName=" + encodeURIComponent("" + clubName) + "&";
        if (playerId !== undefined && playerId !== null)
            url_ += "PlayerId=" + encodeURIComponent("" + playerId) + "&";
        if (playerGender !== undefined && playerGender !== null)
            url_ += "PlayerGender=" + encodeURIComponent("" + playerGender) + "&";
        if (ageGroupId !== undefined && ageGroupId !== null)
            url_ += "AgeGroupId=" + encodeURIComponent("" + ageGroupId) + "&";
        if (matchDateTime !== undefined && matchDateTime !== null)
            url_ += "MatchDateTime=" + encodeURIComponent(matchDateTime ? "" + matchDateTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processSearch(_response));
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PlayerRankings.fromJS(item));
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class LeagueMatchClient extends AuthorizationHeader {
    constructor(configuration, baseUrl, http) {
        super(configuration);
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    getLeagueMatch(leagueMatchId) {
        let url_ = this.baseUrl + "/leaguematch/{leagueMatchId}";
        if (leagueMatchId === undefined || leagueMatchId === null)
            throw new Error("The parameter 'leagueMatchId' must be defined.");
        url_ = url_.replace("{leagueMatchId}", encodeURIComponent("" + leagueMatchId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetLeagueMatch(_response));
        });
    }
    processGetLeagueMatch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeagueMatchAggregateViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateLeagueMatch(leagueMatchId, leagueMatch) {
        let url_ = this.baseUrl + "/leaguematch/{leagueMatchId}";
        if (leagueMatchId === undefined || leagueMatchId === null)
            throw new Error("The parameter 'leagueMatchId' must be defined.");
        url_ = url_.replace("{leagueMatchId}", encodeURIComponent("" + leagueMatchId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(leagueMatch);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdateLeagueMatch(_response));
        });
    }
    processUpdateLeagueMatch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeagueMatchAggregateViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AgeGroupApiViewModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.ageGroupId = _data["ageGroupId"];
            this.ageGroupName = _data["ageGroupName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AgeGroupApiViewModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ageGroupId"] = this.ageGroupId;
        data["ageGroupName"] = this.ageGroupName;
        return data;
    }
}
export class GetUserByIdCrossModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.language = _data["language"];
            this.password = _data["password"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : undefined;
            this.createIp = _data["createIp"];
            this.updateTime = _data["updateTime"] ? new Date(_data["updateTime"].toString()) : undefined;
            this.updateIp = _data["updateIp"];
            this.active = _data["active"];
            this.loginIP = _data["loginIP"];
            this.loginTime = _data["loginTime"] ? new Date(_data["loginTime"].toString()) : undefined;
            this.parentUserId = _data["parentUserId"];
            this.createPortalId = _data["createPortalId"];
            this.coach = _data["coach"];
            this.premiumDate = _data["premiumDate"] ? new Date(_data["premiumDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserByIdCrossModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["language"] = this.language;
        data["password"] = this.password;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : undefined;
        data["createIp"] = this.createIp;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : undefined;
        data["updateIp"] = this.updateIp;
        data["active"] = this.active;
        data["loginIP"] = this.loginIP;
        data["loginTime"] = this.loginTime ? this.loginTime.toISOString() : undefined;
        data["parentUserId"] = this.parentUserId;
        data["createPortalId"] = this.createPortalId;
        data["coach"] = this.coach;
        data["premiumDate"] = this.premiumDate ? this.premiumDate.toISOString() : undefined;
        return data;
    }
}
export class ProtocolResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.httpResponse = _data["httpResponse"];
            this.raw = _data["raw"];
            this.json = _data["json"];
            this.exception = _data["exception"] ? Exception.fromJS(_data["exception"]) : undefined;
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.httpStatusCode = _data["httpStatusCode"];
            this.httpErrorReason = _data["httpErrorReason"];
            this.error = _data["error"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProtocolResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["httpResponse"] = this.httpResponse;
        data["raw"] = this.raw;
        data["json"] = this.json;
        data["exception"] = this.exception ? this.exception.toJSON() : undefined;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["httpStatusCode"] = this.httpStatusCode;
        data["httpErrorReason"] = this.httpErrorReason;
        data["error"] = this.error;
        return data;
    }
}
export class TokenResponse extends ProtocolResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.identityToken = _data["identityToken"];
            this.tokenType = _data["tokenType"];
            this.refreshToken = _data["refreshToken"];
            this.errorDescription = _data["errorDescription"];
            this.expiresIn = _data["expiresIn"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["identityToken"] = this.identityToken;
        data["tokenType"] = this.tokenType;
        data["refreshToken"] = this.refreshToken;
        data["errorDescription"] = this.errorDescription;
        data["expiresIn"] = this.expiresIn;
        super.toJSON(data);
        return data;
    }
}
export class Exception {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.stackTrace = _data["StackTrace"];
            this.message = _data["Message"];
            this.innerException = _data["InnerException"] ? Exception.fromJS(_data["InnerException"]) : undefined;
            this.source = _data["Source"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["StackTrace"] = this.stackTrace;
        data["Message"] = this.message;
        data["InnerException"] = this.innerException ? this.innerException.toJSON() : undefined;
        data["Source"] = this.source;
        return data;
    }
}
export var ResponseErrorType;
(function (ResponseErrorType) {
    ResponseErrorType[ResponseErrorType["None"] = 0] = "None";
    ResponseErrorType[ResponseErrorType["Protocol"] = 1] = "Protocol";
    ResponseErrorType[ResponseErrorType["Http"] = 2] = "Http";
    ResponseErrorType[ResponseErrorType["Exception"] = 3] = "Exception";
    ResponseErrorType[ResponseErrorType["PolicyViolation"] = 4] = "PolicyViolation";
})(ResponseErrorType || (ResponseErrorType = {}));
export var HttpStatusCode;
(function (HttpStatusCode) {
    HttpStatusCode[HttpStatusCode["Continue"] = 100] = "Continue";
    HttpStatusCode[HttpStatusCode["SwitchingProtocols"] = 101] = "SwitchingProtocols";
    HttpStatusCode[HttpStatusCode["Processing"] = 102] = "Processing";
    HttpStatusCode[HttpStatusCode["EarlyHints"] = 103] = "EarlyHints";
    HttpStatusCode[HttpStatusCode["OK"] = 200] = "OK";
    HttpStatusCode[HttpStatusCode["Created"] = 201] = "Created";
    HttpStatusCode[HttpStatusCode["Accepted"] = 202] = "Accepted";
    HttpStatusCode[HttpStatusCode["NonAuthoritativeInformation"] = 203] = "NonAuthoritativeInformation";
    HttpStatusCode[HttpStatusCode["NoContent"] = 204] = "NoContent";
    HttpStatusCode[HttpStatusCode["ResetContent"] = 205] = "ResetContent";
    HttpStatusCode[HttpStatusCode["PartialContent"] = 206] = "PartialContent";
    HttpStatusCode[HttpStatusCode["MultiStatus"] = 207] = "MultiStatus";
    HttpStatusCode[HttpStatusCode["AlreadyReported"] = 208] = "AlreadyReported";
    HttpStatusCode[HttpStatusCode["IMUsed"] = 226] = "IMUsed";
    HttpStatusCode[HttpStatusCode["MultipleChoices"] = 300] = "MultipleChoices";
    HttpStatusCode[HttpStatusCode["Ambiguous"] = 300] = "Ambiguous";
    HttpStatusCode[HttpStatusCode["MovedPermanently"] = 301] = "MovedPermanently";
    HttpStatusCode[HttpStatusCode["Moved"] = 301] = "Moved";
    HttpStatusCode[HttpStatusCode["Found"] = 302] = "Found";
    HttpStatusCode[HttpStatusCode["Redirect"] = 302] = "Redirect";
    HttpStatusCode[HttpStatusCode["SeeOther"] = 303] = "SeeOther";
    HttpStatusCode[HttpStatusCode["RedirectMethod"] = 303] = "RedirectMethod";
    HttpStatusCode[HttpStatusCode["NotModified"] = 304] = "NotModified";
    HttpStatusCode[HttpStatusCode["UseProxy"] = 305] = "UseProxy";
    HttpStatusCode[HttpStatusCode["Unused"] = 306] = "Unused";
    HttpStatusCode[HttpStatusCode["TemporaryRedirect"] = 307] = "TemporaryRedirect";
    HttpStatusCode[HttpStatusCode["RedirectKeepVerb"] = 307] = "RedirectKeepVerb";
    HttpStatusCode[HttpStatusCode["PermanentRedirect"] = 308] = "PermanentRedirect";
    HttpStatusCode[HttpStatusCode["BadRequest"] = 400] = "BadRequest";
    HttpStatusCode[HttpStatusCode["Unauthorized"] = 401] = "Unauthorized";
    HttpStatusCode[HttpStatusCode["PaymentRequired"] = 402] = "PaymentRequired";
    HttpStatusCode[HttpStatusCode["Forbidden"] = 403] = "Forbidden";
    HttpStatusCode[HttpStatusCode["NotFound"] = 404] = "NotFound";
    HttpStatusCode[HttpStatusCode["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    HttpStatusCode[HttpStatusCode["NotAcceptable"] = 406] = "NotAcceptable";
    HttpStatusCode[HttpStatusCode["ProxyAuthenticationRequired"] = 407] = "ProxyAuthenticationRequired";
    HttpStatusCode[HttpStatusCode["RequestTimeout"] = 408] = "RequestTimeout";
    HttpStatusCode[HttpStatusCode["Conflict"] = 409] = "Conflict";
    HttpStatusCode[HttpStatusCode["Gone"] = 410] = "Gone";
    HttpStatusCode[HttpStatusCode["LengthRequired"] = 411] = "LengthRequired";
    HttpStatusCode[HttpStatusCode["PreconditionFailed"] = 412] = "PreconditionFailed";
    HttpStatusCode[HttpStatusCode["RequestEntityTooLarge"] = 413] = "RequestEntityTooLarge";
    HttpStatusCode[HttpStatusCode["RequestUriTooLong"] = 414] = "RequestUriTooLong";
    HttpStatusCode[HttpStatusCode["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    HttpStatusCode[HttpStatusCode["RequestedRangeNotSatisfiable"] = 416] = "RequestedRangeNotSatisfiable";
    HttpStatusCode[HttpStatusCode["ExpectationFailed"] = 417] = "ExpectationFailed";
    HttpStatusCode[HttpStatusCode["MisdirectedRequest"] = 421] = "MisdirectedRequest";
    HttpStatusCode[HttpStatusCode["UnprocessableEntity"] = 422] = "UnprocessableEntity";
    HttpStatusCode[HttpStatusCode["Locked"] = 423] = "Locked";
    HttpStatusCode[HttpStatusCode["FailedDependency"] = 424] = "FailedDependency";
    HttpStatusCode[HttpStatusCode["UpgradeRequired"] = 426] = "UpgradeRequired";
    HttpStatusCode[HttpStatusCode["PreconditionRequired"] = 428] = "PreconditionRequired";
    HttpStatusCode[HttpStatusCode["TooManyRequests"] = 429] = "TooManyRequests";
    HttpStatusCode[HttpStatusCode["RequestHeaderFieldsTooLarge"] = 431] = "RequestHeaderFieldsTooLarge";
    HttpStatusCode[HttpStatusCode["UnavailableForLegalReasons"] = 451] = "UnavailableForLegalReasons";
    HttpStatusCode[HttpStatusCode["InternalServerError"] = 500] = "InternalServerError";
    HttpStatusCode[HttpStatusCode["NotImplemented"] = 501] = "NotImplemented";
    HttpStatusCode[HttpStatusCode["BadGateway"] = 502] = "BadGateway";
    HttpStatusCode[HttpStatusCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    HttpStatusCode[HttpStatusCode["GatewayTimeout"] = 504] = "GatewayTimeout";
    HttpStatusCode[HttpStatusCode["HttpVersionNotSupported"] = 505] = "HttpVersionNotSupported";
    HttpStatusCode[HttpStatusCode["VariantAlsoNegotiates"] = 506] = "VariantAlsoNegotiates";
    HttpStatusCode[HttpStatusCode["InsufficientStorage"] = 507] = "InsufficientStorage";
    HttpStatusCode[HttpStatusCode["LoopDetected"] = 508] = "LoopDetected";
    HttpStatusCode[HttpStatusCode["NotExtended"] = 510] = "NotExtended";
    HttpStatusCode[HttpStatusCode["NetworkAuthenticationRequired"] = 511] = "NetworkAuthenticationRequired";
})(HttpStatusCode || (HttpStatusCode = {}));
export class UserRolesApiModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.language = _data["language"];
            if (_data["userRoles"]) {
                this.userRoles = {};
                for (let key in _data["userRoles"]) {
                    if (_data["userRoles"].hasOwnProperty(key))
                        this.userRoles[key] = _data["userRoles"][key] ? UserRoleModel.fromJS(_data["userRoles"][key]) : new UserRoleModel();
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserRolesApiModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["language"] = this.language;
        if (this.userRoles) {
            data["userRoles"] = {};
            for (let key in this.userRoles) {
                if (this.userRoles.hasOwnProperty(key))
                    data["userRoles"][key] = this.userRoles[key] ? this.userRoles[key].toJSON() : undefined;
            }
        }
        return data;
    }
}
export class UserRoleModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.roleMask = _data["roleMask"];
            this.isSystemRole = _data["isSystemRole"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["roleMask"] = this.roleMask;
        data["isSystemRole"] = this.isSystemRole;
        return data;
    }
}
export class PlayerRankings {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.playerID = _data["playerID"];
            this.playerNumber = _data["playerNumber"];
            this.name = _data["name"];
            this.gender = _data["gender"];
            this.singlePoints = _data["singlePoints"];
            this.doublePoints = _data["doublePoints"];
            this.mixPoints = _data["mixPoints"];
            this.singleRanking = _data["singleRanking"];
            this.doubleRanking = _data["doubleRanking"];
            this.mixRanking = _data["mixRanking"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerRankings();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["playerID"] = this.playerID;
        data["playerNumber"] = this.playerNumber;
        data["name"] = this.name;
        data["gender"] = this.gender;
        data["singlePoints"] = this.singlePoints;
        data["doublePoints"] = this.doublePoints;
        data["mixPoints"] = this.mixPoints;
        data["singleRanking"] = this.singleRanking;
        data["doubleRanking"] = this.doubleRanking;
        data["mixRanking"] = this.mixRanking;
        return data;
    }
}
export class LeagueMatchAggregateViewModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.match = _data["match"] ? LeagueMatchAdmin.fromJS(_data["match"]) : undefined;
            if (Array.isArray(_data["team1Players"])) {
                this.team1Players = [];
                for (let item of _data["team1Players"])
                    this.team1Players.push(PlayerRankings.fromJS(item));
            }
            if (Array.isArray(_data["team2Players"])) {
                this.team2Players = [];
                for (let item of _data["team2Players"])
                    this.team2Players.push(PlayerRankings.fromJS(item));
            }
            if (Array.isArray(_data["combinedTeamMatches"])) {
                this.combinedTeamMatches = [];
                for (let item of _data["combinedTeamMatches"])
                    this.combinedTeamMatches.push(LeagueIndividualMatchViewModel.fromJS(item));
            }
            if (Array.isArray(_data["substitutes"])) {
                this.substitutes = [];
                for (let item of _data["substitutes"])
                    this.substitutes.push(LeagueMatchSubstitutesViewModel.fromJS(item));
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [];
                for (let item of _data["regions"])
                    this.regions.push(RegionViewModel.fromJS(item));
            }
            if (_data["texts"]) {
                this.texts = {};
                for (let key in _data["texts"]) {
                    if (_data["texts"].hasOwnProperty(key))
                        this.texts[key] = _data["texts"][key];
                }
            }
            this.settings = _data["settings"] ? LeagueMatchSettingsViewModel.fromJS(_data["settings"]) : undefined;
            this.resultType = _data["resultType"];
            this.hasGoldenSet = _data["hasGoldenSet"];
            this.isDraft = _data["isDraft"];
            this.saveChangeLog = _data["saveChangeLog"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchAggregateViewModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["match"] = this.match ? this.match.toJSON() : undefined;
        if (Array.isArray(this.team1Players)) {
            data["team1Players"] = [];
            for (let item of this.team1Players)
                data["team1Players"].push(item.toJSON());
        }
        if (Array.isArray(this.team2Players)) {
            data["team2Players"] = [];
            for (let item of this.team2Players)
                data["team2Players"].push(item.toJSON());
        }
        if (Array.isArray(this.combinedTeamMatches)) {
            data["combinedTeamMatches"] = [];
            for (let item of this.combinedTeamMatches)
                data["combinedTeamMatches"].push(item.toJSON());
        }
        if (Array.isArray(this.substitutes)) {
            data["substitutes"] = [];
            for (let item of this.substitutes)
                data["substitutes"].push(item.toJSON());
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item.toJSON());
        }
        if (this.texts) {
            data["texts"] = {};
            for (let key in this.texts) {
                if (this.texts.hasOwnProperty(key))
                    data["texts"][key] = this.texts[key];
            }
        }
        data["settings"] = this.settings ? this.settings.toJSON() : undefined;
        data["resultType"] = this.resultType;
        data["hasGoldenSet"] = this.hasGoldenSet;
        data["isDraft"] = this.isDraft;
        data["saveChangeLog"] = this.saveChangeLog;
        return data;
    }
}
export class LeagueMatchAdmin {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueMatchId = _data["leagueMatchId"];
            this.leagueDivisionId = _data["leagueDivisionId"];
            this.divisionName = _data["divisionName"];
            this.regionId = _data["regionId"];
            this.regionCount = _data["regionCount"];
            this.ageGroupId = _data["ageGroupId"];
            this.roundDate = _data["roundDate"] ? new Date(_data["roundDate"].toString()) : undefined;
            this.roundIndex = _data["roundIndex"];
            this.roundText = _data["roundText"];
            this.leagueGroupTeamId1 = _data["leagueGroupTeamId1"];
            this.teamName1 = _data["teamName1"];
            this.teamNumber1 = _data["teamNumber1"];
            this.clubId1 = _data["clubId1"];
            this.leagueTeamId1 = _data["leagueTeamId1"];
            this.leagueGroupTeamId2 = _data["leagueGroupTeamId2"];
            this.teamName2 = _data["teamName2"];
            this.clubId2 = _data["clubId2"];
            this.leagueTeamId2 = _data["leagueTeamId2"];
            this.teamNumber2 = _data["teamNumber2"];
            this.matchTime = _data["matchTime"] ? new Date(_data["matchTime"].toString()) : undefined;
            this.venueId = _data["venueId"];
            this.venueName = _data["venueName"];
            this.score1 = _data["score1"];
            this.score2 = _data["score2"];
            this.teamLeagueSchemaId = _data["teamLeagueSchemaId"];
            this.individualMatchResults = _data["individualMatchResults"];
            this.matchTimeRegistrationOpen = _data["matchTimeRegistrationOpen"];
            this.matchResultRegistrationOpen = _data["matchResultRegistrationOpen"];
            this.resultCompleted = _data["resultCompleted"];
            this.walkOver = _data["walkOver"];
            this.teamLeagueSchemaOptions = _data["teamLeagueSchemaOptions"];
            this.matchPointsLeagueSchemaId = _data["matchPointsLeagueSchemaId"];
            this.rankingPointsLeagueSchemaId = _data["rankingPointsLeagueSchemaId"];
            this.leagueGroupId = _data["leagueGroupId"];
            this.groupName = _data["groupName"];
            this.points1 = _data["points1"];
            this.points2 = _data["points2"];
            this.setsWon1 = _data["setsWon1"];
            this.setsWon2 = _data["setsWon2"];
            this.setPointsWon1 = _data["setPointsWon1"];
            this.setPointsWon2 = _data["setPointsWon2"];
            this.seasonId = _data["seasonId"];
            this.public = _data["public"];
            this.matchPlanComplete = _data["matchPlanComplete"];
            this.organiserClubId = _data["organiserClubId"];
            this.organiserLeagueTeamId = _data["organiserLeagueTeamId"];
            this.eventRounds = _data["eventRounds"];
            this.teamText1 = _data["teamText1"];
            this.teamText2 = _data["teamText2"];
            this.maxSets = _data["maxSets"];
            this.matchPointsRuleId = _data["matchPointsRuleId"];
            this.comment = _data["comment"];
            this.resultUpdated = _data["resultUpdated"] ? new Date(_data["resultUpdated"].toString()) : undefined;
            this.resultUpdatedByUserId = _data["resultUpdatedByUserId"];
            this.extraTime = _data["extraTime"];
            this.liveScore = _data["liveScore"];
            this.liveScoreCode = _data["liveScoreCode"];
            this.liveScoreEnabled = _data["liveScoreEnabled"];
            this.teamsPublic = _data["teamsPublic"];
            this.team2Updated = _data["team2Updated"] ? new Date(_data["team2Updated"].toString()) : undefined;
            this.team2UpdatedByUserId = _data["team2UpdatedByUserId"];
            this.separateTeamRegistration = _data["separateTeamRegistration"];
            this.teamsPublicMinutes = _data["teamsPublicMinutes"];
            this.organiserLeagueGroupTeamId = _data["organiserLeagueGroupTeamId"];
            this.team1Ready = _data["team1Ready"];
            this.team2Ready = _data["team2Ready"];
            this.withdrawn1 = _data["withdrawn1"];
            this.withdrawn2 = _data["withdrawn2"];
            this.postponed = _data["postponed"];
            this.walkOverReason = _data["walkOverReason"];
            this.matchResultAutosortPlayersEnabled = _data["matchResultAutosortPlayersEnabled"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchAdmin();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueMatchId"] = this.leagueMatchId;
        data["leagueDivisionId"] = this.leagueDivisionId;
        data["divisionName"] = this.divisionName;
        data["regionId"] = this.regionId;
        data["regionCount"] = this.regionCount;
        data["ageGroupId"] = this.ageGroupId;
        data["roundDate"] = this.roundDate ? this.roundDate.toISOString() : undefined;
        data["roundIndex"] = this.roundIndex;
        data["roundText"] = this.roundText;
        data["leagueGroupTeamId1"] = this.leagueGroupTeamId1;
        data["teamName1"] = this.teamName1;
        data["teamNumber1"] = this.teamNumber1;
        data["clubId1"] = this.clubId1;
        data["leagueTeamId1"] = this.leagueTeamId1;
        data["leagueGroupTeamId2"] = this.leagueGroupTeamId2;
        data["teamName2"] = this.teamName2;
        data["clubId2"] = this.clubId2;
        data["leagueTeamId2"] = this.leagueTeamId2;
        data["teamNumber2"] = this.teamNumber2;
        data["matchTime"] = this.matchTime ? this.matchTime.toISOString() : undefined;
        data["venueId"] = this.venueId;
        data["venueName"] = this.venueName;
        data["score1"] = this.score1;
        data["score2"] = this.score2;
        data["teamLeagueSchemaId"] = this.teamLeagueSchemaId;
        data["individualMatchResults"] = this.individualMatchResults;
        data["matchTimeRegistrationOpen"] = this.matchTimeRegistrationOpen;
        data["matchResultRegistrationOpen"] = this.matchResultRegistrationOpen;
        data["resultCompleted"] = this.resultCompleted;
        data["walkOver"] = this.walkOver;
        data["teamLeagueSchemaOptions"] = this.teamLeagueSchemaOptions;
        data["matchPointsLeagueSchemaId"] = this.matchPointsLeagueSchemaId;
        data["rankingPointsLeagueSchemaId"] = this.rankingPointsLeagueSchemaId;
        data["leagueGroupId"] = this.leagueGroupId;
        data["groupName"] = this.groupName;
        data["points1"] = this.points1;
        data["points2"] = this.points2;
        data["setsWon1"] = this.setsWon1;
        data["setsWon2"] = this.setsWon2;
        data["setPointsWon1"] = this.setPointsWon1;
        data["setPointsWon2"] = this.setPointsWon2;
        data["seasonId"] = this.seasonId;
        data["public"] = this.public;
        data["matchPlanComplete"] = this.matchPlanComplete;
        data["organiserClubId"] = this.organiserClubId;
        data["organiserLeagueTeamId"] = this.organiserLeagueTeamId;
        data["eventRounds"] = this.eventRounds;
        data["teamText1"] = this.teamText1;
        data["teamText2"] = this.teamText2;
        data["maxSets"] = this.maxSets;
        data["matchPointsRuleId"] = this.matchPointsRuleId;
        data["comment"] = this.comment;
        data["resultUpdated"] = this.resultUpdated ? this.resultUpdated.toISOString() : undefined;
        data["resultUpdatedByUserId"] = this.resultUpdatedByUserId;
        data["extraTime"] = this.extraTime;
        data["liveScore"] = this.liveScore;
        data["liveScoreCode"] = this.liveScoreCode;
        data["liveScoreEnabled"] = this.liveScoreEnabled;
        data["teamsPublic"] = this.teamsPublic;
        data["team2Updated"] = this.team2Updated ? this.team2Updated.toISOString() : undefined;
        data["team2UpdatedByUserId"] = this.team2UpdatedByUserId;
        data["separateTeamRegistration"] = this.separateTeamRegistration;
        data["teamsPublicMinutes"] = this.teamsPublicMinutes;
        data["organiserLeagueGroupTeamId"] = this.organiserLeagueGroupTeamId;
        data["team1Ready"] = this.team1Ready;
        data["team2Ready"] = this.team2Ready;
        data["withdrawn1"] = this.withdrawn1;
        data["withdrawn2"] = this.withdrawn2;
        data["postponed"] = this.postponed;
        data["walkOverReason"] = this.walkOverReason;
        data["matchResultAutosortPlayersEnabled"] = this.matchResultAutosortPlayersEnabled;
        return data;
    }
}
export class LeagueMatchIndividualMatch {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueMatchIndividualMatchId = _data["leagueMatchIndividualMatchId"];
            this.leagueMatchId = _data["leagueMatchId"];
            this.disciplineCode = _data["disciplineCode"];
            this.disciplineRanking = _data["disciplineRanking"];
            this.winnerWo = _data["winnerWo"];
            this.winnerIndex = _data["winnerIndex"];
            this.isNotInValidPointOrder = _data["isNotInValidPointOrder"];
            this.isGoldenSet = _data["isGoldenSet"];
            this.leagueMatch = _data["leagueMatch"] ? LeagueMatch.fromJS(_data["leagueMatch"]) : undefined;
            this.liveScoreLeagueIndividualMatch = _data["liveScoreLeagueIndividualMatch"] ? LiveScoreLeagueIndividualMatch.fromJS(_data["liveScoreLeagueIndividualMatch"]) : undefined;
            if (Array.isArray(_data["leagueMatchPlayer"])) {
                this.leagueMatchPlayer = [];
                for (let item of _data["leagueMatchPlayer"])
                    this.leagueMatchPlayer.push(LeagueMatchPlayer.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchPlayerLog"])) {
                this.leagueMatchPlayerLog = [];
                for (let item of _data["leagueMatchPlayerLog"])
                    this.leagueMatchPlayerLog.push(LeagueMatchPlayerLog.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchSet"])) {
                this.leagueMatchSet = [];
                for (let item of _data["leagueMatchSet"])
                    this.leagueMatchSet.push(LeagueMatchSet.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchIndividualMatch();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueMatchIndividualMatchId"] = this.leagueMatchIndividualMatchId;
        data["leagueMatchId"] = this.leagueMatchId;
        data["disciplineCode"] = this.disciplineCode;
        data["disciplineRanking"] = this.disciplineRanking;
        data["winnerWo"] = this.winnerWo;
        data["winnerIndex"] = this.winnerIndex;
        data["isNotInValidPointOrder"] = this.isNotInValidPointOrder;
        data["isGoldenSet"] = this.isGoldenSet;
        data["leagueMatch"] = this.leagueMatch ? this.leagueMatch.toJSON() : undefined;
        data["liveScoreLeagueIndividualMatch"] = this.liveScoreLeagueIndividualMatch ? this.liveScoreLeagueIndividualMatch.toJSON() : undefined;
        if (Array.isArray(this.leagueMatchPlayer)) {
            data["leagueMatchPlayer"] = [];
            for (let item of this.leagueMatchPlayer)
                data["leagueMatchPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchPlayerLog)) {
            data["leagueMatchPlayerLog"] = [];
            for (let item of this.leagueMatchPlayerLog)
                data["leagueMatchPlayerLog"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchSet)) {
            data["leagueMatchSet"] = [];
            for (let item of this.leagueMatchSet)
                data["leagueMatchSet"].push(item.toJSON());
        }
        return data;
    }
}
export class LeagueIndividualMatchViewModel extends LeagueMatchIndividualMatch {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.matchIndex = _data["matchIndex"];
            this.selectPlayerType = _data["selectPlayerType"];
            this.group = _data["group"];
            if (_data["teamPlayers"]) {
                this.teamPlayers = {};
                for (let key in _data["teamPlayers"]) {
                    if (_data["teamPlayers"].hasOwnProperty(key))
                        this.teamPlayers[key] = _data["teamPlayers"][key] ? _data["teamPlayers"][key].map((i) => LeagueMatchPlayerViewModel.fromJS(i)) : [];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueIndividualMatchViewModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["matchIndex"] = this.matchIndex;
        data["selectPlayerType"] = this.selectPlayerType;
        data["group"] = this.group;
        if (this.teamPlayers) {
            data["teamPlayers"] = {};
            for (let key in this.teamPlayers) {
                if (this.teamPlayers.hasOwnProperty(key))
                    data["teamPlayers"][key] = this.teamPlayers[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}
export var SelectPlayerTypeEnum;
(function (SelectPlayerTypeEnum) {
    SelectPlayerTypeEnum[SelectPlayerTypeEnum["Search"] = 0] = "Search";
    SelectPlayerTypeEnum[SelectPlayerTypeEnum["PreviousMatches"] = 1] = "PreviousMatches";
    SelectPlayerTypeEnum[SelectPlayerTypeEnum["NoPlayer"] = 2] = "NoPlayer";
    SelectPlayerTypeEnum[SelectPlayerTypeEnum["Substitute"] = 3] = "Substitute";
    SelectPlayerTypeEnum[SelectPlayerTypeEnum["PlayerTroopMen"] = 4] = "PlayerTroopMen";
    SelectPlayerTypeEnum[SelectPlayerTypeEnum["PlayerTroopWomen"] = 5] = "PlayerTroopWomen";
})(SelectPlayerTypeEnum || (SelectPlayerTypeEnum = {}));
export class LeagueMatchPlayerViewModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.disciplineCode = _data["disciplineCode"];
            this.disciplineRanking = _data["disciplineRanking"];
            this.leagueGroupTeamId = _data["leagueGroupTeamId"];
            this.noShow = _data["noShow"];
            this.unknown = _data["unknown"];
            this.playerId = _data["playerId"];
            this.playerIndex = _data["playerIndex"];
            this.rankingPoints = _data["rankingPoints"];
            this.rankingPointsCount = _data["rankingPointsCount"];
            this.player = _data["player"] ? PlayerViewModel.fromJS(_data["player"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchPlayerViewModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["disciplineCode"] = this.disciplineCode;
        data["disciplineRanking"] = this.disciplineRanking;
        data["leagueGroupTeamId"] = this.leagueGroupTeamId;
        data["noShow"] = this.noShow;
        data["unknown"] = this.unknown;
        data["playerId"] = this.playerId;
        data["playerIndex"] = this.playerIndex;
        data["rankingPoints"] = this.rankingPoints;
        data["rankingPointsCount"] = this.rankingPointsCount;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        return data;
    }
}
export class PlayerViewModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.gender = _data["gender"];
            this.name = _data["name"];
            this.active = _data["active"];
            this.playerNumber = _data["playerNumber"];
            this.disciplinePoints = _data["disciplinePoints"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerViewModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["gender"] = this.gender;
        data["name"] = this.name;
        data["active"] = this.active;
        data["playerNumber"] = this.playerNumber;
        data["disciplinePoints"] = this.disciplinePoints;
        return data;
    }
}
export class LeagueMatch {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueMatchId = _data["leagueMatchId"];
            this.leagueRoundSchemaId = _data["leagueRoundSchemaId"];
            this.roundIndex = _data["roundIndex"];
            this.leagueGroupTeamId1 = _data["leagueGroupTeamId1"];
            this.leagueGroupTeamId2 = _data["leagueGroupTeamId2"];
            this.matchTime = _data["matchTime"] ? new Date(_data["matchTime"].toString()) : undefined;
            this.venueId = _data["venueId"];
            this.matchTimeUpdatedByUserId = _data["matchTimeUpdatedByUserId"];
            this.matchTimeUpdated = _data["matchTimeUpdated"] ? new Date(_data["matchTimeUpdated"].toString()) : undefined;
            this.resultUpdatedByUserId = _data["resultUpdatedByUserId"];
            this.resultUpdated = _data["resultUpdated"] ? new Date(_data["resultUpdated"].toString()) : undefined;
            this.resultCompleted = _data["resultCompleted"];
            this.walkOver = _data["walkOver"];
            this.points1 = _data["points1"];
            this.points2 = _data["points2"];
            this.score1 = _data["score1"];
            this.score2 = _data["score2"];
            this.setsWon1 = _data["setsWon1"];
            this.setsWon2 = _data["setsWon2"];
            this.setPointsWon1 = _data["setPointsWon1"];
            this.setPointsWon2 = _data["setPointsWon2"];
            this.court1 = _data["court1"];
            this.court2 = _data["court2"];
            this.roundMatchIndex = _data["roundMatchIndex"];
            this.organiserLeagueGroupTeamId = _data["organiserLeagueGroupTeamId"];
            this.importMatchNumber = _data["importMatchNumber"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined;
            this.comment = _data["comment"];
            this.extraTime = _data["extraTime"];
            this.liveScore = _data["liveScore"];
            this.liveScoreCode = _data["liveScoreCode"];
            this.team1Ready = _data["team1Ready"];
            this.team2Ready = _data["team2Ready"];
            this.teamsPublic = _data["teamsPublic"];
            this.team2Updated = _data["team2Updated"] ? new Date(_data["team2Updated"].toString()) : undefined;
            this.team2UpdatedByUserId = _data["team2UpdatedByUserId"];
            this.postponed = _data["postponed"];
            this.eliminationId = _data["eliminationId"];
            this.transferFromEliminationId1 = _data["transferFromEliminationId1"];
            this.transferFromEliminationId2 = _data["transferFromEliminationId2"];
            this.walkOverReason = _data["walkOverReason"];
            this.leagueGroupTeamId2Navigation = _data["leagueGroupTeamId2Navigation"] ? LeagueGroupTeam.fromJS(_data["leagueGroupTeamId2Navigation"]) : undefined;
            this.leagueRound = _data["leagueRound"] ? LeagueRound.fromJS(_data["leagueRound"]) : undefined;
            this.matchTimeUpdatedByUser = _data["matchTimeUpdatedByUser"] ? User1.fromJS(_data["matchTimeUpdatedByUser"]) : undefined;
            this.organiserLeagueGroupTeam = _data["organiserLeagueGroupTeam"] ? LeagueGroupTeam.fromJS(_data["organiserLeagueGroupTeam"]) : undefined;
            this.resultUpdatedByUser = _data["resultUpdatedByUser"] ? User1.fromJS(_data["resultUpdatedByUser"]) : undefined;
            this.team2UpdatedByUser = _data["team2UpdatedByUser"] ? User1.fromJS(_data["team2UpdatedByUser"]) : undefined;
            this.venue = _data["venue"] ? Venue.fromJS(_data["venue"]) : undefined;
            this.liveScoreLeagueMatch = _data["liveScoreLeagueMatch"] ? LiveScoreLeagueMatch.fromJS(_data["liveScoreLeagueMatch"]) : undefined;
            if (Array.isArray(_data["leagueMatchIndividualMatch"])) {
                this.leagueMatchIndividualMatch = [];
                for (let item of _data["leagueMatchIndividualMatch"])
                    this.leagueMatchIndividualMatch.push(LeagueMatchIndividualMatch.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchMultiTeam"])) {
                this.leagueMatchMultiTeam = [];
                for (let item of _data["leagueMatchMultiTeam"])
                    this.leagueMatchMultiTeam.push(LeagueMatchMultiTeam.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchReferee"])) {
                this.leagueMatchReferee = [];
                for (let item of _data["leagueMatchReferee"])
                    this.leagueMatchReferee.push(LeagueMatchReferee.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchSubstitute"])) {
                this.leagueMatchSubstitute = [];
                for (let item of _data["leagueMatchSubstitute"])
                    this.leagueMatchSubstitute.push(LeagueMatchSubstitute.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchTroopPlayer"])) {
                this.leagueMatchTroopPlayer = [];
                for (let item of _data["leagueMatchTroopPlayer"])
                    this.leagueMatchTroopPlayer.push(LeagueMatchTroopPlayer.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatch();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueMatchId"] = this.leagueMatchId;
        data["leagueRoundSchemaId"] = this.leagueRoundSchemaId;
        data["roundIndex"] = this.roundIndex;
        data["leagueGroupTeamId1"] = this.leagueGroupTeamId1;
        data["leagueGroupTeamId2"] = this.leagueGroupTeamId2;
        data["matchTime"] = this.matchTime ? this.matchTime.toISOString() : undefined;
        data["venueId"] = this.venueId;
        data["matchTimeUpdatedByUserId"] = this.matchTimeUpdatedByUserId;
        data["matchTimeUpdated"] = this.matchTimeUpdated ? this.matchTimeUpdated.toISOString() : undefined;
        data["resultUpdatedByUserId"] = this.resultUpdatedByUserId;
        data["resultUpdated"] = this.resultUpdated ? this.resultUpdated.toISOString() : undefined;
        data["resultCompleted"] = this.resultCompleted;
        data["walkOver"] = this.walkOver;
        data["points1"] = this.points1;
        data["points2"] = this.points2;
        data["score1"] = this.score1;
        data["score2"] = this.score2;
        data["setsWon1"] = this.setsWon1;
        data["setsWon2"] = this.setsWon2;
        data["setPointsWon1"] = this.setPointsWon1;
        data["setPointsWon2"] = this.setPointsWon2;
        data["court1"] = this.court1;
        data["court2"] = this.court2;
        data["roundMatchIndex"] = this.roundMatchIndex;
        data["organiserLeagueGroupTeamId"] = this.organiserLeagueGroupTeamId;
        data["importMatchNumber"] = this.importMatchNumber;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["comment"] = this.comment;
        data["extraTime"] = this.extraTime;
        data["liveScore"] = this.liveScore;
        data["liveScoreCode"] = this.liveScoreCode;
        data["team1Ready"] = this.team1Ready;
        data["team2Ready"] = this.team2Ready;
        data["teamsPublic"] = this.teamsPublic;
        data["team2Updated"] = this.team2Updated ? this.team2Updated.toISOString() : undefined;
        data["team2UpdatedByUserId"] = this.team2UpdatedByUserId;
        data["postponed"] = this.postponed;
        data["eliminationId"] = this.eliminationId;
        data["transferFromEliminationId1"] = this.transferFromEliminationId1;
        data["transferFromEliminationId2"] = this.transferFromEliminationId2;
        data["walkOverReason"] = this.walkOverReason;
        data["leagueGroupTeamId2Navigation"] = this.leagueGroupTeamId2Navigation ? this.leagueGroupTeamId2Navigation.toJSON() : undefined;
        data["leagueRound"] = this.leagueRound ? this.leagueRound.toJSON() : undefined;
        data["matchTimeUpdatedByUser"] = this.matchTimeUpdatedByUser ? this.matchTimeUpdatedByUser.toJSON() : undefined;
        data["organiserLeagueGroupTeam"] = this.organiserLeagueGroupTeam ? this.organiserLeagueGroupTeam.toJSON() : undefined;
        data["resultUpdatedByUser"] = this.resultUpdatedByUser ? this.resultUpdatedByUser.toJSON() : undefined;
        data["team2UpdatedByUser"] = this.team2UpdatedByUser ? this.team2UpdatedByUser.toJSON() : undefined;
        data["venue"] = this.venue ? this.venue.toJSON() : undefined;
        data["liveScoreLeagueMatch"] = this.liveScoreLeagueMatch ? this.liveScoreLeagueMatch.toJSON() : undefined;
        if (Array.isArray(this.leagueMatchIndividualMatch)) {
            data["leagueMatchIndividualMatch"] = [];
            for (let item of this.leagueMatchIndividualMatch)
                data["leagueMatchIndividualMatch"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchMultiTeam)) {
            data["leagueMatchMultiTeam"] = [];
            for (let item of this.leagueMatchMultiTeam)
                data["leagueMatchMultiTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchReferee)) {
            data["leagueMatchReferee"] = [];
            for (let item of this.leagueMatchReferee)
                data["leagueMatchReferee"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchSubstitute)) {
            data["leagueMatchSubstitute"] = [];
            for (let item of this.leagueMatchSubstitute)
                data["leagueMatchSubstitute"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchTroopPlayer)) {
            data["leagueMatchTroopPlayer"] = [];
            for (let item of this.leagueMatchTroopPlayer)
                data["leagueMatchTroopPlayer"].push(item.toJSON());
        }
        return data;
    }
}
export class LeagueGroupTeam {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueGroupTeamId = _data["leagueGroupTeamId"];
            this.leagueGroupId = _data["leagueGroupId"];
            this.index = _data["index"];
            this.clubId = _data["clubId"];
            this.leagueTeamId = _data["leagueTeamId"];
            this.teamNumber = _data["teamNumber"];
            this.preliminaryGroupIndex = _data["preliminaryGroupIndex"];
            this.startPoints = _data["startPoints"];
            this.startMatchesWon = _data["startMatchesWon"];
            this.startScoreWon = _data["startScoreWon"];
            this.startScoreLost = _data["startScoreLost"];
            this.standing = _data["standing"];
            this.text = _data["text"];
            this.matchesPlayed = _data["matchesPlayed"];
            this.matchesWon = _data["matchesWon"];
            this.matchesLost = _data["matchesLost"];
            this.matchScoreWon = _data["matchScoreWon"];
            this.matchScoreLost = _data["matchScoreLost"];
            this.setScoreWon = _data["setScoreWon"];
            this.setScoreLost = _data["setScoreLost"];
            this.setPointScoreWon = _data["setPointScoreWon"];
            this.setPointScoreLost = _data["setPointScoreLost"];
            this.points = _data["points"];
            this.venueId = _data["venueId"];
            this.court1 = _data["court1"];
            this.court2 = _data["court2"];
            this.weekDay = _data["weekDay"];
            this.timeOfDay = _data["timeOfDay"];
            this.withdrawn = _data["withdrawn"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.comment = _data["comment"];
            this.password = _data["password"];
            this.transferFromLeagueGroupId = _data["transferFromLeagueGroupId"];
            this.transferFromLeagueGroupStanding = _data["transferFromLeagueGroupStanding"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.leagueGroup = _data["leagueGroup"] ? LeagueGroup.fromJS(_data["leagueGroup"]) : undefined;
            this.leagueTeam = _data["leagueTeam"] ? LeagueTeam.fromJS(_data["leagueTeam"]) : undefined;
            this.transferFromLeagueGroup = _data["transferFromLeagueGroup"] ? LeagueGroup.fromJS(_data["transferFromLeagueGroup"]) : undefined;
            this.venue = _data["venue"] ? Venue.fromJS(_data["venue"]) : undefined;
            if (Array.isArray(_data["leagueMatch1LeagueGroupTeamId2Navigation"])) {
                this.leagueMatch1LeagueGroupTeamId2Navigation = [];
                for (let item of _data["leagueMatch1LeagueGroupTeamId2Navigation"])
                    this.leagueMatch1LeagueGroupTeamId2Navigation.push(LeagueMatch.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatch1OrganiserLeagueGroupTeam"])) {
                this.leagueMatch1OrganiserLeagueGroupTeam = [];
                for (let item of _data["leagueMatch1OrganiserLeagueGroupTeam"])
                    this.leagueMatch1OrganiserLeagueGroupTeam.push(LeagueMatch.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchMultiTeam"])) {
                this.leagueMatchMultiTeam = [];
                for (let item of _data["leagueMatchMultiTeam"])
                    this.leagueMatchMultiTeam.push(LeagueMatchMultiTeam.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchPlayer"])) {
                this.leagueMatchPlayer = [];
                for (let item of _data["leagueMatchPlayer"])
                    this.leagueMatchPlayer.push(LeagueMatchPlayer.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchPlayerLog"])) {
                this.leagueMatchPlayerLog = [];
                for (let item of _data["leagueMatchPlayerLog"])
                    this.leagueMatchPlayerLog.push(LeagueMatchPlayerLog.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchSubstitute"])) {
                this.leagueMatchSubstitute = [];
                for (let item of _data["leagueMatchSubstitute"])
                    this.leagueMatchSubstitute.push(LeagueMatchSubstitute.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchTroopPlayer"])) {
                this.leagueMatchTroopPlayer = [];
                for (let item of _data["leagueMatchTroopPlayer"])
                    this.leagueMatchTroopPlayer.push(LeagueMatchTroopPlayer.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueGroupTeam();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueGroupTeamId"] = this.leagueGroupTeamId;
        data["leagueGroupId"] = this.leagueGroupId;
        data["index"] = this.index;
        data["clubId"] = this.clubId;
        data["leagueTeamId"] = this.leagueTeamId;
        data["teamNumber"] = this.teamNumber;
        data["preliminaryGroupIndex"] = this.preliminaryGroupIndex;
        data["startPoints"] = this.startPoints;
        data["startMatchesWon"] = this.startMatchesWon;
        data["startScoreWon"] = this.startScoreWon;
        data["startScoreLost"] = this.startScoreLost;
        data["standing"] = this.standing;
        data["text"] = this.text;
        data["matchesPlayed"] = this.matchesPlayed;
        data["matchesWon"] = this.matchesWon;
        data["matchesLost"] = this.matchesLost;
        data["matchScoreWon"] = this.matchScoreWon;
        data["matchScoreLost"] = this.matchScoreLost;
        data["setScoreWon"] = this.setScoreWon;
        data["setScoreLost"] = this.setScoreLost;
        data["setPointScoreWon"] = this.setPointScoreWon;
        data["setPointScoreLost"] = this.setPointScoreLost;
        data["points"] = this.points;
        data["venueId"] = this.venueId;
        data["court1"] = this.court1;
        data["court2"] = this.court2;
        data["weekDay"] = this.weekDay;
        data["timeOfDay"] = this.timeOfDay;
        data["withdrawn"] = this.withdrawn;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["comment"] = this.comment;
        data["password"] = this.password;
        data["transferFromLeagueGroupId"] = this.transferFromLeagueGroupId;
        data["transferFromLeagueGroupStanding"] = this.transferFromLeagueGroupStanding;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["leagueGroup"] = this.leagueGroup ? this.leagueGroup.toJSON() : undefined;
        data["leagueTeam"] = this.leagueTeam ? this.leagueTeam.toJSON() : undefined;
        data["transferFromLeagueGroup"] = this.transferFromLeagueGroup ? this.transferFromLeagueGroup.toJSON() : undefined;
        data["venue"] = this.venue ? this.venue.toJSON() : undefined;
        if (Array.isArray(this.leagueMatch1LeagueGroupTeamId2Navigation)) {
            data["leagueMatch1LeagueGroupTeamId2Navigation"] = [];
            for (let item of this.leagueMatch1LeagueGroupTeamId2Navigation)
                data["leagueMatch1LeagueGroupTeamId2Navigation"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatch1OrganiserLeagueGroupTeam)) {
            data["leagueMatch1OrganiserLeagueGroupTeam"] = [];
            for (let item of this.leagueMatch1OrganiserLeagueGroupTeam)
                data["leagueMatch1OrganiserLeagueGroupTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchMultiTeam)) {
            data["leagueMatchMultiTeam"] = [];
            for (let item of this.leagueMatchMultiTeam)
                data["leagueMatchMultiTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchPlayer)) {
            data["leagueMatchPlayer"] = [];
            for (let item of this.leagueMatchPlayer)
                data["leagueMatchPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchPlayerLog)) {
            data["leagueMatchPlayerLog"] = [];
            for (let item of this.leagueMatchPlayerLog)
                data["leagueMatchPlayerLog"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchSubstitute)) {
            data["leagueMatchSubstitute"] = [];
            for (let item of this.leagueMatchSubstitute)
                data["leagueMatchSubstitute"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchTroopPlayer)) {
            data["leagueMatchTroopPlayer"] = [];
            for (let item of this.leagueMatchTroopPlayer)
                data["leagueMatchTroopPlayer"].push(item.toJSON());
        }
        return data;
    }
}
export class Club2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.unionId = _data["unionId"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.clubNumber = _data["clubNumber"];
            this.active = _data["active"];
            this.password = _data["password"];
            this.acceptRegistrationPayments = _data["acceptRegistrationPayments"];
            this.registrationPaymentsReminderDays = _data["registrationPaymentsReminderDays"];
            this.updatedByUserId = _data["updatedByUserId"];
            this.updatedTime = _data["updatedTime"] ? new Date(_data["updatedTime"].toString()) : undefined;
            this.acceptRegistrationPaymentsByClass = _data["acceptRegistrationPaymentsByClass"];
            this.clubType = _data["clubType"];
            this.acronym = _data["acronym"];
            this.club = _data["club"] ? Club1.fromJS(_data["club"]) : undefined;
            this.updatedByUser = _data["updatedByUser"] ? User1.fromJS(_data["updatedByUser"]) : undefined;
            this.clubSuit = _data["clubSuit"] ? ClubSuit.fromJS(_data["clubSuit"]) : undefined;
            if (Array.isArray(_data["clubCategory"])) {
                this.clubCategory = [];
                for (let item of _data["clubCategory"])
                    this.clubCategory.push(ClubCategory.fromJS(item));
            }
            if (Array.isArray(_data["clubClubFlag"])) {
                this.clubClubFlag = [];
                for (let item of _data["clubClubFlag"])
                    this.clubClubFlag.push(ClubClubFlag.fromJS(item));
            }
            if (Array.isArray(_data["clubContact1"])) {
                this.clubContact1 = [];
                for (let item of _data["clubContact1"])
                    this.clubContact1.push(ClubContact1.fromJS(item));
            }
            if (Array.isArray(_data["clubField"])) {
                this.clubField = [];
                for (let item of _data["clubField"])
                    this.clubField.push(ClubField.fromJS(item));
            }
            if (Array.isArray(_data["clubRegion"])) {
                this.clubRegion = [];
                for (let item of _data["clubRegion"])
                    this.clubRegion.push(ClubRegion.fromJS(item));
            }
            if (Array.isArray(_data["clubSettingAgegroupClass"])) {
                this.clubSettingAgegroupClass = [];
                for (let item of _data["clubSettingAgegroupClass"])
                    this.clubSettingAgegroupClass.push(ClubSettingAgegroupClass.fromJS(item));
            }
            if (Array.isArray(_data["clubVisit"])) {
                this.clubVisit = [];
                for (let item of _data["clubVisit"])
                    this.clubVisit.push(ClubVisit.fromJS(item));
            }
            if (Array.isArray(_data["dbfclubMemberFee"])) {
                this.dbfclubMemberFee = [];
                for (let item of _data["dbfclubMemberFee"])
                    this.dbfclubMemberFee.push(DbfclubMemberFee.fromJS(item));
            }
            if (Array.isArray(_data["dbforderItemClubFee"])) {
                this.dbforderItemClubFee = [];
                for (let item of _data["dbforderItemClubFee"])
                    this.dbforderItemClubFee.push(DbforderItemClubFee.fromJS(item));
            }
            if (Array.isArray(_data["dbforderItemLeagueRegistrationTeam"])) {
                this.dbforderItemLeagueRegistrationTeam = [];
                for (let item of _data["dbforderItemLeagueRegistrationTeam"])
                    this.dbforderItemLeagueRegistrationTeam.push(DbforderItemLeagueRegistrationTeam.fromJS(item));
            }
            if (Array.isArray(_data["dbforderItemTmpUnionMember"])) {
                this.dbforderItemTmpUnionMember = [];
                for (let item of _data["dbforderItemTmpUnionMember"])
                    this.dbforderItemTmpUnionMember.push(DbforderItemTmpUnionMember.fromJS(item));
            }
            if (Array.isArray(_data["dbfrankingListPlayerClass"])) {
                this.dbfrankingListPlayerClass = [];
                for (let item of _data["dbfrankingListPlayerClass"])
                    this.dbfrankingListPlayerClass.push(DbfrankingListPlayerClass.fromJS(item));
            }
            if (Array.isArray(_data["dbftmpUnionMember"])) {
                this.dbftmpUnionMember = [];
                for (let item of _data["dbftmpUnionMember"])
                    this.dbftmpUnionMember.push(DbftmpUnionMember.fromJS(item));
            }
            if (Array.isArray(_data["dbfvmrankingYouthPlayer"])) {
                this.dbfvmrankingYouthPlayer = [];
                for (let item of _data["dbfvmrankingYouthPlayer"])
                    this.dbfvmrankingYouthPlayer.push(DbfvmrankingYouthPlayer.fromJS(item));
            }
            if (Array.isArray(_data["leagueGroupTeam"])) {
                this.leagueGroupTeam = [];
                for (let item of _data["leagueGroupTeam"])
                    this.leagueGroupTeam.push(LeagueGroupTeam.fromJS(item));
            }
            if (Array.isArray(_data["leagueRegistration"])) {
                this.leagueRegistration = [];
                for (let item of _data["leagueRegistration"])
                    this.leagueRegistration.push(LeagueRegistration.fromJS(item));
            }
            if (Array.isArray(_data["leagueRegistrationTeam"])) {
                this.leagueRegistrationTeam = [];
                for (let item of _data["leagueRegistrationTeam"])
                    this.leagueRegistrationTeam.push(LeagueRegistrationTeam.fromJS(item));
            }
            if (Array.isArray(_data["leagueTeamClub"])) {
                this.leagueTeamClub = [];
                for (let item of _data["leagueTeamClub"])
                    this.leagueTeamClub.push(LeagueTeamClub.fromJS(item));
            }
            if (Array.isArray(_data["order"])) {
                this.order = [];
                for (let item of _data["order"])
                    this.order.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["orderItemRegistrationClub"])) {
                this.orderItemRegistrationClub = [];
                for (let item of _data["orderItemRegistrationClub"])
                    this.orderItemRegistrationClub.push(OrderItemRegistrationClub.fromJS(item));
            }
            if (Array.isArray(_data["orderItemRegistrationOption"])) {
                this.orderItemRegistrationOption = [];
                for (let item of _data["orderItemRegistrationOption"])
                    this.orderItemRegistrationOption.push(OrderItemRegistrationOption.fromJS(item));
            }
            if (Array.isArray(_data["orderItemRegistrationPlayer"])) {
                this.orderItemRegistrationPlayer = [];
                for (let item of _data["orderItemRegistrationPlayer"])
                    this.orderItemRegistrationPlayer.push(OrderItemRegistrationPlayer.fromJS(item));
            }
            if (Array.isArray(_data["player1"])) {
                this.player1 = [];
                for (let item of _data["player1"])
                    this.player1.push(Player.fromJS(item));
            }
            if (Array.isArray(_data["playerClub"])) {
                this.playerClub = [];
                for (let item of _data["playerClub"])
                    this.playerClub.push(PlayerClub.fromJS(item));
            }
            if (Array.isArray(_data["playerClubContact"])) {
                this.playerClubContact = [];
                for (let item of _data["playerClubContact"])
                    this.playerClubContact.push(PlayerClubContact.fromJS(item));
            }
            if (Array.isArray(_data["playerClubTransferCreatedByClub"])) {
                this.playerClubTransferCreatedByClub = [];
                for (let item of _data["playerClubTransferCreatedByClub"])
                    this.playerClubTransferCreatedByClub.push(PlayerClubTransfer.fromJS(item));
            }
            if (Array.isArray(_data["playerClubTransferNewClub"])) {
                this.playerClubTransferNewClub = [];
                for (let item of _data["playerClubTransferNewClub"])
                    this.playerClubTransferNewClub.push(PlayerClubTransfer.fromJS(item));
            }
            if (Array.isArray(_data["playerClubTransferOldClub"])) {
                this.playerClubTransferOldClub = [];
                for (let item of _data["playerClubTransferOldClub"])
                    this.playerClubTransferOldClub.push(PlayerClubTransfer.fromJS(item));
            }
            if (Array.isArray(_data["playerLicense"])) {
                this.playerLicense = [];
                for (let item of _data["playerLicense"])
                    this.playerLicense.push(PlayerLicense.fromJS(item));
            }
            if (Array.isArray(_data["rankingListExternEvent"])) {
                this.rankingListExternEvent = [];
                for (let item of _data["rankingListExternEvent"])
                    this.rankingListExternEvent.push(RankingListExternEvent.fromJS(item));
            }
            if (Array.isArray(_data["rankingListExternPoint"])) {
                this.rankingListExternPoint = [];
                for (let item of _data["rankingListExternPoint"])
                    this.rankingListExternPoint.push(RankingListExternPoint.fromJS(item));
            }
            if (Array.isArray(_data["rankingListVersionPlayer"])) {
                this.rankingListVersionPlayer = [];
                for (let item of _data["rankingListVersionPlayer"])
                    this.rankingListVersionPlayer.push(RankingListVersionPlayer.fromJS(item));
            }
            if (Array.isArray(_data["region"])) {
                this.region = [];
                for (let item of _data["region"])
                    this.region.push(Region.fromJS(item));
            }
            if (Array.isArray(_data["tournament1"])) {
                this.tournament1 = [];
                for (let item of _data["tournament1"])
                    this.tournament1.push(Tournament1.fromJS(item));
            }
            if (Array.isArray(_data["tournamentEventPlayer"])) {
                this.tournamentEventPlayer = [];
                for (let item of _data["tournamentEventPlayer"])
                    this.tournamentEventPlayer.push(TournamentEventPlayer.fromJS(item));
            }
            if (Array.isArray(_data["tournamentLog"])) {
                this.tournamentLog = [];
                for (let item of _data["tournamentLog"])
                    this.tournamentLog.push(TournamentLog.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRegistrationClub"])) {
                this.tournamentRegistrationClub = [];
                for (let item of _data["tournamentRegistrationClub"])
                    this.tournamentRegistrationClub.push(TournamentRegistrationClub.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRegistrationPlayer"])) {
                this.tournamentRegistrationPlayer = [];
                for (let item of _data["tournamentRegistrationPlayer"])
                    this.tournamentRegistrationPlayer.push(TournamentRegistrationPlayer.fromJS(item));
            }
            if (Array.isArray(_data["userRole1"])) {
                this.userRole1 = [];
                for (let item of _data["userRole1"])
                    this.userRole1.push(UserRole1.fromJS(item));
            }
            if (Array.isArray(_data["venueClub"])) {
                this.venueClub = [];
                for (let item of _data["venueClub"])
                    this.venueClub.push(VenueClub.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Club2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["unionId"] = this.unionId;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["clubNumber"] = this.clubNumber;
        data["active"] = this.active;
        data["password"] = this.password;
        data["acceptRegistrationPayments"] = this.acceptRegistrationPayments;
        data["registrationPaymentsReminderDays"] = this.registrationPaymentsReminderDays;
        data["updatedByUserId"] = this.updatedByUserId;
        data["updatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : undefined;
        data["acceptRegistrationPaymentsByClass"] = this.acceptRegistrationPaymentsByClass;
        data["clubType"] = this.clubType;
        data["acronym"] = this.acronym;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["updatedByUser"] = this.updatedByUser ? this.updatedByUser.toJSON() : undefined;
        data["clubSuit"] = this.clubSuit ? this.clubSuit.toJSON() : undefined;
        if (Array.isArray(this.clubCategory)) {
            data["clubCategory"] = [];
            for (let item of this.clubCategory)
                data["clubCategory"].push(item.toJSON());
        }
        if (Array.isArray(this.clubClubFlag)) {
            data["clubClubFlag"] = [];
            for (let item of this.clubClubFlag)
                data["clubClubFlag"].push(item.toJSON());
        }
        if (Array.isArray(this.clubContact1)) {
            data["clubContact1"] = [];
            for (let item of this.clubContact1)
                data["clubContact1"].push(item.toJSON());
        }
        if (Array.isArray(this.clubField)) {
            data["clubField"] = [];
            for (let item of this.clubField)
                data["clubField"].push(item.toJSON());
        }
        if (Array.isArray(this.clubRegion)) {
            data["clubRegion"] = [];
            for (let item of this.clubRegion)
                data["clubRegion"].push(item.toJSON());
        }
        if (Array.isArray(this.clubSettingAgegroupClass)) {
            data["clubSettingAgegroupClass"] = [];
            for (let item of this.clubSettingAgegroupClass)
                data["clubSettingAgegroupClass"].push(item.toJSON());
        }
        if (Array.isArray(this.clubVisit)) {
            data["clubVisit"] = [];
            for (let item of this.clubVisit)
                data["clubVisit"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfclubMemberFee)) {
            data["dbfclubMemberFee"] = [];
            for (let item of this.dbfclubMemberFee)
                data["dbfclubMemberFee"].push(item.toJSON());
        }
        if (Array.isArray(this.dbforderItemClubFee)) {
            data["dbforderItemClubFee"] = [];
            for (let item of this.dbforderItemClubFee)
                data["dbforderItemClubFee"].push(item.toJSON());
        }
        if (Array.isArray(this.dbforderItemLeagueRegistrationTeam)) {
            data["dbforderItemLeagueRegistrationTeam"] = [];
            for (let item of this.dbforderItemLeagueRegistrationTeam)
                data["dbforderItemLeagueRegistrationTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.dbforderItemTmpUnionMember)) {
            data["dbforderItemTmpUnionMember"] = [];
            for (let item of this.dbforderItemTmpUnionMember)
                data["dbforderItemTmpUnionMember"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfrankingListPlayerClass)) {
            data["dbfrankingListPlayerClass"] = [];
            for (let item of this.dbfrankingListPlayerClass)
                data["dbfrankingListPlayerClass"].push(item.toJSON());
        }
        if (Array.isArray(this.dbftmpUnionMember)) {
            data["dbftmpUnionMember"] = [];
            for (let item of this.dbftmpUnionMember)
                data["dbftmpUnionMember"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfvmrankingYouthPlayer)) {
            data["dbfvmrankingYouthPlayer"] = [];
            for (let item of this.dbfvmrankingYouthPlayer)
                data["dbfvmrankingYouthPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueGroupTeam)) {
            data["leagueGroupTeam"] = [];
            for (let item of this.leagueGroupTeam)
                data["leagueGroupTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueRegistration)) {
            data["leagueRegistration"] = [];
            for (let item of this.leagueRegistration)
                data["leagueRegistration"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueRegistrationTeam)) {
            data["leagueRegistrationTeam"] = [];
            for (let item of this.leagueRegistrationTeam)
                data["leagueRegistrationTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueTeamClub)) {
            data["leagueTeamClub"] = [];
            for (let item of this.leagueTeamClub)
                data["leagueTeamClub"].push(item.toJSON());
        }
        if (Array.isArray(this.order)) {
            data["order"] = [];
            for (let item of this.order)
                data["order"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemRegistrationClub)) {
            data["orderItemRegistrationClub"] = [];
            for (let item of this.orderItemRegistrationClub)
                data["orderItemRegistrationClub"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemRegistrationOption)) {
            data["orderItemRegistrationOption"] = [];
            for (let item of this.orderItemRegistrationOption)
                data["orderItemRegistrationOption"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemRegistrationPlayer)) {
            data["orderItemRegistrationPlayer"] = [];
            for (let item of this.orderItemRegistrationPlayer)
                data["orderItemRegistrationPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.player1)) {
            data["player1"] = [];
            for (let item of this.player1)
                data["player1"].push(item.toJSON());
        }
        if (Array.isArray(this.playerClub)) {
            data["playerClub"] = [];
            for (let item of this.playerClub)
                data["playerClub"].push(item.toJSON());
        }
        if (Array.isArray(this.playerClubContact)) {
            data["playerClubContact"] = [];
            for (let item of this.playerClubContact)
                data["playerClubContact"].push(item.toJSON());
        }
        if (Array.isArray(this.playerClubTransferCreatedByClub)) {
            data["playerClubTransferCreatedByClub"] = [];
            for (let item of this.playerClubTransferCreatedByClub)
                data["playerClubTransferCreatedByClub"].push(item.toJSON());
        }
        if (Array.isArray(this.playerClubTransferNewClub)) {
            data["playerClubTransferNewClub"] = [];
            for (let item of this.playerClubTransferNewClub)
                data["playerClubTransferNewClub"].push(item.toJSON());
        }
        if (Array.isArray(this.playerClubTransferOldClub)) {
            data["playerClubTransferOldClub"] = [];
            for (let item of this.playerClubTransferOldClub)
                data["playerClubTransferOldClub"].push(item.toJSON());
        }
        if (Array.isArray(this.playerLicense)) {
            data["playerLicense"] = [];
            for (let item of this.playerLicense)
                data["playerLicense"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListExternEvent)) {
            data["rankingListExternEvent"] = [];
            for (let item of this.rankingListExternEvent)
                data["rankingListExternEvent"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListExternPoint)) {
            data["rankingListExternPoint"] = [];
            for (let item of this.rankingListExternPoint)
                data["rankingListExternPoint"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListVersionPlayer)) {
            data["rankingListVersionPlayer"] = [];
            for (let item of this.rankingListVersionPlayer)
                data["rankingListVersionPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.region)) {
            data["region"] = [];
            for (let item of this.region)
                data["region"].push(item.toJSON());
        }
        if (Array.isArray(this.tournament1)) {
            data["tournament1"] = [];
            for (let item of this.tournament1)
                data["tournament1"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentEventPlayer)) {
            data["tournamentEventPlayer"] = [];
            for (let item of this.tournamentEventPlayer)
                data["tournamentEventPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentLog)) {
            data["tournamentLog"] = [];
            for (let item of this.tournamentLog)
                data["tournamentLog"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRegistrationClub)) {
            data["tournamentRegistrationClub"] = [];
            for (let item of this.tournamentRegistrationClub)
                data["tournamentRegistrationClub"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRegistrationPlayer)) {
            data["tournamentRegistrationPlayer"] = [];
            for (let item of this.tournamentRegistrationPlayer)
                data["tournamentRegistrationPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.userRole1)) {
            data["userRole1"] = [];
            for (let item of this.userRole1)
                data["userRole1"].push(item.toJSON());
        }
        if (Array.isArray(this.venueClub)) {
            data["venueClub"] = [];
            for (let item of this.venueClub)
                data["venueClub"].push(item.toJSON());
        }
        return data;
    }
}
export class Club1 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.parentClubId = _data["parentClubId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.countryCode = _data["countryCode"];
            this.url = _data["url"];
            this.clubType = _data["clubType"];
            this.presentation = _data["presentation"];
            this.closedClub = _data["closedClub"];
            this.active = _data["active"];
            this.clubApproval = _data["clubApproval"];
            this.isPrivate = _data["isPrivate"];
            this.clubImage = _data["clubImage"];
            this.isWwwpublic = _data["isWwwpublic"];
            this.isAutomatic = _data["isAutomatic"];
            this.membersBornFrom = _data["membersBornFrom"] ? new Date(_data["membersBornFrom"].toString()) : undefined;
            this.membersBornTo = _data["membersBornTo"] ? new Date(_data["membersBornTo"].toString()) : undefined;
            this.membersGender = _data["membersGender"];
            this.createPortalId = _data["createPortalId"];
            this.clubBanners = _data["clubBanners"] ? new Date(_data["clubBanners"].toString()) : undefined;
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined;
            this.lattitude = _data["lattitude"];
            this.longitude = _data["longitude"];
            this.cvr = _data["cvr"];
            this.bankName = _data["bankName"];
            this.phone = _data["phone"];
            this.createPortal = _data["createPortal"] ? Portal.fromJS(_data["createPortal"]) : undefined;
            this.parentClub = _data["parentClub"] ? Club1.fromJS(_data["parentClub"]) : undefined;
            this.club2 = _data["club2"] ? Club2.fromJS(_data["club2"]) : undefined;
            if (Array.isArray(_data["clubPlayerRelation"])) {
                this.clubPlayerRelation = [];
                for (let item of _data["clubPlayerRelation"])
                    this.clubPlayerRelation.push(ClubPlayerRelation.fromJS(item));
            }
            if (Array.isArray(_data["clubPortal"])) {
                this.clubPortal = [];
                for (let item of _data["clubPortal"])
                    this.clubPortal.push(ClubPortal.fromJS(item));
            }
            if (Array.isArray(_data["clubUserRelation"])) {
                this.clubUserRelation = [];
                for (let item of _data["clubUserRelation"])
                    this.clubUserRelation.push(ClubUserRelation.fromJS(item));
            }
            if (Array.isArray(_data["inboxRelationClub"])) {
                this.inboxRelationClub = [];
                for (let item of _data["inboxRelationClub"])
                    this.inboxRelationClub.push(Inbox.fromJS(item));
            }
            if (Array.isArray(_data["inboxRelationClubId2Navigation"])) {
                this.inboxRelationClubId2Navigation = [];
                for (let item of _data["inboxRelationClubId2Navigation"])
                    this.inboxRelationClubId2Navigation.push(Inbox.fromJS(item));
            }
            if (Array.isArray(_data["inverseParentClub"])) {
                this.inverseParentClub = [];
                for (let item of _data["inverseParentClub"])
                    this.inverseParentClub.push(Club1.fromJS(item));
            }
            if (Array.isArray(_data["union"])) {
                this.union = [];
                for (let item of _data["union"])
                    this.union.push(Union.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Club1();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["parentClubId"] = this.parentClubId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["street"] = this.street;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["url"] = this.url;
        data["clubType"] = this.clubType;
        data["presentation"] = this.presentation;
        data["closedClub"] = this.closedClub;
        data["active"] = this.active;
        data["clubApproval"] = this.clubApproval;
        data["isPrivate"] = this.isPrivate;
        data["clubImage"] = this.clubImage;
        data["isWwwpublic"] = this.isWwwpublic;
        data["isAutomatic"] = this.isAutomatic;
        data["membersBornFrom"] = this.membersBornFrom ? this.membersBornFrom.toISOString() : undefined;
        data["membersBornTo"] = this.membersBornTo ? this.membersBornTo.toISOString() : undefined;
        data["membersGender"] = this.membersGender;
        data["createPortalId"] = this.createPortalId;
        data["clubBanners"] = this.clubBanners ? this.clubBanners.toISOString() : undefined;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined;
        data["lattitude"] = this.lattitude;
        data["longitude"] = this.longitude;
        data["cvr"] = this.cvr;
        data["bankName"] = this.bankName;
        data["phone"] = this.phone;
        data["createPortal"] = this.createPortal ? this.createPortal.toJSON() : undefined;
        data["parentClub"] = this.parentClub ? this.parentClub.toJSON() : undefined;
        data["club2"] = this.club2 ? this.club2.toJSON() : undefined;
        if (Array.isArray(this.clubPlayerRelation)) {
            data["clubPlayerRelation"] = [];
            for (let item of this.clubPlayerRelation)
                data["clubPlayerRelation"].push(item.toJSON());
        }
        if (Array.isArray(this.clubPortal)) {
            data["clubPortal"] = [];
            for (let item of this.clubPortal)
                data["clubPortal"].push(item.toJSON());
        }
        if (Array.isArray(this.clubUserRelation)) {
            data["clubUserRelation"] = [];
            for (let item of this.clubUserRelation)
                data["clubUserRelation"].push(item.toJSON());
        }
        if (Array.isArray(this.inboxRelationClub)) {
            data["inboxRelationClub"] = [];
            for (let item of this.inboxRelationClub)
                data["inboxRelationClub"].push(item.toJSON());
        }
        if (Array.isArray(this.inboxRelationClubId2Navigation)) {
            data["inboxRelationClubId2Navigation"] = [];
            for (let item of this.inboxRelationClubId2Navigation)
                data["inboxRelationClubId2Navigation"].push(item.toJSON());
        }
        if (Array.isArray(this.inverseParentClub)) {
            data["inverseParentClub"] = [];
            for (let item of this.inverseParentClub)
                data["inverseParentClub"].push(item.toJSON());
        }
        if (Array.isArray(this.union)) {
            data["union"] = [];
            for (let item of this.union)
                data["union"].push(item.toJSON());
        }
        return data;
    }
}
export class Portal {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.portalId = _data["portalId"];
            this.name = _data["name"];
            this.mainUrl = _data["mainUrl"];
            this.emailSender = _data["emailSender"];
            this.language = _data["language"];
            this.systemName = _data["systemName"];
            this.contactEmail = _data["contactEmail"];
            this.ownerClubId = _data["ownerClubId"];
            this.googleMaps = _data["googleMaps"];
            if (Array.isArray(_data["club1"])) {
                this.club1 = [];
                for (let item of _data["club1"])
                    this.club1.push(Club1.fromJS(item));
            }
            if (Array.isArray(_data["clubPortal"])) {
                this.clubPortal = [];
                for (let item of _data["clubPortal"])
                    this.clubPortal.push(ClubPortal.fromJS(item));
            }
            if (Array.isArray(_data["email"])) {
                this.email = [];
                for (let item of _data["email"])
                    this.email.push(Email.fromJS(item));
            }
            if (Array.isArray(_data["portalDomain"])) {
                this.portalDomain = [];
                for (let item of _data["portalDomain"])
                    this.portalDomain.push(PortalDomain.fromJS(item));
            }
            if (Array.isArray(_data["saemailLog"])) {
                this.saemailLog = [];
                for (let item of _data["saemailLog"])
                    this.saemailLog.push(SaemailLog.fromJS(item));
            }
            if (Array.isArray(_data["union"])) {
                this.union = [];
                for (let item of _data["union"])
                    this.union.push(Union.fromJS(item));
            }
            if (Array.isArray(_data["user1"])) {
                this.user1 = [];
                for (let item of _data["user1"])
                    this.user1.push(User1.fromJS(item));
            }
            if (Array.isArray(_data["userPortal"])) {
                this.userPortal = [];
                for (let item of _data["userPortal"])
                    this.userPortal.push(UserPortal.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Portal();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["portalId"] = this.portalId;
        data["name"] = this.name;
        data["mainUrl"] = this.mainUrl;
        data["emailSender"] = this.emailSender;
        data["language"] = this.language;
        data["systemName"] = this.systemName;
        data["contactEmail"] = this.contactEmail;
        data["ownerClubId"] = this.ownerClubId;
        data["googleMaps"] = this.googleMaps;
        if (Array.isArray(this.club1)) {
            data["club1"] = [];
            for (let item of this.club1)
                data["club1"].push(item.toJSON());
        }
        if (Array.isArray(this.clubPortal)) {
            data["clubPortal"] = [];
            for (let item of this.clubPortal)
                data["clubPortal"].push(item.toJSON());
        }
        if (Array.isArray(this.email)) {
            data["email"] = [];
            for (let item of this.email)
                data["email"].push(item.toJSON());
        }
        if (Array.isArray(this.portalDomain)) {
            data["portalDomain"] = [];
            for (let item of this.portalDomain)
                data["portalDomain"].push(item.toJSON());
        }
        if (Array.isArray(this.saemailLog)) {
            data["saemailLog"] = [];
            for (let item of this.saemailLog)
                data["saemailLog"].push(item.toJSON());
        }
        if (Array.isArray(this.union)) {
            data["union"] = [];
            for (let item of this.union)
                data["union"].push(item.toJSON());
        }
        if (Array.isArray(this.user1)) {
            data["user1"] = [];
            for (let item of this.user1)
                data["user1"].push(item.toJSON());
        }
        if (Array.isArray(this.userPortal)) {
            data["userPortal"] = [];
            for (let item of this.userPortal)
                data["userPortal"].push(item.toJSON());
        }
        return data;
    }
}
export class ClubPortal {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.portalId = _data["portalId"];
            this.club = _data["club"] ? Club1.fromJS(_data["club"]) : undefined;
            this.portal = _data["portal"] ? Portal.fromJS(_data["portal"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClubPortal();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["portalId"] = this.portalId;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["portal"] = this.portal ? this.portal.toJSON() : undefined;
        return data;
    }
}
export class Email {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.emailId = _data["emailId"];
            this.toUserId = _data["toUserId"];
            this.messageId = _data["messageId"];
            this.email1 = _data["email1"];
            this.portalId = _data["portalId"];
            this.emailSenderDetail = _data["emailSenderDetail"];
            this.mailIdCc = _data["mailIdCc"];
            this.emailSenderName = _data["emailSenderName"];
            this.message = _data["message"] ? Message.fromJS(_data["message"]) : undefined;
            this.portal = _data["portal"] ? Portal.fromJS(_data["portal"]) : undefined;
            this.toUser = _data["toUser"] ? User1.fromJS(_data["toUser"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Email();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["emailId"] = this.emailId;
        data["toUserId"] = this.toUserId;
        data["messageId"] = this.messageId;
        data["email1"] = this.email1;
        data["portalId"] = this.portalId;
        data["emailSenderDetail"] = this.emailSenderDetail;
        data["mailIdCc"] = this.mailIdCc;
        data["emailSenderName"] = this.emailSenderName;
        data["message"] = this.message ? this.message.toJSON() : undefined;
        data["portal"] = this.portal ? this.portal.toJSON() : undefined;
        data["toUser"] = this.toUser ? this.toUser.toJSON() : undefined;
        return data;
    }
}
export class Message {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.sentByUserId = _data["sentByUserId"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.sentTime = _data["sentTime"] ? new Date(_data["sentTime"].toString()) : undefined;
            this.messageType = _data["messageType"];
            this.prevMessageId = _data["prevMessageId"];
            this.deleted = _data["deleted"];
            this.prevMessage = _data["prevMessage"] ? Message.fromJS(_data["prevMessage"]) : undefined;
            this.sentByUser = _data["sentByUser"] ? User1.fromJS(_data["sentByUser"]) : undefined;
            if (Array.isArray(_data["email"])) {
                this.email = [];
                for (let item of _data["email"])
                    this.email.push(Email.fromJS(item));
            }
            if (Array.isArray(_data["inbox"])) {
                this.inbox = [];
                for (let item of _data["inbox"])
                    this.inbox.push(Inbox.fromJS(item));
            }
            if (Array.isArray(_data["inversePrevMessage"])) {
                this.inversePrevMessage = [];
                for (let item of _data["inversePrevMessage"])
                    this.inversePrevMessage.push(Message.fromJS(item));
            }
            if (Array.isArray(_data["saemailLog"])) {
                this.saemailLog = [];
                for (let item of _data["saemailLog"])
                    this.saemailLog.push(SaemailLog.fromJS(item));
            }
            if (Array.isArray(_data["tournamentMessage"])) {
                this.tournamentMessage = [];
                for (let item of _data["tournamentMessage"])
                    this.tournamentMessage.push(TournamentMessage.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["sentByUserId"] = this.sentByUserId;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["sentTime"] = this.sentTime ? this.sentTime.toISOString() : undefined;
        data["messageType"] = this.messageType;
        data["prevMessageId"] = this.prevMessageId;
        data["deleted"] = this.deleted;
        data["prevMessage"] = this.prevMessage ? this.prevMessage.toJSON() : undefined;
        data["sentByUser"] = this.sentByUser ? this.sentByUser.toJSON() : undefined;
        if (Array.isArray(this.email)) {
            data["email"] = [];
            for (let item of this.email)
                data["email"].push(item.toJSON());
        }
        if (Array.isArray(this.inbox)) {
            data["inbox"] = [];
            for (let item of this.inbox)
                data["inbox"].push(item.toJSON());
        }
        if (Array.isArray(this.inversePrevMessage)) {
            data["inversePrevMessage"] = [];
            for (let item of this.inversePrevMessage)
                data["inversePrevMessage"].push(item.toJSON());
        }
        if (Array.isArray(this.saemailLog)) {
            data["saemailLog"] = [];
            for (let item of this.saemailLog)
                data["saemailLog"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentMessage)) {
            data["tournamentMessage"] = [];
            for (let item of this.tournamentMessage)
                data["tournamentMessage"].push(item.toJSON());
        }
        return data;
    }
}
export class User1 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.language = _data["language"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : undefined;
            this.createIp = _data["createIp"];
            this.updateTime = _data["updateTime"] ? new Date(_data["updateTime"].toString()) : undefined;
            this.updateIp = _data["updateIp"];
            this.loginTime = _data["loginTime"] ? new Date(_data["loginTime"].toString()) : undefined;
            this.loginIp = _data["loginIp"];
            this.active = _data["active"];
            this.parentUserId = _data["parentUserId"];
            this.createPortalId = _data["createPortalId"];
            this.coach = _data["coach"];
            this.premiumDate = _data["premiumDate"] ? new Date(_data["premiumDate"].toString()) : undefined;
            this.createPortal = _data["createPortal"] ? Portal.fromJS(_data["createPortal"]) : undefined;
            this.userProfile = _data["userProfile"] ? UserProfile.fromJS(_data["userProfile"]) : undefined;
            if (Array.isArray(_data["club2"])) {
                this.club2 = [];
                for (let item of _data["club2"])
                    this.club2.push(Club2.fromJS(item));
            }
            if (Array.isArray(_data["clubUserRelationFromUser"])) {
                this.clubUserRelationFromUser = [];
                for (let item of _data["clubUserRelationFromUser"])
                    this.clubUserRelationFromUser.push(ClubUserRelation.fromJS(item));
            }
            if (Array.isArray(_data["clubUserRelationUser"])) {
                this.clubUserRelationUser = [];
                for (let item of _data["clubUserRelationUser"])
                    this.clubUserRelationUser.push(ClubUserRelation.fromJS(item));
            }
            if (Array.isArray(_data["clubVisit"])) {
                this.clubVisit = [];
                for (let item of _data["clubVisit"])
                    this.clubVisit.push(ClubVisit.fromJS(item));
            }
            if (Array.isArray(_data["dbfplayerRankingReplacementAdminUser"])) {
                this.dbfplayerRankingReplacementAdminUser = [];
                for (let item of _data["dbfplayerRankingReplacementAdminUser"])
                    this.dbfplayerRankingReplacementAdminUser.push(DbfplayerRankingReplacement.fromJS(item));
            }
            if (Array.isArray(_data["dbfplayerRankingReplacementClubUser"])) {
                this.dbfplayerRankingReplacementClubUser = [];
                for (let item of _data["dbfplayerRankingReplacementClubUser"])
                    this.dbfplayerRankingReplacementClubUser.push(DbfplayerRankingReplacement.fromJS(item));
            }
            if (Array.isArray(_data["emailNavigation"])) {
                this.emailNavigation = [];
                for (let item of _data["emailNavigation"])
                    this.emailNavigation.push(Email.fromJS(item));
            }
            if (Array.isArray(_data["inbox"])) {
                this.inbox = [];
                for (let item of _data["inbox"])
                    this.inbox.push(Inbox.fromJS(item));
            }
            if (Array.isArray(_data["leagueDivision"])) {
                this.leagueDivision = [];
                for (let item of _data["leagueDivision"])
                    this.leagueDivision.push(LeagueDivision.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatch1MatchTimeUpdatedByUser"])) {
                this.leagueMatch1MatchTimeUpdatedByUser = [];
                for (let item of _data["leagueMatch1MatchTimeUpdatedByUser"])
                    this.leagueMatch1MatchTimeUpdatedByUser.push(LeagueMatch.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatch1ResultUpdatedByUser"])) {
                this.leagueMatch1ResultUpdatedByUser = [];
                for (let item of _data["leagueMatch1ResultUpdatedByUser"])
                    this.leagueMatch1ResultUpdatedByUser.push(LeagueMatch.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatch1Team2UpdatedByUser"])) {
                this.leagueMatch1Team2UpdatedByUser = [];
                for (let item of _data["leagueMatch1Team2UpdatedByUser"])
                    this.leagueMatch1Team2UpdatedByUser.push(LeagueMatch.fromJS(item));
            }
            if (Array.isArray(_data["leagueRegistration"])) {
                this.leagueRegistration = [];
                for (let item of _data["leagueRegistration"])
                    this.leagueRegistration.push(LeagueRegistration.fromJS(item));
            }
            if (Array.isArray(_data["leagueRegistrationTeam"])) {
                this.leagueRegistrationTeam = [];
                for (let item of _data["leagueRegistrationTeam"])
                    this.leagueRegistrationTeam.push(LeagueRegistrationTeam.fromJS(item));
            }
            if (Array.isArray(_data["leagueSchema"])) {
                this.leagueSchema = [];
                for (let item of _data["leagueSchema"])
                    this.leagueSchema.push(LeagueSchema.fromJS(item));
            }
            if (Array.isArray(_data["leagueTeam"])) {
                this.leagueTeam = [];
                for (let item of _data["leagueTeam"])
                    this.leagueTeam.push(LeagueTeam.fromJS(item));
            }
            if (Array.isArray(_data["liveScoreSubscriber"])) {
                this.liveScoreSubscriber = [];
                for (let item of _data["liveScoreSubscriber"])
                    this.liveScoreSubscriber.push(LiveScoreSubscriber.fromJS(item));
            }
            if (Array.isArray(_data["liveScoreUser"])) {
                this.liveScoreUser = [];
                for (let item of _data["liveScoreUser"])
                    this.liveScoreUser.push(LiveScoreUser.fromJS(item));
            }
            if (Array.isArray(_data["message"])) {
                this.message = [];
                for (let item of _data["message"])
                    this.message.push(Message.fromJS(item));
            }
            if (Array.isArray(_data["orderRefundUser"])) {
                this.orderRefundUser = [];
                for (let item of _data["orderRefundUser"])
                    this.orderRefundUser.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["orderUser"])) {
                this.orderUser = [];
                for (let item of _data["orderUser"])
                    this.orderUser.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["player1CreatedByUser"])) {
                this.player1CreatedByUser = [];
                for (let item of _data["player1CreatedByUser"])
                    this.player1CreatedByUser.push(Player.fromJS(item));
            }
            if (Array.isArray(_data["player1UpdatedByUser"])) {
                this.player1UpdatedByUser = [];
                for (let item of _data["player1UpdatedByUser"])
                    this.player1UpdatedByUser.push(Player.fromJS(item));
            }
            if (Array.isArray(_data["player1ValidatedByUser"])) {
                this.player1ValidatedByUser = [];
                for (let item of _data["player1ValidatedByUser"])
                    this.player1ValidatedByUser.push(Player.fromJS(item));
            }
            if (Array.isArray(_data["playerClubTransferAcceptedByUser"])) {
                this.playerClubTransferAcceptedByUser = [];
                for (let item of _data["playerClubTransferAcceptedByUser"])
                    this.playerClubTransferAcceptedByUser.push(PlayerClubTransfer.fromJS(item));
            }
            if (Array.isArray(_data["playerClubTransferAcceptedNewByUser"])) {
                this.playerClubTransferAcceptedNewByUser = [];
                for (let item of _data["playerClubTransferAcceptedNewByUser"])
                    this.playerClubTransferAcceptedNewByUser.push(PlayerClubTransfer.fromJS(item));
            }
            if (Array.isArray(_data["playerClubTransferAcceptedOldByUser"])) {
                this.playerClubTransferAcceptedOldByUser = [];
                for (let item of _data["playerClubTransferAcceptedOldByUser"])
                    this.playerClubTransferAcceptedOldByUser.push(PlayerClubTransfer.fromJS(item));
            }
            if (Array.isArray(_data["playerClubTransferCreatedByUser"])) {
                this.playerClubTransferCreatedByUser = [];
                for (let item of _data["playerClubTransferCreatedByUser"])
                    this.playerClubTransferCreatedByUser.push(PlayerClubTransfer.fromJS(item));
            }
            if (Array.isArray(_data["playerUser1"])) {
                this.playerUser1 = [];
                for (let item of _data["playerUser1"])
                    this.playerUser1.push(PlayerUser1.fromJS(item));
            }
            if (Array.isArray(_data["rankingListExternEventUpdatedAdminUser"])) {
                this.rankingListExternEventUpdatedAdminUser = [];
                for (let item of _data["rankingListExternEventUpdatedAdminUser"])
                    this.rankingListExternEventUpdatedAdminUser.push(RankingListExternEvent.fromJS(item));
            }
            if (Array.isArray(_data["rankingListExternEventUpdatedUser"])) {
                this.rankingListExternEventUpdatedUser = [];
                for (let item of _data["rankingListExternEventUpdatedUser"])
                    this.rankingListExternEventUpdatedUser.push(RankingListExternEvent.fromJS(item));
            }
            if (Array.isArray(_data["rankingListPlayer"])) {
                this.rankingListPlayer = [];
                for (let item of _data["rankingListPlayer"])
                    this.rankingListPlayer.push(RankingListPlayer.fromJS(item));
            }
            if (Array.isArray(_data["tournament1"])) {
                this.tournament1 = [];
                for (let item of _data["tournament1"])
                    this.tournament1.push(Tournament1.fromJS(item));
            }
            if (Array.isArray(_data["tournamentApplicationClubUser"])) {
                this.tournamentApplicationClubUser = [];
                for (let item of _data["tournamentApplicationClubUser"])
                    this.tournamentApplicationClubUser.push(TournamentApplication.fromJS(item));
            }
            if (Array.isArray(_data["tournamentApplicationRegionUser"])) {
                this.tournamentApplicationRegionUser = [];
                for (let item of _data["tournamentApplicationRegionUser"])
                    this.tournamentApplicationRegionUser.push(TournamentApplication.fromJS(item));
            }
            if (Array.isArray(_data["tournamentApplicationUpdateByUser"])) {
                this.tournamentApplicationUpdateByUser = [];
                for (let item of _data["tournamentApplicationUpdateByUser"])
                    this.tournamentApplicationUpdateByUser.push(TournamentApplication.fromJS(item));
            }
            if (Array.isArray(_data["tournamentEventPlayer"])) {
                this.tournamentEventPlayer = [];
                for (let item of _data["tournamentEventPlayer"])
                    this.tournamentEventPlayer.push(TournamentEventPlayer.fromJS(item));
            }
            if (Array.isArray(_data["tournamentLateRegistrationUser"])) {
                this.tournamentLateRegistrationUser = [];
                for (let item of _data["tournamentLateRegistrationUser"])
                    this.tournamentLateRegistrationUser.push(TournamentLateRegistrationUser.fromJS(item));
            }
            if (Array.isArray(_data["tournamentLog"])) {
                this.tournamentLog = [];
                for (let item of _data["tournamentLog"])
                    this.tournamentLog.push(TournamentLog.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRegistration"])) {
                this.tournamentRegistration = [];
                for (let item of _data["tournamentRegistration"])
                    this.tournamentRegistration.push(TournamentRegistration.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRegistrationPlayer"])) {
                this.tournamentRegistrationPlayer = [];
                for (let item of _data["tournamentRegistrationPlayer"])
                    this.tournamentRegistrationPlayer.push(TournamentRegistrationPlayer.fromJS(item));
            }
            if (Array.isArray(_data["uploadedFiles"])) {
                this.uploadedFiles = [];
                for (let item of _data["uploadedFiles"])
                    this.uploadedFiles.push(UploadedFiles.fromJS(item));
            }
            if (Array.isArray(_data["userMailSent"])) {
                this.userMailSent = [];
                for (let item of _data["userMailSent"])
                    this.userMailSent.push(UserMailSent.fromJS(item));
            }
            if (Array.isArray(_data["userMailType"])) {
                this.userMailType = [];
                for (let item of _data["userMailType"])
                    this.userMailType.push(UserMailType.fromJS(item));
            }
            if (Array.isArray(_data["userPortal"])) {
                this.userPortal = [];
                for (let item of _data["userPortal"])
                    this.userPortal.push(UserPortal.fromJS(item));
            }
            if (Array.isArray(_data["userRole1UpdatedByUser"])) {
                this.userRole1UpdatedByUser = [];
                for (let item of _data["userRole1UpdatedByUser"])
                    this.userRole1UpdatedByUser.push(UserRole1.fromJS(item));
            }
            if (Array.isArray(_data["userRole1User"])) {
                this.userRole1User = [];
                for (let item of _data["userRole1User"])
                    this.userRole1User.push(UserRole1.fromJS(item));
            }
            if (Array.isArray(_data["venue"])) {
                this.venue = [];
                for (let item of _data["venue"])
                    this.venue.push(Venue.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new User1();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["password"] = this.password;
        data["language"] = this.language;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : undefined;
        data["createIp"] = this.createIp;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : undefined;
        data["updateIp"] = this.updateIp;
        data["loginTime"] = this.loginTime ? this.loginTime.toISOString() : undefined;
        data["loginIp"] = this.loginIp;
        data["active"] = this.active;
        data["parentUserId"] = this.parentUserId;
        data["createPortalId"] = this.createPortalId;
        data["coach"] = this.coach;
        data["premiumDate"] = this.premiumDate ? this.premiumDate.toISOString() : undefined;
        data["createPortal"] = this.createPortal ? this.createPortal.toJSON() : undefined;
        data["userProfile"] = this.userProfile ? this.userProfile.toJSON() : undefined;
        if (Array.isArray(this.club2)) {
            data["club2"] = [];
            for (let item of this.club2)
                data["club2"].push(item.toJSON());
        }
        if (Array.isArray(this.clubUserRelationFromUser)) {
            data["clubUserRelationFromUser"] = [];
            for (let item of this.clubUserRelationFromUser)
                data["clubUserRelationFromUser"].push(item.toJSON());
        }
        if (Array.isArray(this.clubUserRelationUser)) {
            data["clubUserRelationUser"] = [];
            for (let item of this.clubUserRelationUser)
                data["clubUserRelationUser"].push(item.toJSON());
        }
        if (Array.isArray(this.clubVisit)) {
            data["clubVisit"] = [];
            for (let item of this.clubVisit)
                data["clubVisit"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfplayerRankingReplacementAdminUser)) {
            data["dbfplayerRankingReplacementAdminUser"] = [];
            for (let item of this.dbfplayerRankingReplacementAdminUser)
                data["dbfplayerRankingReplacementAdminUser"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfplayerRankingReplacementClubUser)) {
            data["dbfplayerRankingReplacementClubUser"] = [];
            for (let item of this.dbfplayerRankingReplacementClubUser)
                data["dbfplayerRankingReplacementClubUser"].push(item.toJSON());
        }
        if (Array.isArray(this.emailNavigation)) {
            data["emailNavigation"] = [];
            for (let item of this.emailNavigation)
                data["emailNavigation"].push(item.toJSON());
        }
        if (Array.isArray(this.inbox)) {
            data["inbox"] = [];
            for (let item of this.inbox)
                data["inbox"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueDivision)) {
            data["leagueDivision"] = [];
            for (let item of this.leagueDivision)
                data["leagueDivision"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatch1MatchTimeUpdatedByUser)) {
            data["leagueMatch1MatchTimeUpdatedByUser"] = [];
            for (let item of this.leagueMatch1MatchTimeUpdatedByUser)
                data["leagueMatch1MatchTimeUpdatedByUser"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatch1ResultUpdatedByUser)) {
            data["leagueMatch1ResultUpdatedByUser"] = [];
            for (let item of this.leagueMatch1ResultUpdatedByUser)
                data["leagueMatch1ResultUpdatedByUser"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatch1Team2UpdatedByUser)) {
            data["leagueMatch1Team2UpdatedByUser"] = [];
            for (let item of this.leagueMatch1Team2UpdatedByUser)
                data["leagueMatch1Team2UpdatedByUser"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueRegistration)) {
            data["leagueRegistration"] = [];
            for (let item of this.leagueRegistration)
                data["leagueRegistration"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueRegistrationTeam)) {
            data["leagueRegistrationTeam"] = [];
            for (let item of this.leagueRegistrationTeam)
                data["leagueRegistrationTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueSchema)) {
            data["leagueSchema"] = [];
            for (let item of this.leagueSchema)
                data["leagueSchema"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueTeam)) {
            data["leagueTeam"] = [];
            for (let item of this.leagueTeam)
                data["leagueTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.liveScoreSubscriber)) {
            data["liveScoreSubscriber"] = [];
            for (let item of this.liveScoreSubscriber)
                data["liveScoreSubscriber"].push(item.toJSON());
        }
        if (Array.isArray(this.liveScoreUser)) {
            data["liveScoreUser"] = [];
            for (let item of this.liveScoreUser)
                data["liveScoreUser"].push(item.toJSON());
        }
        if (Array.isArray(this.message)) {
            data["message"] = [];
            for (let item of this.message)
                data["message"].push(item.toJSON());
        }
        if (Array.isArray(this.orderRefundUser)) {
            data["orderRefundUser"] = [];
            for (let item of this.orderRefundUser)
                data["orderRefundUser"].push(item.toJSON());
        }
        if (Array.isArray(this.orderUser)) {
            data["orderUser"] = [];
            for (let item of this.orderUser)
                data["orderUser"].push(item.toJSON());
        }
        if (Array.isArray(this.player1CreatedByUser)) {
            data["player1CreatedByUser"] = [];
            for (let item of this.player1CreatedByUser)
                data["player1CreatedByUser"].push(item.toJSON());
        }
        if (Array.isArray(this.player1UpdatedByUser)) {
            data["player1UpdatedByUser"] = [];
            for (let item of this.player1UpdatedByUser)
                data["player1UpdatedByUser"].push(item.toJSON());
        }
        if (Array.isArray(this.player1ValidatedByUser)) {
            data["player1ValidatedByUser"] = [];
            for (let item of this.player1ValidatedByUser)
                data["player1ValidatedByUser"].push(item.toJSON());
        }
        if (Array.isArray(this.playerClubTransferAcceptedByUser)) {
            data["playerClubTransferAcceptedByUser"] = [];
            for (let item of this.playerClubTransferAcceptedByUser)
                data["playerClubTransferAcceptedByUser"].push(item.toJSON());
        }
        if (Array.isArray(this.playerClubTransferAcceptedNewByUser)) {
            data["playerClubTransferAcceptedNewByUser"] = [];
            for (let item of this.playerClubTransferAcceptedNewByUser)
                data["playerClubTransferAcceptedNewByUser"].push(item.toJSON());
        }
        if (Array.isArray(this.playerClubTransferAcceptedOldByUser)) {
            data["playerClubTransferAcceptedOldByUser"] = [];
            for (let item of this.playerClubTransferAcceptedOldByUser)
                data["playerClubTransferAcceptedOldByUser"].push(item.toJSON());
        }
        if (Array.isArray(this.playerClubTransferCreatedByUser)) {
            data["playerClubTransferCreatedByUser"] = [];
            for (let item of this.playerClubTransferCreatedByUser)
                data["playerClubTransferCreatedByUser"].push(item.toJSON());
        }
        if (Array.isArray(this.playerUser1)) {
            data["playerUser1"] = [];
            for (let item of this.playerUser1)
                data["playerUser1"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListExternEventUpdatedAdminUser)) {
            data["rankingListExternEventUpdatedAdminUser"] = [];
            for (let item of this.rankingListExternEventUpdatedAdminUser)
                data["rankingListExternEventUpdatedAdminUser"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListExternEventUpdatedUser)) {
            data["rankingListExternEventUpdatedUser"] = [];
            for (let item of this.rankingListExternEventUpdatedUser)
                data["rankingListExternEventUpdatedUser"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListPlayer)) {
            data["rankingListPlayer"] = [];
            for (let item of this.rankingListPlayer)
                data["rankingListPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.tournament1)) {
            data["tournament1"] = [];
            for (let item of this.tournament1)
                data["tournament1"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentApplicationClubUser)) {
            data["tournamentApplicationClubUser"] = [];
            for (let item of this.tournamentApplicationClubUser)
                data["tournamentApplicationClubUser"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentApplicationRegionUser)) {
            data["tournamentApplicationRegionUser"] = [];
            for (let item of this.tournamentApplicationRegionUser)
                data["tournamentApplicationRegionUser"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentApplicationUpdateByUser)) {
            data["tournamentApplicationUpdateByUser"] = [];
            for (let item of this.tournamentApplicationUpdateByUser)
                data["tournamentApplicationUpdateByUser"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentEventPlayer)) {
            data["tournamentEventPlayer"] = [];
            for (let item of this.tournamentEventPlayer)
                data["tournamentEventPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentLateRegistrationUser)) {
            data["tournamentLateRegistrationUser"] = [];
            for (let item of this.tournamentLateRegistrationUser)
                data["tournamentLateRegistrationUser"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentLog)) {
            data["tournamentLog"] = [];
            for (let item of this.tournamentLog)
                data["tournamentLog"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRegistration)) {
            data["tournamentRegistration"] = [];
            for (let item of this.tournamentRegistration)
                data["tournamentRegistration"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRegistrationPlayer)) {
            data["tournamentRegistrationPlayer"] = [];
            for (let item of this.tournamentRegistrationPlayer)
                data["tournamentRegistrationPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.uploadedFiles)) {
            data["uploadedFiles"] = [];
            for (let item of this.uploadedFiles)
                data["uploadedFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.userMailSent)) {
            data["userMailSent"] = [];
            for (let item of this.userMailSent)
                data["userMailSent"].push(item.toJSON());
        }
        if (Array.isArray(this.userMailType)) {
            data["userMailType"] = [];
            for (let item of this.userMailType)
                data["userMailType"].push(item.toJSON());
        }
        if (Array.isArray(this.userPortal)) {
            data["userPortal"] = [];
            for (let item of this.userPortal)
                data["userPortal"].push(item.toJSON());
        }
        if (Array.isArray(this.userRole1UpdatedByUser)) {
            data["userRole1UpdatedByUser"] = [];
            for (let item of this.userRole1UpdatedByUser)
                data["userRole1UpdatedByUser"].push(item.toJSON());
        }
        if (Array.isArray(this.userRole1User)) {
            data["userRole1User"] = [];
            for (let item of this.userRole1User)
                data["userRole1User"].push(item.toJSON());
        }
        if (Array.isArray(this.venue)) {
            data["venue"] = [];
            for (let item of this.venue)
                data["venue"].push(item.toJSON());
        }
        return data;
    }
}
export class UserProfile {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.countryCode = _data["countryCode"];
            this.phone = _data["phone"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : undefined;
            this.gender = _data["gender"];
            this.profileImage = _data["profileImage"];
            this.url = _data["url"];
            this.summary = _data["summary"];
            this.isPublic = _data["isPublic"];
            this.emailNotifications = _data["emailNotifications"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : undefined;
            this.createIp = _data["createIp"];
            this.updateTime = _data["updateTime"] ? new Date(_data["updateTime"].toString()) : undefined;
            this.updateIp = _data["updateIp"];
            this.clubPeopleNotifications = _data["clubPeopleNotifications"];
            this.userProfileAccess = _data["userProfileAccess"];
            this.regionId = _data["regionId"];
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfile();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["street"] = this.street;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["phone"] = this.phone;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : undefined;
        data["gender"] = this.gender;
        data["profileImage"] = this.profileImage;
        data["url"] = this.url;
        data["summary"] = this.summary;
        data["isPublic"] = this.isPublic;
        data["emailNotifications"] = this.emailNotifications;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : undefined;
        data["createIp"] = this.createIp;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : undefined;
        data["updateIp"] = this.updateIp;
        data["clubPeopleNotifications"] = this.clubPeopleNotifications;
        data["userProfileAccess"] = this.userProfileAccess;
        data["regionId"] = this.regionId;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class ClubUserRelation {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.userId = _data["userId"];
            this.relationType = _data["relationType"];
            this.sortIndex = _data["sortIndex"];
            this.relationState = _data["relationState"];
            this.message = _data["message"];
            this.fromUserId = _data["fromUserId"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : undefined;
            this.acceptTime = _data["acceptTime"] ? new Date(_data["acceptTime"].toString()) : undefined;
            this.contactTypeId = _data["contactTypeId"];
            this.userSortIndex = _data["userSortIndex"];
            this.club = _data["club"] ? Club1.fromJS(_data["club"]) : undefined;
            this.fromUser = _data["fromUser"] ? User1.fromJS(_data["fromUser"]) : undefined;
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClubUserRelation();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["userId"] = this.userId;
        data["relationType"] = this.relationType;
        data["sortIndex"] = this.sortIndex;
        data["relationState"] = this.relationState;
        data["message"] = this.message;
        data["fromUserId"] = this.fromUserId;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : undefined;
        data["acceptTime"] = this.acceptTime ? this.acceptTime.toISOString() : undefined;
        data["contactTypeId"] = this.contactTypeId;
        data["userSortIndex"] = this.userSortIndex;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["fromUser"] = this.fromUser ? this.fromUser.toJSON() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class ClubVisit {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubVisitId = _data["clubVisitId"];
            this.userId = _data["userId"];
            this.clubId = _data["clubId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined;
            this.visitType = _data["visitType"];
            this.comment = _data["comment"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClubVisit();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubVisitId"] = this.clubVisitId;
        data["userId"] = this.userId;
        data["clubId"] = this.clubId;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["visitType"] = this.visitType;
        data["comment"] = this.comment;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class DbfplayerRankingReplacement {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.seasonId = _data["seasonId"];
            this.playerId = _data["playerId"];
            this.clubStartPointsSingle = _data["clubStartPointsSingle"];
            this.clubStartPointsDouble = _data["clubStartPointsDouble"];
            this.clubStartPointsMixDouble = _data["clubStartPointsMixDouble"];
            this.clubComment = _data["clubComment"];
            this.clubUserId = _data["clubUserId"];
            this.clubTime = _data["clubTime"] ? new Date(_data["clubTime"].toString()) : undefined;
            this.state = _data["state"];
            this.adminStartPointsSingle = _data["adminStartPointsSingle"];
            this.adminStartPointsDouble = _data["adminStartPointsDouble"];
            this.adminStartPointsMixDouble = _data["adminStartPointsMixDouble"];
            this.adminResponse = _data["adminResponse"];
            this.adminInternalNote = _data["adminInternalNote"];
            this.adminRankingComment = _data["adminRankingComment"];
            this.adminUserId = _data["adminUserId"];
            this.adminTime = _data["adminTime"] ? new Date(_data["adminTime"].toString()) : undefined;
            this.orgStartPointsSingle = _data["orgStartPointsSingle"];
            this.orgStartPointsDouble = _data["orgStartPointsDouble"];
            this.orgStartPointsMixDouble = _data["orgStartPointsMixDouble"];
            this.playerGroup = _data["playerGroup"];
            this.adminUser = _data["adminUser"] ? User1.fromJS(_data["adminUser"]) : undefined;
            this.clubUser = _data["clubUser"] ? User1.fromJS(_data["clubUser"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfplayerRankingReplacement();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["seasonId"] = this.seasonId;
        data["playerId"] = this.playerId;
        data["clubStartPointsSingle"] = this.clubStartPointsSingle;
        data["clubStartPointsDouble"] = this.clubStartPointsDouble;
        data["clubStartPointsMixDouble"] = this.clubStartPointsMixDouble;
        data["clubComment"] = this.clubComment;
        data["clubUserId"] = this.clubUserId;
        data["clubTime"] = this.clubTime ? this.clubTime.toISOString() : undefined;
        data["state"] = this.state;
        data["adminStartPointsSingle"] = this.adminStartPointsSingle;
        data["adminStartPointsDouble"] = this.adminStartPointsDouble;
        data["adminStartPointsMixDouble"] = this.adminStartPointsMixDouble;
        data["adminResponse"] = this.adminResponse;
        data["adminInternalNote"] = this.adminInternalNote;
        data["adminRankingComment"] = this.adminRankingComment;
        data["adminUserId"] = this.adminUserId;
        data["adminTime"] = this.adminTime ? this.adminTime.toISOString() : undefined;
        data["orgStartPointsSingle"] = this.orgStartPointsSingle;
        data["orgStartPointsDouble"] = this.orgStartPointsDouble;
        data["orgStartPointsMixDouble"] = this.orgStartPointsMixDouble;
        data["playerGroup"] = this.playerGroup;
        data["adminUser"] = this.adminUser ? this.adminUser.toJSON() : undefined;
        data["clubUser"] = this.clubUser ? this.clubUser.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        return data;
    }
}
export class Player {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.unionId = _data["unionId"];
            this.playerNumber = _data["playerNumber"];
            this.name = _data["name"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined;
            this.clubId = _data["clubId"];
            this.gender = _data["gender"];
            this.validated = _data["validated"];
            this.createdByUserId = _data["createdByUserId"];
            this.validatedByUserId = _data["validatedByUserId"];
            this.updatedByUserId = _data["updatedByUserId"];
            this.updateTime = _data["updateTime"] ? new Date(_data["updateTime"].toString()) : undefined;
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : undefined;
            this.active = _data["active"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.createdByUser = _data["createdByUser"] ? User1.fromJS(_data["createdByUser"]) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            this.updatedByUser = _data["updatedByUser"] ? User1.fromJS(_data["updatedByUser"]) : undefined;
            this.validatedByUser = _data["validatedByUser"] ? User1.fromJS(_data["validatedByUser"]) : undefined;
            this.dbfvmrankingYouthPlayer = _data["dbfvmrankingYouthPlayer"] ? DbfvmrankingYouthPlayer.fromJS(_data["dbfvmrankingYouthPlayer"]) : undefined;
            this.playerAddress = _data["playerAddress"] ? PlayerAddress.fromJS(_data["playerAddress"]) : undefined;
            if (Array.isArray(_data["clubPlayerRelation"])) {
                this.clubPlayerRelation = [];
                for (let item of _data["clubPlayerRelation"])
                    this.clubPlayerRelation.push(ClubPlayerRelation.fromJS(item));
            }
            if (Array.isArray(_data["dbfleagueRegistrationTeamPlayer"])) {
                this.dbfleagueRegistrationTeamPlayer = [];
                for (let item of _data["dbfleagueRegistrationTeamPlayer"])
                    this.dbfleagueRegistrationTeamPlayer.push(DbfleagueRegistrationTeamPlayer.fromJS(item));
            }
            if (Array.isArray(_data["dbfplayerRankingReplacement"])) {
                this.dbfplayerRankingReplacement = [];
                for (let item of _data["dbfplayerRankingReplacement"])
                    this.dbfplayerRankingReplacement.push(DbfplayerRankingReplacement.fromJS(item));
            }
            if (Array.isArray(_data["dbfrankingListPlayerExternPoint"])) {
                this.dbfrankingListPlayerExternPoint = [];
                for (let item of _data["dbfrankingListPlayerExternPoint"])
                    this.dbfrankingListPlayerExternPoint.push(DbfrankingListPlayerExternPoint.fromJS(item));
            }
            if (Array.isArray(_data["dbfrankingListPlayerPoint"])) {
                this.dbfrankingListPlayerPoint = [];
                for (let item of _data["dbfrankingListPlayerPoint"])
                    this.dbfrankingListPlayerPoint.push(DbfrankingListPlayerPoint.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchPlayer"])) {
                this.leagueMatchPlayer = [];
                for (let item of _data["leagueMatchPlayer"])
                    this.leagueMatchPlayer.push(LeagueMatchPlayer.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchPlayerLogOldPlayer"])) {
                this.leagueMatchPlayerLogOldPlayer = [];
                for (let item of _data["leagueMatchPlayerLogOldPlayer"])
                    this.leagueMatchPlayerLogOldPlayer.push(LeagueMatchPlayerLog.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchPlayerLogPlayer"])) {
                this.leagueMatchPlayerLogPlayer = [];
                for (let item of _data["leagueMatchPlayerLogPlayer"])
                    this.leagueMatchPlayerLogPlayer.push(LeagueMatchPlayerLog.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchReferee"])) {
                this.leagueMatchReferee = [];
                for (let item of _data["leagueMatchReferee"])
                    this.leagueMatchReferee.push(LeagueMatchReferee.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchSubstitutePlayer"])) {
                this.leagueMatchSubstitutePlayer = [];
                for (let item of _data["leagueMatchSubstitutePlayer"])
                    this.leagueMatchSubstitutePlayer.push(LeagueMatchSubstitute.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchSubstituteSubstitutedPlayer"])) {
                this.leagueMatchSubstituteSubstitutedPlayer = [];
                for (let item of _data["leagueMatchSubstituteSubstitutedPlayer"])
                    this.leagueMatchSubstituteSubstitutedPlayer.push(LeagueMatchSubstitute.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchTroopPlayer"])) {
                this.leagueMatchTroopPlayer = [];
                for (let item of _data["leagueMatchTroopPlayer"])
                    this.leagueMatchTroopPlayer.push(LeagueMatchTroopPlayer.fromJS(item));
            }
            if (Array.isArray(_data["orderItemKidsClub"])) {
                this.orderItemKidsClub = [];
                for (let item of _data["orderItemKidsClub"])
                    this.orderItemKidsClub.push(OrderItemKidsClub.fromJS(item));
            }
            if (Array.isArray(_data["orderItemLicense"])) {
                this.orderItemLicense = [];
                for (let item of _data["orderItemLicense"])
                    this.orderItemLicense.push(OrderItemLicense.fromJS(item));
            }
            if (Array.isArray(_data["orderItemRegistrationOption"])) {
                this.orderItemRegistrationOption = [];
                for (let item of _data["orderItemRegistrationOption"])
                    this.orderItemRegistrationOption.push(OrderItemRegistrationOption.fromJS(item));
            }
            if (Array.isArray(_data["orderItemRegistrationPlayer"])) {
                this.orderItemRegistrationPlayer = [];
                for (let item of _data["orderItemRegistrationPlayer"])
                    this.orderItemRegistrationPlayer.push(OrderItemRegistrationPlayer.fromJS(item));
            }
            if (Array.isArray(_data["playerClub"])) {
                this.playerClub = [];
                for (let item of _data["playerClub"])
                    this.playerClub.push(PlayerClub.fromJS(item));
            }
            if (Array.isArray(_data["playerClubContact"])) {
                this.playerClubContact = [];
                for (let item of _data["playerClubContact"])
                    this.playerClubContact.push(PlayerClubContact.fromJS(item));
            }
            if (Array.isArray(_data["playerClubTransfer"])) {
                this.playerClubTransfer = [];
                for (let item of _data["playerClubTransfer"])
                    this.playerClubTransfer.push(PlayerClubTransfer.fromJS(item));
            }
            if (Array.isArray(_data["playerLicense"])) {
                this.playerLicense = [];
                for (let item of _data["playerLicense"])
                    this.playerLicense.push(PlayerLicense.fromJS(item));
            }
            if (Array.isArray(_data["playerPlayerType"])) {
                this.playerPlayerType = [];
                for (let item of _data["playerPlayerType"])
                    this.playerPlayerType.push(PlayerPlayerType.fromJS(item));
            }
            if (Array.isArray(_data["playerUser1"])) {
                this.playerUser1 = [];
                for (let item of _data["playerUser1"])
                    this.playerUser1.push(PlayerUser1.fromJS(item));
            }
            if (Array.isArray(_data["rankingListExternPoint"])) {
                this.rankingListExternPoint = [];
                for (let item of _data["rankingListExternPoint"])
                    this.rankingListExternPoint.push(RankingListExternPoint.fromJS(item));
            }
            if (Array.isArray(_data["rankingListPlayer"])) {
                this.rankingListPlayer = [];
                for (let item of _data["rankingListPlayer"])
                    this.rankingListPlayer.push(RankingListPlayer.fromJS(item));
            }
            if (Array.isArray(_data["tournamentClassWildcard"])) {
                this.tournamentClassWildcard = [];
                for (let item of _data["tournamentClassWildcard"])
                    this.tournamentClassWildcard.push(TournamentClassWildcard.fromJS(item));
            }
            if (Array.isArray(_data["tournamentEventPlayer"])) {
                this.tournamentEventPlayer = [];
                for (let item of _data["tournamentEventPlayer"])
                    this.tournamentEventPlayer.push(TournamentEventPlayer.fromJS(item));
            }
            if (Array.isArray(_data["tournamentImportPlayer"])) {
                this.tournamentImportPlayer = [];
                for (let item of _data["tournamentImportPlayer"])
                    this.tournamentImportPlayer.push(TournamentImportPlayer.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRegistrationPlayer"])) {
                this.tournamentRegistrationPlayer = [];
                for (let item of _data["tournamentRegistrationPlayer"])
                    this.tournamentRegistrationPlayer.push(TournamentRegistrationPlayer.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Player();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["unionId"] = this.unionId;
        data["playerNumber"] = this.playerNumber;
        data["name"] = this.name;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined;
        data["clubId"] = this.clubId;
        data["gender"] = this.gender;
        data["validated"] = this.validated;
        data["createdByUserId"] = this.createdByUserId;
        data["validatedByUserId"] = this.validatedByUserId;
        data["updatedByUserId"] = this.updatedByUserId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : undefined;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : undefined;
        data["active"] = this.active;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        data["updatedByUser"] = this.updatedByUser ? this.updatedByUser.toJSON() : undefined;
        data["validatedByUser"] = this.validatedByUser ? this.validatedByUser.toJSON() : undefined;
        data["dbfvmrankingYouthPlayer"] = this.dbfvmrankingYouthPlayer ? this.dbfvmrankingYouthPlayer.toJSON() : undefined;
        data["playerAddress"] = this.playerAddress ? this.playerAddress.toJSON() : undefined;
        if (Array.isArray(this.clubPlayerRelation)) {
            data["clubPlayerRelation"] = [];
            for (let item of this.clubPlayerRelation)
                data["clubPlayerRelation"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfleagueRegistrationTeamPlayer)) {
            data["dbfleagueRegistrationTeamPlayer"] = [];
            for (let item of this.dbfleagueRegistrationTeamPlayer)
                data["dbfleagueRegistrationTeamPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfplayerRankingReplacement)) {
            data["dbfplayerRankingReplacement"] = [];
            for (let item of this.dbfplayerRankingReplacement)
                data["dbfplayerRankingReplacement"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfrankingListPlayerExternPoint)) {
            data["dbfrankingListPlayerExternPoint"] = [];
            for (let item of this.dbfrankingListPlayerExternPoint)
                data["dbfrankingListPlayerExternPoint"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfrankingListPlayerPoint)) {
            data["dbfrankingListPlayerPoint"] = [];
            for (let item of this.dbfrankingListPlayerPoint)
                data["dbfrankingListPlayerPoint"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchPlayer)) {
            data["leagueMatchPlayer"] = [];
            for (let item of this.leagueMatchPlayer)
                data["leagueMatchPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchPlayerLogOldPlayer)) {
            data["leagueMatchPlayerLogOldPlayer"] = [];
            for (let item of this.leagueMatchPlayerLogOldPlayer)
                data["leagueMatchPlayerLogOldPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchPlayerLogPlayer)) {
            data["leagueMatchPlayerLogPlayer"] = [];
            for (let item of this.leagueMatchPlayerLogPlayer)
                data["leagueMatchPlayerLogPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchReferee)) {
            data["leagueMatchReferee"] = [];
            for (let item of this.leagueMatchReferee)
                data["leagueMatchReferee"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchSubstitutePlayer)) {
            data["leagueMatchSubstitutePlayer"] = [];
            for (let item of this.leagueMatchSubstitutePlayer)
                data["leagueMatchSubstitutePlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchSubstituteSubstitutedPlayer)) {
            data["leagueMatchSubstituteSubstitutedPlayer"] = [];
            for (let item of this.leagueMatchSubstituteSubstitutedPlayer)
                data["leagueMatchSubstituteSubstitutedPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchTroopPlayer)) {
            data["leagueMatchTroopPlayer"] = [];
            for (let item of this.leagueMatchTroopPlayer)
                data["leagueMatchTroopPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemKidsClub)) {
            data["orderItemKidsClub"] = [];
            for (let item of this.orderItemKidsClub)
                data["orderItemKidsClub"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemLicense)) {
            data["orderItemLicense"] = [];
            for (let item of this.orderItemLicense)
                data["orderItemLicense"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemRegistrationOption)) {
            data["orderItemRegistrationOption"] = [];
            for (let item of this.orderItemRegistrationOption)
                data["orderItemRegistrationOption"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemRegistrationPlayer)) {
            data["orderItemRegistrationPlayer"] = [];
            for (let item of this.orderItemRegistrationPlayer)
                data["orderItemRegistrationPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.playerClub)) {
            data["playerClub"] = [];
            for (let item of this.playerClub)
                data["playerClub"].push(item.toJSON());
        }
        if (Array.isArray(this.playerClubContact)) {
            data["playerClubContact"] = [];
            for (let item of this.playerClubContact)
                data["playerClubContact"].push(item.toJSON());
        }
        if (Array.isArray(this.playerClubTransfer)) {
            data["playerClubTransfer"] = [];
            for (let item of this.playerClubTransfer)
                data["playerClubTransfer"].push(item.toJSON());
        }
        if (Array.isArray(this.playerLicense)) {
            data["playerLicense"] = [];
            for (let item of this.playerLicense)
                data["playerLicense"].push(item.toJSON());
        }
        if (Array.isArray(this.playerPlayerType)) {
            data["playerPlayerType"] = [];
            for (let item of this.playerPlayerType)
                data["playerPlayerType"].push(item.toJSON());
        }
        if (Array.isArray(this.playerUser1)) {
            data["playerUser1"] = [];
            for (let item of this.playerUser1)
                data["playerUser1"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListExternPoint)) {
            data["rankingListExternPoint"] = [];
            for (let item of this.rankingListExternPoint)
                data["rankingListExternPoint"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListPlayer)) {
            data["rankingListPlayer"] = [];
            for (let item of this.rankingListPlayer)
                data["rankingListPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentClassWildcard)) {
            data["tournamentClassWildcard"] = [];
            for (let item of this.tournamentClassWildcard)
                data["tournamentClassWildcard"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentEventPlayer)) {
            data["tournamentEventPlayer"] = [];
            for (let item of this.tournamentEventPlayer)
                data["tournamentEventPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentImportPlayer)) {
            data["tournamentImportPlayer"] = [];
            for (let item of this.tournamentImportPlayer)
                data["tournamentImportPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRegistrationPlayer)) {
            data["tournamentRegistrationPlayer"] = [];
            for (let item of this.tournamentRegistrationPlayer)
                data["tournamentRegistrationPlayer"].push(item.toJSON());
        }
        return data;
    }
}
export class Union {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.unionId = _data["unionId"];
            this.name = _data["name"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.countryCode = _data["countryCode"];
            this.phone = _data["phone"];
            this.vatno = _data["vatno"];
            this.email = _data["email"];
            this.currency = _data["currency"];
            this.paymentFeePerOrder = _data["paymentFeePerOrder"];
            this.paymentFeePercentage = _data["paymentFeePercentage"];
            this.administrationFeePerOrder = _data["administrationFeePerOrder"];
            this.administrationFeePerLicense = _data["administrationFeePerLicense"];
            this.administrationFeePerRegistration = _data["administrationFeePerRegistration"];
            this.invoiceFeePerOrder = _data["invoiceFeePerOrder"];
            this.gatewayMerchantId = _data["gatewayMerchantId"];
            this.gatewayOrderPrefix = _data["gatewayOrderPrefix"];
            this.portalId = _data["portalId"];
            this.clubId = _data["clubId"];
            this.rootDir = _data["rootDir"];
            this.gatewayMd5 = _data["gatewayMd5"];
            this.club = _data["club"] ? Club1.fromJS(_data["club"]) : undefined;
            this.portal = _data["portal"] ? Portal.fromJS(_data["portal"]) : undefined;
            this.unionCustomNews = _data["unionCustomNews"] ? UnionCustomNews.fromJS(_data["unionCustomNews"]) : undefined;
            this.unionMailUpdate = _data["unionMailUpdate"] ? UnionMailUpdate.fromJS(_data["unionMailUpdate"]) : undefined;
            if (Array.isArray(_data["ageGroup"])) {
                this.ageGroup = [];
                for (let item of _data["ageGroup"])
                    this.ageGroup.push(AgeGroup.fromJS(item));
            }
            if (Array.isArray(_data["class"])) {
                this.class = [];
                for (let item of _data["class"])
                    this.class.push(Class.fromJS(item));
            }
            if (Array.isArray(_data["clubFlag"])) {
                this.clubFlag = [];
                for (let item of _data["clubFlag"])
                    this.clubFlag.push(ClubFlag.fromJS(item));
            }
            if (Array.isArray(_data["dbfappGameUser"])) {
                this.dbfappGameUser = [];
                for (let item of _data["dbfappGameUser"])
                    this.dbfappGameUser.push(DbfappGameUser.fromJS(item));
            }
            if (Array.isArray(_data["geoRegion"])) {
                this.geoRegion = [];
                for (let item of _data["geoRegion"])
                    this.geoRegion.push(GeoRegion.fromJS(item));
            }
            if (Array.isArray(_data["leagueSchema"])) {
                this.leagueSchema = [];
                for (let item of _data["leagueSchema"])
                    this.leagueSchema.push(LeagueSchema.fromJS(item));
            }
            if (Array.isArray(_data["leagueTeam"])) {
                this.leagueTeam = [];
                for (let item of _data["leagueTeam"])
                    this.leagueTeam.push(LeagueTeam.fromJS(item));
            }
            if (Array.isArray(_data["license"])) {
                this.license = [];
                for (let item of _data["license"])
                    this.license.push(License.fromJS(item));
            }
            if (Array.isArray(_data["liveScoreSubscriber"])) {
                this.liveScoreSubscriber = [];
                for (let item of _data["liveScoreSubscriber"])
                    this.liveScoreSubscriber.push(LiveScoreSubscriber.fromJS(item));
            }
            if (Array.isArray(_data["liveScoreSubscription"])) {
                this.liveScoreSubscription = [];
                for (let item of _data["liveScoreSubscription"])
                    this.liveScoreSubscription.push(LiveScoreSubscription.fromJS(item));
            }
            if (Array.isArray(_data["mailTemplate"])) {
                this.mailTemplate = [];
                for (let item of _data["mailTemplate"])
                    this.mailTemplate.push(MailTemplate.fromJS(item));
            }
            if (Array.isArray(_data["order"])) {
                this.order = [];
                for (let item of _data["order"])
                    this.order.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["paidAccess"])) {
                this.paidAccess = [];
                for (let item of _data["paidAccess"])
                    this.paidAccess.push(PaidAccess.fromJS(item));
            }
            if (Array.isArray(_data["player1"])) {
                this.player1 = [];
                for (let item of _data["player1"])
                    this.player1.push(Player.fromJS(item));
            }
            if (Array.isArray(_data["playerDeleted"])) {
                this.playerDeleted = [];
                for (let item of _data["playerDeleted"])
                    this.playerDeleted.push(PlayerDeleted.fromJS(item));
            }
            if (Array.isArray(_data["playerType"])) {
                this.playerType = [];
                for (let item of _data["playerType"])
                    this.playerType.push(PlayerType.fromJS(item));
            }
            if (Array.isArray(_data["rankingList"])) {
                this.rankingList = [];
                for (let item of _data["rankingList"])
                    this.rankingList.push(RankingList.fromJS(item));
            }
            if (Array.isArray(_data["rankingListPromotionVersion"])) {
                this.rankingListPromotionVersion = [];
                for (let item of _data["rankingListPromotionVersion"])
                    this.rankingListPromotionVersion.push(RankingListPromotionVersion.fromJS(item));
            }
            if (Array.isArray(_data["region"])) {
                this.region = [];
                for (let item of _data["region"])
                    this.region.push(Region.fromJS(item));
            }
            if (Array.isArray(_data["season"])) {
                this.season = [];
                for (let item of _data["season"])
                    this.season.push(Season.fromJS(item));
            }
            if (Array.isArray(_data["smspayment"])) {
                this.smspayment = [];
                for (let item of _data["smspayment"])
                    this.smspayment.push(Smspayment.fromJS(item));
            }
            if (Array.isArray(_data["tournamentImportBatch"])) {
                this.tournamentImportBatch = [];
                for (let item of _data["tournamentImportBatch"])
                    this.tournamentImportBatch.push(TournamentImportBatch.fromJS(item));
            }
            if (Array.isArray(_data["tournamentType1"])) {
                this.tournamentType1 = [];
                for (let item of _data["tournamentType1"])
                    this.tournamentType1.push(TournamentType1.fromJS(item));
            }
            if (Array.isArray(_data["unionSettings"])) {
                this.unionSettings = [];
                for (let item of _data["unionSettings"])
                    this.unionSettings.push(UnionSettings.fromJS(item));
            }
            if (Array.isArray(_data["venue"])) {
                this.venue = [];
                for (let item of _data["venue"])
                    this.venue.push(Venue.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Union();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["unionId"] = this.unionId;
        data["name"] = this.name;
        data["street"] = this.street;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["phone"] = this.phone;
        data["vatno"] = this.vatno;
        data["email"] = this.email;
        data["currency"] = this.currency;
        data["paymentFeePerOrder"] = this.paymentFeePerOrder;
        data["paymentFeePercentage"] = this.paymentFeePercentage;
        data["administrationFeePerOrder"] = this.administrationFeePerOrder;
        data["administrationFeePerLicense"] = this.administrationFeePerLicense;
        data["administrationFeePerRegistration"] = this.administrationFeePerRegistration;
        data["invoiceFeePerOrder"] = this.invoiceFeePerOrder;
        data["gatewayMerchantId"] = this.gatewayMerchantId;
        data["gatewayOrderPrefix"] = this.gatewayOrderPrefix;
        data["portalId"] = this.portalId;
        data["clubId"] = this.clubId;
        data["rootDir"] = this.rootDir;
        data["gatewayMd5"] = this.gatewayMd5;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["portal"] = this.portal ? this.portal.toJSON() : undefined;
        data["unionCustomNews"] = this.unionCustomNews ? this.unionCustomNews.toJSON() : undefined;
        data["unionMailUpdate"] = this.unionMailUpdate ? this.unionMailUpdate.toJSON() : undefined;
        if (Array.isArray(this.ageGroup)) {
            data["ageGroup"] = [];
            for (let item of this.ageGroup)
                data["ageGroup"].push(item.toJSON());
        }
        if (Array.isArray(this.class)) {
            data["class"] = [];
            for (let item of this.class)
                data["class"].push(item.toJSON());
        }
        if (Array.isArray(this.clubFlag)) {
            data["clubFlag"] = [];
            for (let item of this.clubFlag)
                data["clubFlag"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfappGameUser)) {
            data["dbfappGameUser"] = [];
            for (let item of this.dbfappGameUser)
                data["dbfappGameUser"].push(item.toJSON());
        }
        if (Array.isArray(this.geoRegion)) {
            data["geoRegion"] = [];
            for (let item of this.geoRegion)
                data["geoRegion"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueSchema)) {
            data["leagueSchema"] = [];
            for (let item of this.leagueSchema)
                data["leagueSchema"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueTeam)) {
            data["leagueTeam"] = [];
            for (let item of this.leagueTeam)
                data["leagueTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.license)) {
            data["license"] = [];
            for (let item of this.license)
                data["license"].push(item.toJSON());
        }
        if (Array.isArray(this.liveScoreSubscriber)) {
            data["liveScoreSubscriber"] = [];
            for (let item of this.liveScoreSubscriber)
                data["liveScoreSubscriber"].push(item.toJSON());
        }
        if (Array.isArray(this.liveScoreSubscription)) {
            data["liveScoreSubscription"] = [];
            for (let item of this.liveScoreSubscription)
                data["liveScoreSubscription"].push(item.toJSON());
        }
        if (Array.isArray(this.mailTemplate)) {
            data["mailTemplate"] = [];
            for (let item of this.mailTemplate)
                data["mailTemplate"].push(item.toJSON());
        }
        if (Array.isArray(this.order)) {
            data["order"] = [];
            for (let item of this.order)
                data["order"].push(item.toJSON());
        }
        if (Array.isArray(this.paidAccess)) {
            data["paidAccess"] = [];
            for (let item of this.paidAccess)
                data["paidAccess"].push(item.toJSON());
        }
        if (Array.isArray(this.player1)) {
            data["player1"] = [];
            for (let item of this.player1)
                data["player1"].push(item.toJSON());
        }
        if (Array.isArray(this.playerDeleted)) {
            data["playerDeleted"] = [];
            for (let item of this.playerDeleted)
                data["playerDeleted"].push(item.toJSON());
        }
        if (Array.isArray(this.playerType)) {
            data["playerType"] = [];
            for (let item of this.playerType)
                data["playerType"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingList)) {
            data["rankingList"] = [];
            for (let item of this.rankingList)
                data["rankingList"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListPromotionVersion)) {
            data["rankingListPromotionVersion"] = [];
            for (let item of this.rankingListPromotionVersion)
                data["rankingListPromotionVersion"].push(item.toJSON());
        }
        if (Array.isArray(this.region)) {
            data["region"] = [];
            for (let item of this.region)
                data["region"].push(item.toJSON());
        }
        if (Array.isArray(this.season)) {
            data["season"] = [];
            for (let item of this.season)
                data["season"].push(item.toJSON());
        }
        if (Array.isArray(this.smspayment)) {
            data["smspayment"] = [];
            for (let item of this.smspayment)
                data["smspayment"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentImportBatch)) {
            data["tournamentImportBatch"] = [];
            for (let item of this.tournamentImportBatch)
                data["tournamentImportBatch"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentType1)) {
            data["tournamentType1"] = [];
            for (let item of this.tournamentType1)
                data["tournamentType1"].push(item.toJSON());
        }
        if (Array.isArray(this.unionSettings)) {
            data["unionSettings"] = [];
            for (let item of this.unionSettings)
                data["unionSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.venue)) {
            data["venue"] = [];
            for (let item of this.venue)
                data["venue"].push(item.toJSON());
        }
        return data;
    }
}
export class UnionCustomNews {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.unionId = _data["unionId"];
            this.title = _data["title"];
            this.newsCategoryId = _data["newsCategoryId"];
            this.newsCategory = _data["newsCategory"] ? NewsCategory.fromJS(_data["newsCategory"]) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UnionCustomNews();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["unionId"] = this.unionId;
        data["title"] = this.title;
        data["newsCategoryId"] = this.newsCategoryId;
        data["newsCategory"] = this.newsCategory ? this.newsCategory.toJSON() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        return data;
    }
}
export class NewsCategory {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.newsCategoryId = _data["newsCategoryId"];
            this.clubId = _data["clubId"];
            this.newsCategoryName = _data["newsCategoryName"];
            if (Array.isArray(_data["unionCustomNews"])) {
                this.unionCustomNews = [];
                for (let item of _data["unionCustomNews"])
                    this.unionCustomNews.push(UnionCustomNews.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NewsCategory();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["newsCategoryId"] = this.newsCategoryId;
        data["clubId"] = this.clubId;
        data["newsCategoryName"] = this.newsCategoryName;
        if (Array.isArray(this.unionCustomNews)) {
            data["unionCustomNews"] = [];
            for (let item of this.unionCustomNews)
                data["unionCustomNews"].push(item.toJSON());
        }
        return data;
    }
}
export class UnionMailUpdate {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.unionId = _data["unionId"];
            this.updateTime = _data["updateTime"] ? new Date(_data["updateTime"].toString()) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UnionMailUpdate();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["unionId"] = this.unionId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        return data;
    }
}
export class AgeGroup {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.ageGroupId = _data["ageGroupId"];
            this.unionId = _data["unionId"];
            this.ageGroupName = _data["ageGroupName"];
            this.yearsFrom = _data["yearsFrom"];
            this.yearsTo = _data["yearsTo"];
            this.licensePriority = _data["licensePriority"];
            this.tournamentApplication = _data["tournamentApplication"];
            this.cutOffDay = _data["cutOffDay"];
            this.cutOffMonth = _data["cutOffMonth"];
            this.defaultLeague = _data["defaultLeague"];
            this.licenseId = _data["licenseId"];
            this.seasonPlanGroupIndex = _data["seasonPlanGroupIndex"];
            this.seasonPlanGroupName = _data["seasonPlanGroupName"];
            this.tournamentSpecific = _data["tournamentSpecific"];
            this.yearsFromTournament = _data["yearsFromTournament"];
            this.yearsToTournament = _data["yearsToTournament"];
            this.cutOffDayTournament = _data["cutOffDayTournament"];
            this.cutOffMonthTournament = _data["cutOffMonthTournament"];
            this.calendarYear = _data["calendarYear"];
            this.sortIndex = _data["sortIndex"];
            this.license = _data["license"] ? License.fromJS(_data["license"]) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            if (Array.isArray(_data["ageGroupClass"])) {
                this.ageGroupClass = [];
                for (let item of _data["ageGroupClass"])
                    this.ageGroupClass.push(AgeGroupClass.fromJS(item));
            }
            if (Array.isArray(_data["ageGroupClassRanking"])) {
                this.ageGroupClassRanking = [];
                for (let item of _data["ageGroupClassRanking"])
                    this.ageGroupClassRanking.push(AgeGroupClassRanking.fromJS(item));
            }
            if (Array.isArray(_data["clubSettingAgegroupClass"])) {
                this.clubSettingAgegroupClass = [];
                for (let item of _data["clubSettingAgegroupClass"])
                    this.clubSettingAgegroupClass.push(ClubSettingAgegroupClass.fromJS(item));
            }
            if (Array.isArray(_data["dbfleagueClassificationPoints"])) {
                this.dbfleagueClassificationPoints = [];
                for (let item of _data["dbfleagueClassificationPoints"])
                    this.dbfleagueClassificationPoints.push(DbfleagueClassificationPoints.fromJS(item));
            }
            if (Array.isArray(_data["dbfleagueRankingPointsYouth"])) {
                this.dbfleagueRankingPointsYouth = [];
                for (let item of _data["dbfleagueRankingPointsYouth"])
                    this.dbfleagueRankingPointsYouth.push(DbfleagueRankingPointsYouth.fromJS(item));
            }
            if (Array.isArray(_data["dbfrankingListPlayerClass"])) {
                this.dbfrankingListPlayerClass = [];
                for (let item of _data["dbfrankingListPlayerClass"])
                    this.dbfrankingListPlayerClass.push(DbfrankingListPlayerClass.fromJS(item));
            }
            if (Array.isArray(_data["dbfrankinglistTournamentPoints"])) {
                this.dbfrankinglistTournamentPoints = [];
                for (let item of _data["dbfrankinglistTournamentPoints"])
                    this.dbfrankinglistTournamentPoints.push(DbfrankinglistTournamentPoints.fromJS(item));
            }
            if (Array.isArray(_data["dbfratingAdjustment"])) {
                this.dbfratingAdjustment = [];
                for (let item of _data["dbfratingAdjustment"])
                    this.dbfratingAdjustment.push(DbfratingAdjustment.fromJS(item));
            }
            if (Array.isArray(_data["dbfratingListClassInterval"])) {
                this.dbfratingListClassInterval = [];
                for (let item of _data["dbfratingListClassInterval"])
                    this.dbfratingListClassInterval.push(DbfratingListClassInterval.fromJS(item));
            }
            if (Array.isArray(_data["dbfratingListStartPoints"])) {
                this.dbfratingListStartPoints = [];
                for (let item of _data["dbfratingListStartPoints"])
                    this.dbfratingListStartPoints.push(DbfratingListStartPoints.fromJS(item));
            }
            if (Array.isArray(_data["leagueDivision"])) {
                this.leagueDivision = [];
                for (let item of _data["leagueDivision"])
                    this.leagueDivision.push(LeagueDivision.fromJS(item));
            }
            if (Array.isArray(_data["leagueRegistration"])) {
                this.leagueRegistration = [];
                for (let item of _data["leagueRegistration"])
                    this.leagueRegistration.push(LeagueRegistration.fromJS(item));
            }
            if (Array.isArray(_data["orderItemLicense"])) {
                this.orderItemLicense = [];
                for (let item of _data["orderItemLicense"])
                    this.orderItemLicense.push(OrderItemLicense.fromJS(item));
            }
            if (Array.isArray(_data["rankingList"])) {
                this.rankingList = [];
                for (let item of _data["rankingList"])
                    this.rankingList.push(RankingList.fromJS(item));
            }
            if (Array.isArray(_data["rankingListExternPoint"])) {
                this.rankingListExternPoint = [];
                for (let item of _data["rankingListExternPoint"])
                    this.rankingListExternPoint.push(RankingListExternPoint.fromJS(item));
            }
            if (Array.isArray(_data["rankingListVersionPlayer"])) {
                this.rankingListVersionPlayer = [];
                for (let item of _data["rankingListVersionPlayer"])
                    this.rankingListVersionPlayer.push(RankingListVersionPlayer.fromJS(item));
            }
            if (Array.isArray(_data["tournamentClass1"])) {
                this.tournamentClass1 = [];
                for (let item of _data["tournamentClass1"])
                    this.tournamentClass1.push(TournamentClass1.fromJS(item));
            }
            if (Array.isArray(_data["tournamentClassApplication"])) {
                this.tournamentClassApplication = [];
                for (let item of _data["tournamentClassApplication"])
                    this.tournamentClassApplication.push(TournamentClassApplication.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRoundAgeGroupClass"])) {
                this.tournamentRoundAgeGroupClass = [];
                for (let item of _data["tournamentRoundAgeGroupClass"])
                    this.tournamentRoundAgeGroupClass.push(TournamentRoundAgeGroupClass.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AgeGroup();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ageGroupId"] = this.ageGroupId;
        data["unionId"] = this.unionId;
        data["ageGroupName"] = this.ageGroupName;
        data["yearsFrom"] = this.yearsFrom;
        data["yearsTo"] = this.yearsTo;
        data["licensePriority"] = this.licensePriority;
        data["tournamentApplication"] = this.tournamentApplication;
        data["cutOffDay"] = this.cutOffDay;
        data["cutOffMonth"] = this.cutOffMonth;
        data["defaultLeague"] = this.defaultLeague;
        data["licenseId"] = this.licenseId;
        data["seasonPlanGroupIndex"] = this.seasonPlanGroupIndex;
        data["seasonPlanGroupName"] = this.seasonPlanGroupName;
        data["tournamentSpecific"] = this.tournamentSpecific;
        data["yearsFromTournament"] = this.yearsFromTournament;
        data["yearsToTournament"] = this.yearsToTournament;
        data["cutOffDayTournament"] = this.cutOffDayTournament;
        data["cutOffMonthTournament"] = this.cutOffMonthTournament;
        data["calendarYear"] = this.calendarYear;
        data["sortIndex"] = this.sortIndex;
        data["license"] = this.license ? this.license.toJSON() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        if (Array.isArray(this.ageGroupClass)) {
            data["ageGroupClass"] = [];
            for (let item of this.ageGroupClass)
                data["ageGroupClass"].push(item.toJSON());
        }
        if (Array.isArray(this.ageGroupClassRanking)) {
            data["ageGroupClassRanking"] = [];
            for (let item of this.ageGroupClassRanking)
                data["ageGroupClassRanking"].push(item.toJSON());
        }
        if (Array.isArray(this.clubSettingAgegroupClass)) {
            data["clubSettingAgegroupClass"] = [];
            for (let item of this.clubSettingAgegroupClass)
                data["clubSettingAgegroupClass"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfleagueClassificationPoints)) {
            data["dbfleagueClassificationPoints"] = [];
            for (let item of this.dbfleagueClassificationPoints)
                data["dbfleagueClassificationPoints"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfleagueRankingPointsYouth)) {
            data["dbfleagueRankingPointsYouth"] = [];
            for (let item of this.dbfleagueRankingPointsYouth)
                data["dbfleagueRankingPointsYouth"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfrankingListPlayerClass)) {
            data["dbfrankingListPlayerClass"] = [];
            for (let item of this.dbfrankingListPlayerClass)
                data["dbfrankingListPlayerClass"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfrankinglistTournamentPoints)) {
            data["dbfrankinglistTournamentPoints"] = [];
            for (let item of this.dbfrankinglistTournamentPoints)
                data["dbfrankinglistTournamentPoints"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfratingAdjustment)) {
            data["dbfratingAdjustment"] = [];
            for (let item of this.dbfratingAdjustment)
                data["dbfratingAdjustment"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfratingListClassInterval)) {
            data["dbfratingListClassInterval"] = [];
            for (let item of this.dbfratingListClassInterval)
                data["dbfratingListClassInterval"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfratingListStartPoints)) {
            data["dbfratingListStartPoints"] = [];
            for (let item of this.dbfratingListStartPoints)
                data["dbfratingListStartPoints"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueDivision)) {
            data["leagueDivision"] = [];
            for (let item of this.leagueDivision)
                data["leagueDivision"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueRegistration)) {
            data["leagueRegistration"] = [];
            for (let item of this.leagueRegistration)
                data["leagueRegistration"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemLicense)) {
            data["orderItemLicense"] = [];
            for (let item of this.orderItemLicense)
                data["orderItemLicense"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingList)) {
            data["rankingList"] = [];
            for (let item of this.rankingList)
                data["rankingList"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListExternPoint)) {
            data["rankingListExternPoint"] = [];
            for (let item of this.rankingListExternPoint)
                data["rankingListExternPoint"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListVersionPlayer)) {
            data["rankingListVersionPlayer"] = [];
            for (let item of this.rankingListVersionPlayer)
                data["rankingListVersionPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentClass1)) {
            data["tournamentClass1"] = [];
            for (let item of this.tournamentClass1)
                data["tournamentClass1"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentClassApplication)) {
            data["tournamentClassApplication"] = [];
            for (let item of this.tournamentClassApplication)
                data["tournamentClassApplication"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRoundAgeGroupClass)) {
            data["tournamentRoundAgeGroupClass"] = [];
            for (let item of this.tournamentRoundAgeGroupClass)
                data["tournamentRoundAgeGroupClass"].push(item.toJSON());
        }
        return data;
    }
}
export class License {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.licenseId = _data["licenseId"];
            this.unionId = _data["unionId"];
            this.name = _data["name"];
            this.licenseType = _data["licenseType"];
            this.price = _data["price"];
            this.secondary = _data["secondary"];
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            if (Array.isArray(_data["ageGroup"])) {
                this.ageGroup = [];
                for (let item of _data["ageGroup"])
                    this.ageGroup.push(AgeGroup.fromJS(item));
            }
            if (Array.isArray(_data["ageGroupClass"])) {
                this.ageGroupClass = [];
                for (let item of _data["ageGroupClass"])
                    this.ageGroupClass.push(AgeGroupClass.fromJS(item));
            }
            if (Array.isArray(_data["orderItemLicense"])) {
                this.orderItemLicense = [];
                for (let item of _data["orderItemLicense"])
                    this.orderItemLicense.push(OrderItemLicense.fromJS(item));
            }
            if (Array.isArray(_data["playerLicense"])) {
                this.playerLicense = [];
                for (let item of _data["playerLicense"])
                    this.playerLicense.push(PlayerLicense.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new License();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId;
        data["unionId"] = this.unionId;
        data["name"] = this.name;
        data["licenseType"] = this.licenseType;
        data["price"] = this.price;
        data["secondary"] = this.secondary;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        if (Array.isArray(this.ageGroup)) {
            data["ageGroup"] = [];
            for (let item of this.ageGroup)
                data["ageGroup"].push(item.toJSON());
        }
        if (Array.isArray(this.ageGroupClass)) {
            data["ageGroupClass"] = [];
            for (let item of this.ageGroupClass)
                data["ageGroupClass"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemLicense)) {
            data["orderItemLicense"] = [];
            for (let item of this.orderItemLicense)
                data["orderItemLicense"].push(item.toJSON());
        }
        if (Array.isArray(this.playerLicense)) {
            data["playerLicense"] = [];
            for (let item of this.playerLicense)
                data["playerLicense"].push(item.toJSON());
        }
        return data;
    }
}
export class AgeGroupClass {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.ageGroupClassId = _data["ageGroupClassId"];
            this.ageGroupId = _data["ageGroupId"];
            this.classId = _data["classId"];
            this.licenseId = _data["licenseId"];
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.class = _data["class"] ? Class.fromJS(_data["class"]) : undefined;
            this.license = _data["license"] ? License.fromJS(_data["license"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AgeGroupClass();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ageGroupClassId"] = this.ageGroupClassId;
        data["ageGroupId"] = this.ageGroupId;
        data["classId"] = this.classId;
        data["licenseId"] = this.licenseId;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["class"] = this.class ? this.class.toJSON() : undefined;
        data["license"] = this.license ? this.license.toJSON() : undefined;
        return data;
    }
}
export class Class {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.classId = _data["classId"];
            this.unionId = _data["unionId"];
            this.className = _data["className"];
            this.sortIndex = _data["sortIndex"];
            this.shortClassName = _data["shortClassName"];
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            if (Array.isArray(_data["ageGroupClass"])) {
                this.ageGroupClass = [];
                for (let item of _data["ageGroupClass"])
                    this.ageGroupClass.push(AgeGroupClass.fromJS(item));
            }
            if (Array.isArray(_data["ageGroupClassRanking"])) {
                this.ageGroupClassRanking = [];
                for (let item of _data["ageGroupClassRanking"])
                    this.ageGroupClassRanking.push(AgeGroupClassRanking.fromJS(item));
            }
            if (Array.isArray(_data["clubSettingAgegroupClass"])) {
                this.clubSettingAgegroupClass = [];
                for (let item of _data["clubSettingAgegroupClass"])
                    this.clubSettingAgegroupClass.push(ClubSettingAgegroupClass.fromJS(item));
            }
            if (Array.isArray(_data["dbfclubBarometerClassId1Navigation"])) {
                this.dbfclubBarometerClassId1Navigation = [];
                for (let item of _data["dbfclubBarometerClassId1Navigation"])
                    this.dbfclubBarometerClassId1Navigation.push(DbfclubBarometer.fromJS(item));
            }
            if (Array.isArray(_data["dbfclubBarometerClassId2Navigation"])) {
                this.dbfclubBarometerClassId2Navigation = [];
                for (let item of _data["dbfclubBarometerClassId2Navigation"])
                    this.dbfclubBarometerClassId2Navigation.push(DbfclubBarometer.fromJS(item));
            }
            if (Array.isArray(_data["dbfleagueClassificationPoints"])) {
                this.dbfleagueClassificationPoints = [];
                for (let item of _data["dbfleagueClassificationPoints"])
                    this.dbfleagueClassificationPoints.push(DbfleagueClassificationPoints.fromJS(item));
            }
            if (Array.isArray(_data["dbfleagueDivision"])) {
                this.dbfleagueDivision = [];
                for (let item of _data["dbfleagueDivision"])
                    this.dbfleagueDivision.push(DbfleagueDivision.fromJS(item));
            }
            if (Array.isArray(_data["dbfleagueRankingPointsYouth"])) {
                this.dbfleagueRankingPointsYouth = [];
                for (let item of _data["dbfleagueRankingPointsYouth"])
                    this.dbfleagueRankingPointsYouth.push(DbfleagueRankingPointsYouth.fromJS(item));
            }
            if (Array.isArray(_data["dbfrankingListPlayerClassHighClass"])) {
                this.dbfrankingListPlayerClassHighClass = [];
                for (let item of _data["dbfrankingListPlayerClassHighClass"])
                    this.dbfrankingListPlayerClassHighClass.push(DbfrankingListPlayerClass.fromJS(item));
            }
            if (Array.isArray(_data["dbfrankingListPlayerClassLowClass"])) {
                this.dbfrankingListPlayerClassLowClass = [];
                for (let item of _data["dbfrankingListPlayerClassLowClass"])
                    this.dbfrankingListPlayerClassLowClass.push(DbfrankingListPlayerClass.fromJS(item));
            }
            if (Array.isArray(_data["dbfrankinglistTournamentPoints"])) {
                this.dbfrankinglistTournamentPoints = [];
                for (let item of _data["dbfrankinglistTournamentPoints"])
                    this.dbfrankinglistTournamentPoints.push(DbfrankinglistTournamentPoints.fromJS(item));
            }
            if (Array.isArray(_data["dbfratingListClassIntervalHighClass"])) {
                this.dbfratingListClassIntervalHighClass = [];
                for (let item of _data["dbfratingListClassIntervalHighClass"])
                    this.dbfratingListClassIntervalHighClass.push(DbfratingListClassInterval.fromJS(item));
            }
            if (Array.isArray(_data["dbfratingListClassIntervalLowClass"])) {
                this.dbfratingListClassIntervalLowClass = [];
                for (let item of _data["dbfratingListClassIntervalLowClass"])
                    this.dbfratingListClassIntervalLowClass.push(DbfratingListClassInterval.fromJS(item));
            }
            if (Array.isArray(_data["orderItemLicense"])) {
                this.orderItemLicense = [];
                for (let item of _data["orderItemLicense"])
                    this.orderItemLicense.push(OrderItemLicense.fromJS(item));
            }
            if (Array.isArray(_data["rankingList"])) {
                this.rankingList = [];
                for (let item of _data["rankingList"])
                    this.rankingList.push(RankingList.fromJS(item));
            }
            if (Array.isArray(_data["rankingListClassInterval"])) {
                this.rankingListClassInterval = [];
                for (let item of _data["rankingListClassInterval"])
                    this.rankingListClassInterval.push(RankingListClassInterval.fromJS(item));
            }
            if (Array.isArray(_data["rankingListVersionPlayerHighClass"])) {
                this.rankingListVersionPlayerHighClass = [];
                for (let item of _data["rankingListVersionPlayerHighClass"])
                    this.rankingListVersionPlayerHighClass.push(RankingListVersionPlayer.fromJS(item));
            }
            if (Array.isArray(_data["rankingListVersionPlayerLowClass"])) {
                this.rankingListVersionPlayerLowClass = [];
                for (let item of _data["rankingListVersionPlayerLowClass"])
                    this.rankingListVersionPlayerLowClass.push(RankingListVersionPlayer.fromJS(item));
            }
            if (Array.isArray(_data["tournamentApplicationRegionAccess"])) {
                this.tournamentApplicationRegionAccess = [];
                for (let item of _data["tournamentApplicationRegionAccess"])
                    this.tournamentApplicationRegionAccess.push(TournamentApplicationRegionAccess.fromJS(item));
            }
            if (Array.isArray(_data["tournamentClass1"])) {
                this.tournamentClass1 = [];
                for (let item of _data["tournamentClass1"])
                    this.tournamentClass1.push(TournamentClass1.fromJS(item));
            }
            if (Array.isArray(_data["tournamentClassApplication"])) {
                this.tournamentClassApplication = [];
                for (let item of _data["tournamentClassApplication"])
                    this.tournamentClassApplication.push(TournamentClassApplication.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRoundAgeGroupClass"])) {
                this.tournamentRoundAgeGroupClass = [];
                for (let item of _data["tournamentRoundAgeGroupClass"])
                    this.tournamentRoundAgeGroupClass.push(TournamentRoundAgeGroupClass.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Class();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["unionId"] = this.unionId;
        data["className"] = this.className;
        data["sortIndex"] = this.sortIndex;
        data["shortClassName"] = this.shortClassName;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        if (Array.isArray(this.ageGroupClass)) {
            data["ageGroupClass"] = [];
            for (let item of this.ageGroupClass)
                data["ageGroupClass"].push(item.toJSON());
        }
        if (Array.isArray(this.ageGroupClassRanking)) {
            data["ageGroupClassRanking"] = [];
            for (let item of this.ageGroupClassRanking)
                data["ageGroupClassRanking"].push(item.toJSON());
        }
        if (Array.isArray(this.clubSettingAgegroupClass)) {
            data["clubSettingAgegroupClass"] = [];
            for (let item of this.clubSettingAgegroupClass)
                data["clubSettingAgegroupClass"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfclubBarometerClassId1Navigation)) {
            data["dbfclubBarometerClassId1Navigation"] = [];
            for (let item of this.dbfclubBarometerClassId1Navigation)
                data["dbfclubBarometerClassId1Navigation"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfclubBarometerClassId2Navigation)) {
            data["dbfclubBarometerClassId2Navigation"] = [];
            for (let item of this.dbfclubBarometerClassId2Navigation)
                data["dbfclubBarometerClassId2Navigation"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfleagueClassificationPoints)) {
            data["dbfleagueClassificationPoints"] = [];
            for (let item of this.dbfleagueClassificationPoints)
                data["dbfleagueClassificationPoints"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfleagueDivision)) {
            data["dbfleagueDivision"] = [];
            for (let item of this.dbfleagueDivision)
                data["dbfleagueDivision"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfleagueRankingPointsYouth)) {
            data["dbfleagueRankingPointsYouth"] = [];
            for (let item of this.dbfleagueRankingPointsYouth)
                data["dbfleagueRankingPointsYouth"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfrankingListPlayerClassHighClass)) {
            data["dbfrankingListPlayerClassHighClass"] = [];
            for (let item of this.dbfrankingListPlayerClassHighClass)
                data["dbfrankingListPlayerClassHighClass"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfrankingListPlayerClassLowClass)) {
            data["dbfrankingListPlayerClassLowClass"] = [];
            for (let item of this.dbfrankingListPlayerClassLowClass)
                data["dbfrankingListPlayerClassLowClass"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfrankinglistTournamentPoints)) {
            data["dbfrankinglistTournamentPoints"] = [];
            for (let item of this.dbfrankinglistTournamentPoints)
                data["dbfrankinglistTournamentPoints"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfratingListClassIntervalHighClass)) {
            data["dbfratingListClassIntervalHighClass"] = [];
            for (let item of this.dbfratingListClassIntervalHighClass)
                data["dbfratingListClassIntervalHighClass"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfratingListClassIntervalLowClass)) {
            data["dbfratingListClassIntervalLowClass"] = [];
            for (let item of this.dbfratingListClassIntervalLowClass)
                data["dbfratingListClassIntervalLowClass"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemLicense)) {
            data["orderItemLicense"] = [];
            for (let item of this.orderItemLicense)
                data["orderItemLicense"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingList)) {
            data["rankingList"] = [];
            for (let item of this.rankingList)
                data["rankingList"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListClassInterval)) {
            data["rankingListClassInterval"] = [];
            for (let item of this.rankingListClassInterval)
                data["rankingListClassInterval"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListVersionPlayerHighClass)) {
            data["rankingListVersionPlayerHighClass"] = [];
            for (let item of this.rankingListVersionPlayerHighClass)
                data["rankingListVersionPlayerHighClass"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListVersionPlayerLowClass)) {
            data["rankingListVersionPlayerLowClass"] = [];
            for (let item of this.rankingListVersionPlayerLowClass)
                data["rankingListVersionPlayerLowClass"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentApplicationRegionAccess)) {
            data["tournamentApplicationRegionAccess"] = [];
            for (let item of this.tournamentApplicationRegionAccess)
                data["tournamentApplicationRegionAccess"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentClass1)) {
            data["tournamentClass1"] = [];
            for (let item of this.tournamentClass1)
                data["tournamentClass1"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentClassApplication)) {
            data["tournamentClassApplication"] = [];
            for (let item of this.tournamentClassApplication)
                data["tournamentClassApplication"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRoundAgeGroupClass)) {
            data["tournamentRoundAgeGroupClass"] = [];
            for (let item of this.tournamentRoundAgeGroupClass)
                data["tournamentRoundAgeGroupClass"].push(item.toJSON());
        }
        return data;
    }
}
export class AgeGroupClassRanking {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.ageGroupId = _data["ageGroupId"];
            this.classId = _data["classId"];
            this.gender = _data["gender"];
            this.lowRanking = _data["lowRanking"];
            this.highRanking = _data["highRanking"];
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.class = _data["class"] ? Class.fromJS(_data["class"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AgeGroupClassRanking();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ageGroupId"] = this.ageGroupId;
        data["classId"] = this.classId;
        data["gender"] = this.gender;
        data["lowRanking"] = this.lowRanking;
        data["highRanking"] = this.highRanking;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["class"] = this.class ? this.class.toJSON() : undefined;
        return data;
    }
}
export class ClubSettingAgegroupClass {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.agegroupId = _data["agegroupId"];
            this.classId = _data["classId"];
            this.acceptRegistrationPayments = _data["acceptRegistrationPayments"];
            this.agegroup = _data["agegroup"] ? AgeGroup.fromJS(_data["agegroup"]) : undefined;
            this.class = _data["class"] ? Class.fromJS(_data["class"]) : undefined;
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClubSettingAgegroupClass();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["agegroupId"] = this.agegroupId;
        data["classId"] = this.classId;
        data["acceptRegistrationPayments"] = this.acceptRegistrationPayments;
        data["agegroup"] = this.agegroup ? this.agegroup.toJSON() : undefined;
        data["class"] = this.class ? this.class.toJSON() : undefined;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        return data;
    }
}
export class DbfclubBarometer {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.sort = _data["sort"];
            this.groupId = _data["groupId"];
            this.level = _data["level"];
            this.text = _data["text"];
            this.sourceId = _data["sourceId"];
            this.ageClassId = _data["ageClassId"];
            this.classId1 = _data["classId1"];
            this.classId2 = _data["classId2"];
            this.tournamentType = _data["tournamentType"];
            this.minCount = _data["minCount"];
            this.url = _data["url"];
            this.clubFlagId = _data["clubFlagId"];
            this.clubVisitType = _data["clubVisitType"];
            this.classId1Navigation = _data["classId1Navigation"] ? Class.fromJS(_data["classId1Navigation"]) : undefined;
            this.classId2Navigation = _data["classId2Navigation"] ? Class.fromJS(_data["classId2Navigation"]) : undefined;
            this.clubFlag = _data["clubFlag"] ? ClubFlag.fromJS(_data["clubFlag"]) : undefined;
            if (Array.isArray(_data["dbfclubBarometerCourse"])) {
                this.dbfclubBarometerCourse = [];
                for (let item of _data["dbfclubBarometerCourse"])
                    this.dbfclubBarometerCourse.push(DbfclubBarometerCourse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfclubBarometer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sort"] = this.sort;
        data["groupId"] = this.groupId;
        data["level"] = this.level;
        data["text"] = this.text;
        data["sourceId"] = this.sourceId;
        data["ageClassId"] = this.ageClassId;
        data["classId1"] = this.classId1;
        data["classId2"] = this.classId2;
        data["tournamentType"] = this.tournamentType;
        data["minCount"] = this.minCount;
        data["url"] = this.url;
        data["clubFlagId"] = this.clubFlagId;
        data["clubVisitType"] = this.clubVisitType;
        data["classId1Navigation"] = this.classId1Navigation ? this.classId1Navigation.toJSON() : undefined;
        data["classId2Navigation"] = this.classId2Navigation ? this.classId2Navigation.toJSON() : undefined;
        data["clubFlag"] = this.clubFlag ? this.clubFlag.toJSON() : undefined;
        if (Array.isArray(this.dbfclubBarometerCourse)) {
            data["dbfclubBarometerCourse"] = [];
            for (let item of this.dbfclubBarometerCourse)
                data["dbfclubBarometerCourse"].push(item.toJSON());
        }
        return data;
    }
}
export class ClubFlag {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubFlagId = _data["clubFlagId"];
            this.unionId = _data["unionId"];
            this.name = _data["name"];
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            if (Array.isArray(_data["clubClubFlag"])) {
                this.clubClubFlag = [];
                for (let item of _data["clubClubFlag"])
                    this.clubClubFlag.push(ClubClubFlag.fromJS(item));
            }
            if (Array.isArray(_data["dbfclubBarometer"])) {
                this.dbfclubBarometer = [];
                for (let item of _data["dbfclubBarometer"])
                    this.dbfclubBarometer.push(DbfclubBarometer.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClubFlag();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubFlagId"] = this.clubFlagId;
        data["unionId"] = this.unionId;
        data["name"] = this.name;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        if (Array.isArray(this.clubClubFlag)) {
            data["clubClubFlag"] = [];
            for (let item of this.clubClubFlag)
                data["clubClubFlag"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfclubBarometer)) {
            data["dbfclubBarometer"] = [];
            for (let item of this.dbfclubBarometer)
                data["dbfclubBarometer"].push(item.toJSON());
        }
        return data;
    }
}
export class ClubClubFlag {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.clubFlagId = _data["clubFlagId"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.clubFlag = _data["clubFlag"] ? ClubFlag.fromJS(_data["clubFlag"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClubClubFlag();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["clubFlagId"] = this.clubFlagId;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["clubFlag"] = this.clubFlag ? this.clubFlag.toJSON() : undefined;
        return data;
    }
}
export class DbfclubBarometerCourse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dbfclubBarometerId = _data["dbfclubBarometerId"];
            this.courseId = _data["courseId"];
            this.course = _data["course"] ? Course.fromJS(_data["course"]) : undefined;
            this.dbfclubBarometer = _data["dbfclubBarometer"] ? DbfclubBarometer.fromJS(_data["dbfclubBarometer"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfclubBarometerCourse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dbfclubBarometerId"] = this.dbfclubBarometerId;
        data["courseId"] = this.courseId;
        data["course"] = this.course ? this.course.toJSON() : undefined;
        data["dbfclubBarometer"] = this.dbfclubBarometer ? this.dbfclubBarometer.toJSON() : undefined;
        return data;
    }
}
export class Course {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.name = _data["name"];
            this.portalId = _data["portalId"];
            this.active = _data["active"];
            this.duration = _data["duration"];
            this.groupId = _data["groupId"];
            this.ageLimit = _data["ageLimit"];
            this.showInSearchCriteria = _data["showInSearchCriteria"];
            if (Array.isArray(_data["dbfclubBarometerCourse"])) {
                this.dbfclubBarometerCourse = [];
                for (let item of _data["dbfclubBarometerCourse"])
                    this.dbfclubBarometerCourse.push(DbfclubBarometerCourse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Course();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["name"] = this.name;
        data["portalId"] = this.portalId;
        data["active"] = this.active;
        data["duration"] = this.duration;
        data["groupId"] = this.groupId;
        data["ageLimit"] = this.ageLimit;
        data["showInSearchCriteria"] = this.showInSearchCriteria;
        if (Array.isArray(this.dbfclubBarometerCourse)) {
            data["dbfclubBarometerCourse"] = [];
            for (let item of this.dbfclubBarometerCourse)
                data["dbfclubBarometerCourse"].push(item.toJSON());
        }
        return data;
    }
}
export class DbfleagueClassificationPoints {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.agegroupId = _data["agegroupId"];
            this.gender = _data["gender"];
            this.classId = _data["classId"];
            this.points = _data["points"];
            this.agegroup = _data["agegroup"] ? AgeGroup.fromJS(_data["agegroup"]) : undefined;
            this.class = _data["class"] ? Class.fromJS(_data["class"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfleagueClassificationPoints();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["agegroupId"] = this.agegroupId;
        data["gender"] = this.gender;
        data["classId"] = this.classId;
        data["points"] = this.points;
        data["agegroup"] = this.agegroup ? this.agegroup.toJSON() : undefined;
        data["class"] = this.class ? this.class.toJSON() : undefined;
        return data;
    }
}
export class DbfleagueDivision {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueDivisionId = _data["leagueDivisionId"];
            this.openAll = _data["openAll"];
            this.classId = _data["classId"];
            this.boysFrom = _data["boysFrom"];
            this.boysTo = _data["boysTo"];
            this.girlsFrom = _data["girlsFrom"];
            this.girlsTo = _data["girlsTo"];
            this.playersFrom = _data["playersFrom"];
            this.playersTo = _data["playersTo"];
            this.maxClassificationPoints = _data["maxClassificationPoints"];
            this.maxOlderPlayers = _data["maxOlderPlayers"];
            this.maxYoungerPlayers = _data["maxYoungerPlayers"];
            this.registrationDeadLine = _data["registrationDeadLine"] ? new Date(_data["registrationDeadLine"].toString()) : undefined;
            this.playerRegistration = _data["playerRegistration"];
            this.maxClassificationPointsPlayer1 = _data["maxClassificationPointsPlayer1"];
            this.maxClassificationPointsPlayer2 = _data["maxClassificationPointsPlayer2"];
            this.onlineRegistration = _data["onlineRegistration"];
            this.externalId = _data["externalId"];
            this.price = _data["price"];
            this.hideRoundDateInMatchList = _data["hideRoundDateInMatchList"];
            this.allowDuplicatePlayers = _data["allowDuplicatePlayers"];
            this.allowByPassErrors = _data["allowByPassErrors"];
            this.optionsTournamentId = _data["optionsTournamentId"];
            this.onlinePayment = _data["onlinePayment"];
            this.showCommentField = _data["showCommentField"];
            this.class = _data["class"] ? Class.fromJS(_data["class"]) : undefined;
            this.leagueDivision = _data["leagueDivision"] ? LeagueDivision.fromJS(_data["leagueDivision"]) : undefined;
            this.optionsTournament = _data["optionsTournament"] ? Tournament1.fromJS(_data["optionsTournament"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfleagueDivision();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueDivisionId"] = this.leagueDivisionId;
        data["openAll"] = this.openAll;
        data["classId"] = this.classId;
        data["boysFrom"] = this.boysFrom;
        data["boysTo"] = this.boysTo;
        data["girlsFrom"] = this.girlsFrom;
        data["girlsTo"] = this.girlsTo;
        data["playersFrom"] = this.playersFrom;
        data["playersTo"] = this.playersTo;
        data["maxClassificationPoints"] = this.maxClassificationPoints;
        data["maxOlderPlayers"] = this.maxOlderPlayers;
        data["maxYoungerPlayers"] = this.maxYoungerPlayers;
        data["registrationDeadLine"] = this.registrationDeadLine ? this.registrationDeadLine.toISOString() : undefined;
        data["playerRegistration"] = this.playerRegistration;
        data["maxClassificationPointsPlayer1"] = this.maxClassificationPointsPlayer1;
        data["maxClassificationPointsPlayer2"] = this.maxClassificationPointsPlayer2;
        data["onlineRegistration"] = this.onlineRegistration;
        data["externalId"] = this.externalId;
        data["price"] = this.price;
        data["hideRoundDateInMatchList"] = this.hideRoundDateInMatchList;
        data["allowDuplicatePlayers"] = this.allowDuplicatePlayers;
        data["allowByPassErrors"] = this.allowByPassErrors;
        data["optionsTournamentId"] = this.optionsTournamentId;
        data["onlinePayment"] = this.onlinePayment;
        data["showCommentField"] = this.showCommentField;
        data["class"] = this.class ? this.class.toJSON() : undefined;
        data["leagueDivision"] = this.leagueDivision ? this.leagueDivision.toJSON() : undefined;
        data["optionsTournament"] = this.optionsTournament ? this.optionsTournament.toJSON() : undefined;
        return data;
    }
}
export class LeagueDivision {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueDivisionId = _data["leagueDivisionId"];
            this.seasonId = _data["seasonId"];
            this.name = _data["name"];
            this.ageGroupId = _data["ageGroupId"];
            this.roundLeagueSchemaId = _data["roundLeagueSchemaId"];
            this.firstRoundIndex = _data["firstRoundIndex"];
            this.matchPointsLeagueSchemaId = _data["matchPointsLeagueSchemaId"];
            this.standingsRuleLeagueSchemaId = _data["standingsRuleLeagueSchemaId"];
            this.teamLeagueSchemaId = _data["teamLeagueSchemaId"];
            this.rankingPointsLeagueSchemaId = _data["rankingPointsLeagueSchemaId"];
            this.individualMatchResults = _data["individualMatchResults"];
            this.playerLicenseRequired = _data["playerLicenseRequired"];
            this.public = _data["public"];
            this.updatedByUserId = _data["updatedByUserId"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : undefined;
            this.isPlayOff = _data["isPlayOff"];
            this.solidLine1 = _data["solidLine1"];
            this.solidLine2 = _data["solidLine2"];
            this.dashedLine1 = _data["dashedLine1"];
            this.dashedLine2 = _data["dashedLine2"];
            this.relegatedCount = _data["relegatedCount"];
            this.sortKey = _data["sortKey"];
            this.matchTimeRegistrationOpen = _data["matchTimeRegistrationOpen"];
            this.matchResultRegistrationOpen = _data["matchResultRegistrationOpen"];
            this.maxSets = _data["maxSets"];
            this.matchPointsRuleId = _data["matchPointsRuleId"];
            this.minMatchDate = _data["minMatchDate"] ? new Date(_data["minMatchDate"].toString()) : undefined;
            this.maxMatchDate = _data["maxMatchDate"] ? new Date(_data["maxMatchDate"].toString()) : undefined;
            this.liveScoreSubscribersOnly = _data["liveScoreSubscribersOnly"];
            this.liveScoreEnabled = _data["liveScoreEnabled"];
            this.separateTeamRegistration = _data["separateTeamRegistration"];
            this.teamsPublicMinutes = _data["teamsPublicMinutes"];
            this.divisionType = _data["divisionType"];
            this.maxTopList = _data["maxTopList"];
            this.rankingPointsEnabled = _data["rankingPointsEnabled"];
            this.password = _data["password"];
            this.matchTimeRegistrationOpenLastDate = _data["matchTimeRegistrationOpenLastDate"] ? new Date(_data["matchTimeRegistrationOpenLastDate"].toString()) : undefined;
            this.matchResultAutosortPlayersEnabled = _data["matchResultAutosortPlayersEnabled"];
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.matchPointsLeagueSchema = _data["matchPointsLeagueSchema"] ? LeagueSchema.fromJS(_data["matchPointsLeagueSchema"]) : undefined;
            this.rankingPointsLeagueSchema = _data["rankingPointsLeagueSchema"] ? LeagueSchema.fromJS(_data["rankingPointsLeagueSchema"]) : undefined;
            this.roundLeagueSchema = _data["roundLeagueSchema"] ? LeagueSchema.fromJS(_data["roundLeagueSchema"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
            this.standingsRuleLeagueSchema = _data["standingsRuleLeagueSchema"] ? LeagueSchema.fromJS(_data["standingsRuleLeagueSchema"]) : undefined;
            this.teamLeagueSchema = _data["teamLeagueSchema"] ? LeagueSchema.fromJS(_data["teamLeagueSchema"]) : undefined;
            this.updatedByUser = _data["updatedByUser"] ? User1.fromJS(_data["updatedByUser"]) : undefined;
            this.dbfleagueDivision = _data["dbfleagueDivision"] ? DbfleagueDivision.fromJS(_data["dbfleagueDivision"]) : undefined;
            if (Array.isArray(_data["dbforderItemLeagueRegistrationTeam"])) {
                this.dbforderItemLeagueRegistrationTeam = [];
                for (let item of _data["dbforderItemLeagueRegistrationTeam"])
                    this.dbforderItemLeagueRegistrationTeam.push(DbforderItemLeagueRegistrationTeam.fromJS(item));
            }
            if (Array.isArray(_data["leagueDivisionRegion"])) {
                this.leagueDivisionRegion = [];
                for (let item of _data["leagueDivisionRegion"])
                    this.leagueDivisionRegion.push(LeagueDivisionRegion.fromJS(item));
            }
            if (Array.isArray(_data["leagueGroup"])) {
                this.leagueGroup = [];
                for (let item of _data["leagueGroup"])
                    this.leagueGroup.push(LeagueGroup.fromJS(item));
            }
            if (Array.isArray(_data["leagueRegistrationTeam"])) {
                this.leagueRegistrationTeam = [];
                for (let item of _data["leagueRegistrationTeam"])
                    this.leagueRegistrationTeam.push(LeagueRegistrationTeam.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueDivision();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueDivisionId"] = this.leagueDivisionId;
        data["seasonId"] = this.seasonId;
        data["name"] = this.name;
        data["ageGroupId"] = this.ageGroupId;
        data["roundLeagueSchemaId"] = this.roundLeagueSchemaId;
        data["firstRoundIndex"] = this.firstRoundIndex;
        data["matchPointsLeagueSchemaId"] = this.matchPointsLeagueSchemaId;
        data["standingsRuleLeagueSchemaId"] = this.standingsRuleLeagueSchemaId;
        data["teamLeagueSchemaId"] = this.teamLeagueSchemaId;
        data["rankingPointsLeagueSchemaId"] = this.rankingPointsLeagueSchemaId;
        data["individualMatchResults"] = this.individualMatchResults;
        data["playerLicenseRequired"] = this.playerLicenseRequired;
        data["public"] = this.public;
        data["updatedByUserId"] = this.updatedByUserId;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : undefined;
        data["isPlayOff"] = this.isPlayOff;
        data["solidLine1"] = this.solidLine1;
        data["solidLine2"] = this.solidLine2;
        data["dashedLine1"] = this.dashedLine1;
        data["dashedLine2"] = this.dashedLine2;
        data["relegatedCount"] = this.relegatedCount;
        data["sortKey"] = this.sortKey;
        data["matchTimeRegistrationOpen"] = this.matchTimeRegistrationOpen;
        data["matchResultRegistrationOpen"] = this.matchResultRegistrationOpen;
        data["maxSets"] = this.maxSets;
        data["matchPointsRuleId"] = this.matchPointsRuleId;
        data["minMatchDate"] = this.minMatchDate ? this.minMatchDate.toISOString() : undefined;
        data["maxMatchDate"] = this.maxMatchDate ? this.maxMatchDate.toISOString() : undefined;
        data["liveScoreSubscribersOnly"] = this.liveScoreSubscribersOnly;
        data["liveScoreEnabled"] = this.liveScoreEnabled;
        data["separateTeamRegistration"] = this.separateTeamRegistration;
        data["teamsPublicMinutes"] = this.teamsPublicMinutes;
        data["divisionType"] = this.divisionType;
        data["maxTopList"] = this.maxTopList;
        data["rankingPointsEnabled"] = this.rankingPointsEnabled;
        data["password"] = this.password;
        data["matchTimeRegistrationOpenLastDate"] = this.matchTimeRegistrationOpenLastDate ? this.matchTimeRegistrationOpenLastDate.toISOString() : undefined;
        data["matchResultAutosortPlayersEnabled"] = this.matchResultAutosortPlayersEnabled;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["matchPointsLeagueSchema"] = this.matchPointsLeagueSchema ? this.matchPointsLeagueSchema.toJSON() : undefined;
        data["rankingPointsLeagueSchema"] = this.rankingPointsLeagueSchema ? this.rankingPointsLeagueSchema.toJSON() : undefined;
        data["roundLeagueSchema"] = this.roundLeagueSchema ? this.roundLeagueSchema.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        data["standingsRuleLeagueSchema"] = this.standingsRuleLeagueSchema ? this.standingsRuleLeagueSchema.toJSON() : undefined;
        data["teamLeagueSchema"] = this.teamLeagueSchema ? this.teamLeagueSchema.toJSON() : undefined;
        data["updatedByUser"] = this.updatedByUser ? this.updatedByUser.toJSON() : undefined;
        data["dbfleagueDivision"] = this.dbfleagueDivision ? this.dbfleagueDivision.toJSON() : undefined;
        if (Array.isArray(this.dbforderItemLeagueRegistrationTeam)) {
            data["dbforderItemLeagueRegistrationTeam"] = [];
            for (let item of this.dbforderItemLeagueRegistrationTeam)
                data["dbforderItemLeagueRegistrationTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueDivisionRegion)) {
            data["leagueDivisionRegion"] = [];
            for (let item of this.leagueDivisionRegion)
                data["leagueDivisionRegion"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueGroup)) {
            data["leagueGroup"] = [];
            for (let item of this.leagueGroup)
                data["leagueGroup"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueRegistrationTeam)) {
            data["leagueRegistrationTeam"] = [];
            for (let item of this.leagueRegistrationTeam)
                data["leagueRegistrationTeam"].push(item.toJSON());
        }
        return data;
    }
}
export class LeagueSchema {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueSchemaId = _data["leagueSchemaId"];
            this.unionId = _data["unionId"];
            this.schemaType = _data["schemaType"];
            this.seasonId = _data["seasonId"];
            this.regionId = _data["regionId"];
            this.name = _data["name"];
            this.options = _data["options"];
            this.updateByUserId = _data["updateByUserId"];
            this.updatedTime = _data["updatedTime"] ? new Date(_data["updatedTime"].toString()) : undefined;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            this.updateByUser = _data["updateByUser"] ? User1.fromJS(_data["updateByUser"]) : undefined;
            if (Array.isArray(_data["leagueDivisionMatchPointsLeagueSchema"])) {
                this.leagueDivisionMatchPointsLeagueSchema = [];
                for (let item of _data["leagueDivisionMatchPointsLeagueSchema"])
                    this.leagueDivisionMatchPointsLeagueSchema.push(LeagueDivision.fromJS(item));
            }
            if (Array.isArray(_data["leagueDivisionRankingPointsLeagueSchema"])) {
                this.leagueDivisionRankingPointsLeagueSchema = [];
                for (let item of _data["leagueDivisionRankingPointsLeagueSchema"])
                    this.leagueDivisionRankingPointsLeagueSchema.push(LeagueDivision.fromJS(item));
            }
            if (Array.isArray(_data["leagueDivisionRoundLeagueSchema"])) {
                this.leagueDivisionRoundLeagueSchema = [];
                for (let item of _data["leagueDivisionRoundLeagueSchema"])
                    this.leagueDivisionRoundLeagueSchema.push(LeagueDivision.fromJS(item));
            }
            if (Array.isArray(_data["leagueDivisionStandingsRuleLeagueSchema"])) {
                this.leagueDivisionStandingsRuleLeagueSchema = [];
                for (let item of _data["leagueDivisionStandingsRuleLeagueSchema"])
                    this.leagueDivisionStandingsRuleLeagueSchema.push(LeagueDivision.fromJS(item));
            }
            if (Array.isArray(_data["leagueDivisionTeamLeagueSchema"])) {
                this.leagueDivisionTeamLeagueSchema = [];
                for (let item of _data["leagueDivisionTeamLeagueSchema"])
                    this.leagueDivisionTeamLeagueSchema.push(LeagueDivision.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchPlanSchema"])) {
                this.leagueMatchPlanSchema = [];
                for (let item of _data["leagueMatchPlanSchema"])
                    this.leagueMatchPlanSchema.push(LeagueMatchPlanSchema.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatchPoints"])) {
                this.leagueMatchPoints = [];
                for (let item of _data["leagueMatchPoints"])
                    this.leagueMatchPoints.push(LeagueMatchPoints.fromJS(item));
            }
            if (Array.isArray(_data["leagueRankingPoints"])) {
                this.leagueRankingPoints = [];
                for (let item of _data["leagueRankingPoints"])
                    this.leagueRankingPoints.push(LeagueRankingPoints.fromJS(item));
            }
            if (Array.isArray(_data["leagueRound"])) {
                this.leagueRound = [];
                for (let item of _data["leagueRound"])
                    this.leagueRound.push(LeagueRound.fromJS(item));
            }
            if (Array.isArray(_data["leagueStandingsRule"])) {
                this.leagueStandingsRule = [];
                for (let item of _data["leagueStandingsRule"])
                    this.leagueStandingsRule.push(LeagueStandingsRule.fromJS(item));
            }
            if (Array.isArray(_data["leagueTeamSchemaMatch"])) {
                this.leagueTeamSchemaMatch = [];
                for (let item of _data["leagueTeamSchemaMatch"])
                    this.leagueTeamSchemaMatch.push(LeagueTeamSchemaMatch.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueSchema();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueSchemaId"] = this.leagueSchemaId;
        data["unionId"] = this.unionId;
        data["schemaType"] = this.schemaType;
        data["seasonId"] = this.seasonId;
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        data["options"] = this.options;
        data["updateByUserId"] = this.updateByUserId;
        data["updatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : undefined;
        data["region"] = this.region ? this.region.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        data["updateByUser"] = this.updateByUser ? this.updateByUser.toJSON() : undefined;
        if (Array.isArray(this.leagueDivisionMatchPointsLeagueSchema)) {
            data["leagueDivisionMatchPointsLeagueSchema"] = [];
            for (let item of this.leagueDivisionMatchPointsLeagueSchema)
                data["leagueDivisionMatchPointsLeagueSchema"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueDivisionRankingPointsLeagueSchema)) {
            data["leagueDivisionRankingPointsLeagueSchema"] = [];
            for (let item of this.leagueDivisionRankingPointsLeagueSchema)
                data["leagueDivisionRankingPointsLeagueSchema"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueDivisionRoundLeagueSchema)) {
            data["leagueDivisionRoundLeagueSchema"] = [];
            for (let item of this.leagueDivisionRoundLeagueSchema)
                data["leagueDivisionRoundLeagueSchema"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueDivisionStandingsRuleLeagueSchema)) {
            data["leagueDivisionStandingsRuleLeagueSchema"] = [];
            for (let item of this.leagueDivisionStandingsRuleLeagueSchema)
                data["leagueDivisionStandingsRuleLeagueSchema"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueDivisionTeamLeagueSchema)) {
            data["leagueDivisionTeamLeagueSchema"] = [];
            for (let item of this.leagueDivisionTeamLeagueSchema)
                data["leagueDivisionTeamLeagueSchema"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchPlanSchema)) {
            data["leagueMatchPlanSchema"] = [];
            for (let item of this.leagueMatchPlanSchema)
                data["leagueMatchPlanSchema"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatchPoints)) {
            data["leagueMatchPoints"] = [];
            for (let item of this.leagueMatchPoints)
                data["leagueMatchPoints"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueRankingPoints)) {
            data["leagueRankingPoints"] = [];
            for (let item of this.leagueRankingPoints)
                data["leagueRankingPoints"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueRound)) {
            data["leagueRound"] = [];
            for (let item of this.leagueRound)
                data["leagueRound"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueStandingsRule)) {
            data["leagueStandingsRule"] = [];
            for (let item of this.leagueStandingsRule)
                data["leagueStandingsRule"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueTeamSchemaMatch)) {
            data["leagueTeamSchemaMatch"] = [];
            for (let item of this.leagueTeamSchemaMatch)
                data["leagueTeamSchemaMatch"].push(item.toJSON());
        }
        return data;
    }
}
export class Region {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.regionId = _data["regionId"];
            this.unionId = _data["unionId"];
            this.parentRegionId = _data["parentRegionId"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.code = _data["code"];
            this.clubId = _data["clubId"];
            this.tournament = _data["tournament"];
            this.league = _data["league"];
            this.club = _data["club"];
            this.regionAdministration = _data["regionAdministration"];
            this.tournamentRoundsOnly = _data["tournamentRoundsOnly"];
            this.geoRegionId = _data["geoRegionId"];
            this.clubNavigation = _data["clubNavigation"] ? Club2.fromJS(_data["clubNavigation"]) : undefined;
            this.geoRegion = _data["geoRegion"] ? GeoRegion.fromJS(_data["geoRegion"]) : undefined;
            this.parentRegion = _data["parentRegion"] ? Region.fromJS(_data["parentRegion"]) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            if (Array.isArray(_data["clubRegion"])) {
                this.clubRegion = [];
                for (let item of _data["clubRegion"])
                    this.clubRegion.push(ClubRegion.fromJS(item));
            }
            if (Array.isArray(_data["dbforderItemTmpUnionMember"])) {
                this.dbforderItemTmpUnionMember = [];
                for (let item of _data["dbforderItemTmpUnionMember"])
                    this.dbforderItemTmpUnionMember.push(DbforderItemTmpUnionMember.fromJS(item));
            }
            if (Array.isArray(_data["dbftmpUnionMember"])) {
                this.dbftmpUnionMember = [];
                for (let item of _data["dbftmpUnionMember"])
                    this.dbftmpUnionMember.push(DbftmpUnionMember.fromJS(item));
            }
            if (Array.isArray(_data["inverseParentRegion"])) {
                this.inverseParentRegion = [];
                for (let item of _data["inverseParentRegion"])
                    this.inverseParentRegion.push(Region.fromJS(item));
            }
            if (Array.isArray(_data["leagueDivisionRegion"])) {
                this.leagueDivisionRegion = [];
                for (let item of _data["leagueDivisionRegion"])
                    this.leagueDivisionRegion.push(LeagueDivisionRegion.fromJS(item));
            }
            if (Array.isArray(_data["leagueSchema"])) {
                this.leagueSchema = [];
                for (let item of _data["leagueSchema"])
                    this.leagueSchema.push(LeagueSchema.fromJS(item));
            }
            if (Array.isArray(_data["leagueTeam"])) {
                this.leagueTeam = [];
                for (let item of _data["leagueTeam"])
                    this.leagueTeam.push(LeagueTeam.fromJS(item));
            }
            if (Array.isArray(_data["tournament1"])) {
                this.tournament1 = [];
                for (let item of _data["tournament1"])
                    this.tournament1.push(Tournament1.fromJS(item));
            }
            if (Array.isArray(_data["tournamentApplicationRegionAccess"])) {
                this.tournamentApplicationRegionAccess = [];
                for (let item of _data["tournamentApplicationRegionAccess"])
                    this.tournamentApplicationRegionAccess.push(TournamentApplicationRegionAccess.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRegion"])) {
                this.tournamentRegion = [];
                for (let item of _data["tournamentRegion"])
                    this.tournamentRegion.push(TournamentRegion.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Region();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["unionId"] = this.unionId;
        data["parentRegionId"] = this.parentRegionId;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["code"] = this.code;
        data["clubId"] = this.clubId;
        data["tournament"] = this.tournament;
        data["league"] = this.league;
        data["club"] = this.club;
        data["regionAdministration"] = this.regionAdministration;
        data["tournamentRoundsOnly"] = this.tournamentRoundsOnly;
        data["geoRegionId"] = this.geoRegionId;
        data["clubNavigation"] = this.clubNavigation ? this.clubNavigation.toJSON() : undefined;
        data["geoRegion"] = this.geoRegion ? this.geoRegion.toJSON() : undefined;
        data["parentRegion"] = this.parentRegion ? this.parentRegion.toJSON() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        if (Array.isArray(this.clubRegion)) {
            data["clubRegion"] = [];
            for (let item of this.clubRegion)
                data["clubRegion"].push(item.toJSON());
        }
        if (Array.isArray(this.dbforderItemTmpUnionMember)) {
            data["dbforderItemTmpUnionMember"] = [];
            for (let item of this.dbforderItemTmpUnionMember)
                data["dbforderItemTmpUnionMember"].push(item.toJSON());
        }
        if (Array.isArray(this.dbftmpUnionMember)) {
            data["dbftmpUnionMember"] = [];
            for (let item of this.dbftmpUnionMember)
                data["dbftmpUnionMember"].push(item.toJSON());
        }
        if (Array.isArray(this.inverseParentRegion)) {
            data["inverseParentRegion"] = [];
            for (let item of this.inverseParentRegion)
                data["inverseParentRegion"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueDivisionRegion)) {
            data["leagueDivisionRegion"] = [];
            for (let item of this.leagueDivisionRegion)
                data["leagueDivisionRegion"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueSchema)) {
            data["leagueSchema"] = [];
            for (let item of this.leagueSchema)
                data["leagueSchema"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueTeam)) {
            data["leagueTeam"] = [];
            for (let item of this.leagueTeam)
                data["leagueTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.tournament1)) {
            data["tournament1"] = [];
            for (let item of this.tournament1)
                data["tournament1"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentApplicationRegionAccess)) {
            data["tournamentApplicationRegionAccess"] = [];
            for (let item of this.tournamentApplicationRegionAccess)
                data["tournamentApplicationRegionAccess"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRegion)) {
            data["tournamentRegion"] = [];
            for (let item of this.tournamentRegion)
                data["tournamentRegion"].push(item.toJSON());
        }
        return data;
    }
}
export class GeoRegion {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.geoRegionId = _data["geoRegionId"];
            this.unionId = _data["unionId"];
            this.name = _data["name"];
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            if (Array.isArray(_data["region"])) {
                this.region = [];
                for (let item of _data["region"])
                    this.region.push(Region.fromJS(item));
            }
            if (Array.isArray(_data["tournament1"])) {
                this.tournament1 = [];
                for (let item of _data["tournament1"])
                    this.tournament1.push(Tournament1.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GeoRegion();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["geoRegionId"] = this.geoRegionId;
        data["unionId"] = this.unionId;
        data["name"] = this.name;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        if (Array.isArray(this.region)) {
            data["region"] = [];
            for (let item of this.region)
                data["region"].push(item.toJSON());
        }
        if (Array.isArray(this.tournament1)) {
            data["tournament1"] = [];
            for (let item of this.tournament1)
                data["tournament1"].push(item.toJSON());
        }
        return data;
    }
}
export class Tournament1 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentId = _data["tournamentId"];
            this.seasonId = _data["seasonId"];
            this.clubId = _data["clubId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined;
            this.tournamentNumber = _data["tournamentNumber"];
            this.title = _data["title"];
            this.lastRegistration = _data["lastRegistration"] ? new Date(_data["lastRegistration"].toString()) : undefined;
            this.tournamentState = _data["tournamentState"];
            this.exportUnionName = _data["exportUnionName"];
            this.tournamentType = _data["tournamentType"];
            this.contactName = _data["contactName"];
            this.contactAddress = _data["contactAddress"];
            this.contactCity = _data["contactCity"];
            this.contactPostalCode = _data["contactPostalCode"];
            this.contactCountryCode = _data["contactCountryCode"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.urlinvitation = _data["urlinvitation"];
            this.urlprogram = _data["urlprogram"];
            this.registrationOpen = _data["registrationOpen"];
            this.updatedByUserId = _data["updatedByUserId"];
            this.updatedTime = _data["updatedTime"] ? new Date(_data["updatedTime"].toString()) : undefined;
            this.maxEvents = _data["maxEvents"];
            this.roundId = _data["roundId"];
            this.regionId = _data["regionId"];
            this.contactPhoneMobile = _data["contactPhoneMobile"];
            this.contactPhoneWork = _data["contactPhoneWork"];
            this.fixedPrice = _data["fixedPrice"];
            this.resultState = _data["resultState"];
            this.managedByRegion = _data["managedByRegion"];
            this.leaderRequired = _data["leaderRequired"];
            this.optionFields = _data["optionFields"];
            this.leader = _data["leader"];
            this.leaderPrice = _data["leaderPrice"];
            this.hidePublicSeasonPlan = _data["hidePublicSeasonPlan"];
            this.showInternalSeasonPlan = _data["showInternalSeasonPlan"];
            this.hideSearchResult = _data["hideSearchResult"];
            this.noAdministrationFee = _data["noAdministrationFee"];
            this.info = _data["info"];
            this.externalId = _data["externalId"];
            this.geoRegionId = _data["geoRegionId"];
            this.registrationLocked = _data["registrationLocked"];
            this.invitationPdf = _data["invitationPdf"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.geoRegion = _data["geoRegion"] ? GeoRegion.fromJS(_data["geoRegion"]) : undefined;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined;
            this.tournamentRound = _data["tournamentRound"] ? TournamentRound.fromJS(_data["tournamentRound"]) : undefined;
            this.updatedByUser = _data["updatedByUser"] ? User1.fromJS(_data["updatedByUser"]) : undefined;
            this.liveScoreTournament = _data["liveScoreTournament"] ? LiveScoreTournament.fromJS(_data["liveScoreTournament"]) : undefined;
            this.tournamentApplication = _data["tournamentApplication"] ? TournamentApplication.fromJS(_data["tournamentApplication"]) : undefined;
            if (Array.isArray(_data["dbfleagueDivision"])) {
                this.dbfleagueDivision = [];
                for (let item of _data["dbfleagueDivision"])
                    this.dbfleagueDivision.push(DbfleagueDivision.fromJS(item));
            }
            if (Array.isArray(_data["dbfrankingListPlayerExternPoint"])) {
                this.dbfrankingListPlayerExternPoint = [];
                for (let item of _data["dbfrankingListPlayerExternPoint"])
                    this.dbfrankingListPlayerExternPoint.push(DbfrankingListPlayerExternPoint.fromJS(item));
            }
            if (Array.isArray(_data["orderItemRegistrationOption"])) {
                this.orderItemRegistrationOption = [];
                for (let item of _data["orderItemRegistrationOption"])
                    this.orderItemRegistrationOption.push(OrderItemRegistrationOption.fromJS(item));
            }
            if (Array.isArray(_data["playerDeleted"])) {
                this.playerDeleted = [];
                for (let item of _data["playerDeleted"])
                    this.playerDeleted.push(PlayerDeleted.fromJS(item));
            }
            if (Array.isArray(_data["tournamentClass1"])) {
                this.tournamentClass1 = [];
                for (let item of _data["tournamentClass1"])
                    this.tournamentClass1.push(TournamentClass1.fromJS(item));
            }
            if (Array.isArray(_data["tournamentClassApplication"])) {
                this.tournamentClassApplication = [];
                for (let item of _data["tournamentClassApplication"])
                    this.tournamentClassApplication.push(TournamentClassApplication.fromJS(item));
            }
            if (Array.isArray(_data["tournamentImportBatch"])) {
                this.tournamentImportBatch = [];
                for (let item of _data["tournamentImportBatch"])
                    this.tournamentImportBatch.push(TournamentImportBatch.fromJS(item));
            }
            if (Array.isArray(_data["tournamentImportPlayer"])) {
                this.tournamentImportPlayer = [];
                for (let item of _data["tournamentImportPlayer"])
                    this.tournamentImportPlayer.push(TournamentImportPlayer.fromJS(item));
            }
            if (Array.isArray(_data["tournamentLateRegistrationUser"])) {
                this.tournamentLateRegistrationUser = [];
                for (let item of _data["tournamentLateRegistrationUser"])
                    this.tournamentLateRegistrationUser.push(TournamentLateRegistrationUser.fromJS(item));
            }
            if (Array.isArray(_data["tournamentMessage"])) {
                this.tournamentMessage = [];
                for (let item of _data["tournamentMessage"])
                    this.tournamentMessage.push(TournamentMessage.fromJS(item));
            }
            if (Array.isArray(_data["tournamentOptionField"])) {
                this.tournamentOptionField = [];
                for (let item of _data["tournamentOptionField"])
                    this.tournamentOptionField.push(TournamentOptionField.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRegion"])) {
                this.tournamentRegion = [];
                for (let item of _data["tournamentRegion"])
                    this.tournamentRegion.push(TournamentRegion.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Tournament1();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentId"] = this.tournamentId;
        data["seasonId"] = this.seasonId;
        data["clubId"] = this.clubId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined;
        data["tournamentNumber"] = this.tournamentNumber;
        data["title"] = this.title;
        data["lastRegistration"] = this.lastRegistration ? this.lastRegistration.toISOString() : undefined;
        data["tournamentState"] = this.tournamentState;
        data["exportUnionName"] = this.exportUnionName;
        data["tournamentType"] = this.tournamentType;
        data["contactName"] = this.contactName;
        data["contactAddress"] = this.contactAddress;
        data["contactCity"] = this.contactCity;
        data["contactPostalCode"] = this.contactPostalCode;
        data["contactCountryCode"] = this.contactCountryCode;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["urlinvitation"] = this.urlinvitation;
        data["urlprogram"] = this.urlprogram;
        data["registrationOpen"] = this.registrationOpen;
        data["updatedByUserId"] = this.updatedByUserId;
        data["updatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : undefined;
        data["maxEvents"] = this.maxEvents;
        data["roundId"] = this.roundId;
        data["regionId"] = this.regionId;
        data["contactPhoneMobile"] = this.contactPhoneMobile;
        data["contactPhoneWork"] = this.contactPhoneWork;
        data["fixedPrice"] = this.fixedPrice;
        data["resultState"] = this.resultState;
        data["managedByRegion"] = this.managedByRegion;
        data["leaderRequired"] = this.leaderRequired;
        data["optionFields"] = this.optionFields;
        data["leader"] = this.leader;
        data["leaderPrice"] = this.leaderPrice;
        data["hidePublicSeasonPlan"] = this.hidePublicSeasonPlan;
        data["showInternalSeasonPlan"] = this.showInternalSeasonPlan;
        data["hideSearchResult"] = this.hideSearchResult;
        data["noAdministrationFee"] = this.noAdministrationFee;
        data["info"] = this.info;
        data["externalId"] = this.externalId;
        data["geoRegionId"] = this.geoRegionId;
        data["registrationLocked"] = this.registrationLocked;
        data["invitationPdf"] = this.invitationPdf;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["geoRegion"] = this.geoRegion ? this.geoRegion.toJSON() : undefined;
        data["region"] = this.region ? this.region.toJSON() : undefined;
        data["tournamentRound"] = this.tournamentRound ? this.tournamentRound.toJSON() : undefined;
        data["updatedByUser"] = this.updatedByUser ? this.updatedByUser.toJSON() : undefined;
        data["liveScoreTournament"] = this.liveScoreTournament ? this.liveScoreTournament.toJSON() : undefined;
        data["tournamentApplication"] = this.tournamentApplication ? this.tournamentApplication.toJSON() : undefined;
        if (Array.isArray(this.dbfleagueDivision)) {
            data["dbfleagueDivision"] = [];
            for (let item of this.dbfleagueDivision)
                data["dbfleagueDivision"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfrankingListPlayerExternPoint)) {
            data["dbfrankingListPlayerExternPoint"] = [];
            for (let item of this.dbfrankingListPlayerExternPoint)
                data["dbfrankingListPlayerExternPoint"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemRegistrationOption)) {
            data["orderItemRegistrationOption"] = [];
            for (let item of this.orderItemRegistrationOption)
                data["orderItemRegistrationOption"].push(item.toJSON());
        }
        if (Array.isArray(this.playerDeleted)) {
            data["playerDeleted"] = [];
            for (let item of this.playerDeleted)
                data["playerDeleted"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentClass1)) {
            data["tournamentClass1"] = [];
            for (let item of this.tournamentClass1)
                data["tournamentClass1"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentClassApplication)) {
            data["tournamentClassApplication"] = [];
            for (let item of this.tournamentClassApplication)
                data["tournamentClassApplication"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentImportBatch)) {
            data["tournamentImportBatch"] = [];
            for (let item of this.tournamentImportBatch)
                data["tournamentImportBatch"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentImportPlayer)) {
            data["tournamentImportPlayer"] = [];
            for (let item of this.tournamentImportPlayer)
                data["tournamentImportPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentLateRegistrationUser)) {
            data["tournamentLateRegistrationUser"] = [];
            for (let item of this.tournamentLateRegistrationUser)
                data["tournamentLateRegistrationUser"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentMessage)) {
            data["tournamentMessage"] = [];
            for (let item of this.tournamentMessage)
                data["tournamentMessage"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentOptionField)) {
            data["tournamentOptionField"] = [];
            for (let item of this.tournamentOptionField)
                data["tournamentOptionField"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRegion)) {
            data["tournamentRegion"] = [];
            for (let item of this.tournamentRegion)
                data["tournamentRegion"].push(item.toJSON());
        }
        return data;
    }
}
export class TournamentRound {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.seasonId = _data["seasonId"];
            this.roundId = _data["roundId"];
            this.weekNo = _data["weekNo"];
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
            if (Array.isArray(_data["tournament1"])) {
                this.tournament1 = [];
                for (let item of _data["tournament1"])
                    this.tournament1.push(Tournament1.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRoundAgeGroupClass"])) {
                this.tournamentRoundAgeGroupClass = [];
                for (let item of _data["tournamentRoundAgeGroupClass"])
                    this.tournamentRoundAgeGroupClass.push(TournamentRoundAgeGroupClass.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentRound();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["seasonId"] = this.seasonId;
        data["roundId"] = this.roundId;
        data["weekNo"] = this.weekNo;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        if (Array.isArray(this.tournament1)) {
            data["tournament1"] = [];
            for (let item of this.tournament1)
                data["tournament1"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRoundAgeGroupClass)) {
            data["tournamentRoundAgeGroupClass"] = [];
            for (let item of this.tournamentRoundAgeGroupClass)
                data["tournamentRoundAgeGroupClass"].push(item.toJSON());
        }
        return data;
    }
}
export class Season {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.seasonId = _data["seasonId"];
            this.unionId = _data["unionId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.tournamentApplicationOpen = _data["tournamentApplicationOpen"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined;
            this.tournamentApplicationShowStatus = _data["tournamentApplicationShowStatus"];
            this.tournamentApplicationNotifications = _data["tournamentApplicationNotifications"];
            this.tournamentApplication = _data["tournamentApplication"];
            this.leagueAdministration = _data["leagueAdministration"];
            this.seasonPlan = _data["seasonPlan"];
            this.leagueResults = _data["leagueResults"];
            this.ranking = _data["ranking"];
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            if (Array.isArray(_data["dbfclubMemberFee"])) {
                this.dbfclubMemberFee = [];
                for (let item of _data["dbfclubMemberFee"])
                    this.dbfclubMemberFee.push(DbfclubMemberFee.fromJS(item));
            }
            if (Array.isArray(_data["dbforderItemClubFee"])) {
                this.dbforderItemClubFee = [];
                for (let item of _data["dbforderItemClubFee"])
                    this.dbforderItemClubFee.push(DbforderItemClubFee.fromJS(item));
            }
            if (Array.isArray(_data["dbforderItemTmpUnionMember"])) {
                this.dbforderItemTmpUnionMember = [];
                for (let item of _data["dbforderItemTmpUnionMember"])
                    this.dbforderItemTmpUnionMember.push(DbforderItemTmpUnionMember.fromJS(item));
            }
            if (Array.isArray(_data["dbfplayerRankingReplacement"])) {
                this.dbfplayerRankingReplacement = [];
                for (let item of _data["dbfplayerRankingReplacement"])
                    this.dbfplayerRankingReplacement.push(DbfplayerRankingReplacement.fromJS(item));
            }
            if (Array.isArray(_data["dbfrankingListPlayerExternPoint"])) {
                this.dbfrankingListPlayerExternPoint = [];
                for (let item of _data["dbfrankingListPlayerExternPoint"])
                    this.dbfrankingListPlayerExternPoint.push(DbfrankingListPlayerExternPoint.fromJS(item));
            }
            if (Array.isArray(_data["dbfrankingListPlayerPoint"])) {
                this.dbfrankingListPlayerPoint = [];
                for (let item of _data["dbfrankingListPlayerPoint"])
                    this.dbfrankingListPlayerPoint.push(DbfrankingListPlayerPoint.fromJS(item));
            }
            if (Array.isArray(_data["dbfrankingListPlayerPointLeague"])) {
                this.dbfrankingListPlayerPointLeague = [];
                for (let item of _data["dbfrankingListPlayerPointLeague"])
                    this.dbfrankingListPlayerPointLeague.push(DbfrankingListPlayerPointLeague.fromJS(item));
            }
            if (Array.isArray(_data["dbftmpUnionMember"])) {
                this.dbftmpUnionMember = [];
                for (let item of _data["dbftmpUnionMember"])
                    this.dbftmpUnionMember.push(DbftmpUnionMember.fromJS(item));
            }
            if (Array.isArray(_data["leagueDivision"])) {
                this.leagueDivision = [];
                for (let item of _data["leagueDivision"])
                    this.leagueDivision.push(LeagueDivision.fromJS(item));
            }
            if (Array.isArray(_data["leagueRegistration"])) {
                this.leagueRegistration = [];
                for (let item of _data["leagueRegistration"])
                    this.leagueRegistration.push(LeagueRegistration.fromJS(item));
            }
            if (Array.isArray(_data["leagueSchema"])) {
                this.leagueSchema = [];
                for (let item of _data["leagueSchema"])
                    this.leagueSchema.push(LeagueSchema.fromJS(item));
            }
            if (Array.isArray(_data["orderItemKidsClub"])) {
                this.orderItemKidsClub = [];
                for (let item of _data["orderItemKidsClub"])
                    this.orderItemKidsClub.push(OrderItemKidsClub.fromJS(item));
            }
            if (Array.isArray(_data["orderItemLicense"])) {
                this.orderItemLicense = [];
                for (let item of _data["orderItemLicense"])
                    this.orderItemLicense.push(OrderItemLicense.fromJS(item));
            }
            if (Array.isArray(_data["paidAccess"])) {
                this.paidAccess = [];
                for (let item of _data["paidAccess"])
                    this.paidAccess.push(PaidAccess.fromJS(item));
            }
            if (Array.isArray(_data["playerClubTransfer"])) {
                this.playerClubTransfer = [];
                for (let item of _data["playerClubTransfer"])
                    this.playerClubTransfer.push(PlayerClubTransfer.fromJS(item));
            }
            if (Array.isArray(_data["playerLicense"])) {
                this.playerLicense = [];
                for (let item of _data["playerLicense"])
                    this.playerLicense.push(PlayerLicense.fromJS(item));
            }
            if (Array.isArray(_data["playerLicensePrintBatch"])) {
                this.playerLicensePrintBatch = [];
                for (let item of _data["playerLicensePrintBatch"])
                    this.playerLicensePrintBatch.push(PlayerLicensePrintBatch.fromJS(item));
            }
            if (Array.isArray(_data["rankingListExternEvent"])) {
                this.rankingListExternEvent = [];
                for (let item of _data["rankingListExternEvent"])
                    this.rankingListExternEvent.push(RankingListExternEvent.fromJS(item));
            }
            if (Array.isArray(_data["rankingListPlayer"])) {
                this.rankingListPlayer = [];
                for (let item of _data["rankingListPlayer"])
                    this.rankingListPlayer.push(RankingListPlayer.fromJS(item));
            }
            if (Array.isArray(_data["rankingListPlayerPoint"])) {
                this.rankingListPlayerPoint = [];
                for (let item of _data["rankingListPlayerPoint"])
                    this.rankingListPlayerPoint.push(RankingListPlayerPoint.fromJS(item));
            }
            if (Array.isArray(_data["rankingListVersion"])) {
                this.rankingListVersion = [];
                for (let item of _data["rankingListVersion"])
                    this.rankingListVersion.push(RankingListVersion.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRound"])) {
                this.tournamentRound = [];
                for (let item of _data["tournamentRound"])
                    this.tournamentRound.push(TournamentRound.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Season();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["seasonId"] = this.seasonId;
        data["unionId"] = this.unionId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["tournamentApplicationOpen"] = this.tournamentApplicationOpen;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined;
        data["tournamentApplicationShowStatus"] = this.tournamentApplicationShowStatus;
        data["tournamentApplicationNotifications"] = this.tournamentApplicationNotifications;
        data["tournamentApplication"] = this.tournamentApplication;
        data["leagueAdministration"] = this.leagueAdministration;
        data["seasonPlan"] = this.seasonPlan;
        data["leagueResults"] = this.leagueResults;
        data["ranking"] = this.ranking;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        if (Array.isArray(this.dbfclubMemberFee)) {
            data["dbfclubMemberFee"] = [];
            for (let item of this.dbfclubMemberFee)
                data["dbfclubMemberFee"].push(item.toJSON());
        }
        if (Array.isArray(this.dbforderItemClubFee)) {
            data["dbforderItemClubFee"] = [];
            for (let item of this.dbforderItemClubFee)
                data["dbforderItemClubFee"].push(item.toJSON());
        }
        if (Array.isArray(this.dbforderItemTmpUnionMember)) {
            data["dbforderItemTmpUnionMember"] = [];
            for (let item of this.dbforderItemTmpUnionMember)
                data["dbforderItemTmpUnionMember"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfplayerRankingReplacement)) {
            data["dbfplayerRankingReplacement"] = [];
            for (let item of this.dbfplayerRankingReplacement)
                data["dbfplayerRankingReplacement"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfrankingListPlayerExternPoint)) {
            data["dbfrankingListPlayerExternPoint"] = [];
            for (let item of this.dbfrankingListPlayerExternPoint)
                data["dbfrankingListPlayerExternPoint"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfrankingListPlayerPoint)) {
            data["dbfrankingListPlayerPoint"] = [];
            for (let item of this.dbfrankingListPlayerPoint)
                data["dbfrankingListPlayerPoint"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfrankingListPlayerPointLeague)) {
            data["dbfrankingListPlayerPointLeague"] = [];
            for (let item of this.dbfrankingListPlayerPointLeague)
                data["dbfrankingListPlayerPointLeague"].push(item.toJSON());
        }
        if (Array.isArray(this.dbftmpUnionMember)) {
            data["dbftmpUnionMember"] = [];
            for (let item of this.dbftmpUnionMember)
                data["dbftmpUnionMember"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueDivision)) {
            data["leagueDivision"] = [];
            for (let item of this.leagueDivision)
                data["leagueDivision"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueRegistration)) {
            data["leagueRegistration"] = [];
            for (let item of this.leagueRegistration)
                data["leagueRegistration"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueSchema)) {
            data["leagueSchema"] = [];
            for (let item of this.leagueSchema)
                data["leagueSchema"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemKidsClub)) {
            data["orderItemKidsClub"] = [];
            for (let item of this.orderItemKidsClub)
                data["orderItemKidsClub"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemLicense)) {
            data["orderItemLicense"] = [];
            for (let item of this.orderItemLicense)
                data["orderItemLicense"].push(item.toJSON());
        }
        if (Array.isArray(this.paidAccess)) {
            data["paidAccess"] = [];
            for (let item of this.paidAccess)
                data["paidAccess"].push(item.toJSON());
        }
        if (Array.isArray(this.playerClubTransfer)) {
            data["playerClubTransfer"] = [];
            for (let item of this.playerClubTransfer)
                data["playerClubTransfer"].push(item.toJSON());
        }
        if (Array.isArray(this.playerLicense)) {
            data["playerLicense"] = [];
            for (let item of this.playerLicense)
                data["playerLicense"].push(item.toJSON());
        }
        if (Array.isArray(this.playerLicensePrintBatch)) {
            data["playerLicensePrintBatch"] = [];
            for (let item of this.playerLicensePrintBatch)
                data["playerLicensePrintBatch"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListExternEvent)) {
            data["rankingListExternEvent"] = [];
            for (let item of this.rankingListExternEvent)
                data["rankingListExternEvent"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListPlayer)) {
            data["rankingListPlayer"] = [];
            for (let item of this.rankingListPlayer)
                data["rankingListPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListPlayerPoint)) {
            data["rankingListPlayerPoint"] = [];
            for (let item of this.rankingListPlayerPoint)
                data["rankingListPlayerPoint"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListVersion)) {
            data["rankingListVersion"] = [];
            for (let item of this.rankingListVersion)
                data["rankingListVersion"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRound)) {
            data["tournamentRound"] = [];
            for (let item of this.tournamentRound)
                data["tournamentRound"].push(item.toJSON());
        }
        return data;
    }
}
export class DbfclubMemberFee {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dbfclubMemberFeeId = _data["dbfclubMemberFeeId"];
            this.clubId = _data["clubId"];
            this.seasonId = _data["seasonId"];
            this.barometerLevel = _data["barometerLevel"];
            this.memberCount = _data["memberCount"];
            this.memberFee = _data["memberFee"];
            this.insurance = _data["insurance"];
            this.fikno = _data["fikno"];
            this.datePrinted = _data["datePrinted"] ? new Date(_data["datePrinted"].toString()) : undefined;
            this.orderId = _data["orderId"];
            this.payed = _data["payed"];
            this.locked = _data["locked"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfclubMemberFee();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dbfclubMemberFeeId"] = this.dbfclubMemberFeeId;
        data["clubId"] = this.clubId;
        data["seasonId"] = this.seasonId;
        data["barometerLevel"] = this.barometerLevel;
        data["memberCount"] = this.memberCount;
        data["memberFee"] = this.memberFee;
        data["insurance"] = this.insurance;
        data["fikno"] = this.fikno;
        data["datePrinted"] = this.datePrinted ? this.datePrinted.toISOString() : undefined;
        data["orderId"] = this.orderId;
        data["payed"] = this.payed;
        data["locked"] = this.locked;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        return data;
    }
}
export class Order {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.unionId = _data["unionId"];
            this.userId = _data["userId"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : undefined;
            this.administrationFee = _data["administrationFee"];
            this.paymentFee = _data["paymentFee"];
            this.total = _data["total"];
            this.currency = _data["currency"];
            this.orderState = _data["orderState"];
            this.paymentState = _data["paymentState"];
            this.transactionId = _data["transactionId"];
            this.transactionData = _data["transactionData"];
            this.clubId = _data["clubId"];
            this.refundTotal = _data["refundTotal"];
            this.refundAdministrationFee = _data["refundAdministrationFee"];
            this.refundTime = _data["refundTime"] ? new Date(_data["refundTime"].toString()) : undefined;
            this.paymentMethod = _data["paymentMethod"];
            this.refundPaymentFee = _data["refundPaymentFee"];
            this.bankRegNo = _data["bankRegNo"];
            this.accountNumber = _data["accountNumber"];
            this.refundUserId = _data["refundUserId"];
            this.transactionType = _data["transactionType"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.refundUser = _data["refundUser"] ? User1.fromJS(_data["refundUser"]) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
            if (Array.isArray(_data["dbfclubMemberFee"])) {
                this.dbfclubMemberFee = [];
                for (let item of _data["dbfclubMemberFee"])
                    this.dbfclubMemberFee.push(DbfclubMemberFee.fromJS(item));
            }
            if (Array.isArray(_data["dbforderItemClubFee"])) {
                this.dbforderItemClubFee = [];
                for (let item of _data["dbforderItemClubFee"])
                    this.dbforderItemClubFee.push(DbforderItemClubFee.fromJS(item));
            }
            if (Array.isArray(_data["dbforderItemLeagueRegistrationTeam"])) {
                this.dbforderItemLeagueRegistrationTeam = [];
                for (let item of _data["dbforderItemLeagueRegistrationTeam"])
                    this.dbforderItemLeagueRegistrationTeam.push(DbforderItemLeagueRegistrationTeam.fromJS(item));
            }
            if (Array.isArray(_data["dbforderItemTmpUnionMember"])) {
                this.dbforderItemTmpUnionMember = [];
                for (let item of _data["dbforderItemTmpUnionMember"])
                    this.dbforderItemTmpUnionMember.push(DbforderItemTmpUnionMember.fromJS(item));
            }
            if (Array.isArray(_data["leagueRegistrationTeam"])) {
                this.leagueRegistrationTeam = [];
                for (let item of _data["leagueRegistrationTeam"])
                    this.leagueRegistrationTeam.push(LeagueRegistrationTeam.fromJS(item));
            }
            if (Array.isArray(_data["orderItemKidsClub"])) {
                this.orderItemKidsClub = [];
                for (let item of _data["orderItemKidsClub"])
                    this.orderItemKidsClub.push(OrderItemKidsClub.fromJS(item));
            }
            if (Array.isArray(_data["orderItemRegistration"])) {
                this.orderItemRegistration = [];
                for (let item of _data["orderItemRegistration"])
                    this.orderItemRegistration.push(OrderItemRegistration.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["unionId"] = this.unionId;
        data["userId"] = this.userId;
        data["time"] = this.time ? this.time.toISOString() : undefined;
        data["administrationFee"] = this.administrationFee;
        data["paymentFee"] = this.paymentFee;
        data["total"] = this.total;
        data["currency"] = this.currency;
        data["orderState"] = this.orderState;
        data["paymentState"] = this.paymentState;
        data["transactionId"] = this.transactionId;
        data["transactionData"] = this.transactionData;
        data["clubId"] = this.clubId;
        data["refundTotal"] = this.refundTotal;
        data["refundAdministrationFee"] = this.refundAdministrationFee;
        data["refundTime"] = this.refundTime ? this.refundTime.toISOString() : undefined;
        data["paymentMethod"] = this.paymentMethod;
        data["refundPaymentFee"] = this.refundPaymentFee;
        data["bankRegNo"] = this.bankRegNo;
        data["accountNumber"] = this.accountNumber;
        data["refundUserId"] = this.refundUserId;
        data["transactionType"] = this.transactionType;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["refundUser"] = this.refundUser ? this.refundUser.toJSON() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        if (Array.isArray(this.dbfclubMemberFee)) {
            data["dbfclubMemberFee"] = [];
            for (let item of this.dbfclubMemberFee)
                data["dbfclubMemberFee"].push(item.toJSON());
        }
        if (Array.isArray(this.dbforderItemClubFee)) {
            data["dbforderItemClubFee"] = [];
            for (let item of this.dbforderItemClubFee)
                data["dbforderItemClubFee"].push(item.toJSON());
        }
        if (Array.isArray(this.dbforderItemLeagueRegistrationTeam)) {
            data["dbforderItemLeagueRegistrationTeam"] = [];
            for (let item of this.dbforderItemLeagueRegistrationTeam)
                data["dbforderItemLeagueRegistrationTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.dbforderItemTmpUnionMember)) {
            data["dbforderItemTmpUnionMember"] = [];
            for (let item of this.dbforderItemTmpUnionMember)
                data["dbforderItemTmpUnionMember"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueRegistrationTeam)) {
            data["leagueRegistrationTeam"] = [];
            for (let item of this.leagueRegistrationTeam)
                data["leagueRegistrationTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemKidsClub)) {
            data["orderItemKidsClub"] = [];
            for (let item of this.orderItemKidsClub)
                data["orderItemKidsClub"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemRegistration)) {
            data["orderItemRegistration"] = [];
            for (let item of this.orderItemRegistration)
                data["orderItemRegistration"].push(item.toJSON());
        }
        return data;
    }
}
export class DbforderItemClubFee {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dbforderItemClubFeeId = _data["dbforderItemClubFeeId"];
            this.orderId = _data["orderId"];
            this.seasonId = _data["seasonId"];
            this.clubId = _data["clubId"];
            this.fee = _data["fee"];
            this.insurance = _data["insurance"];
            this.memberCount = _data["memberCount"];
            this.barometerLevel = _data["barometerLevel"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbforderItemClubFee();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dbforderItemClubFeeId"] = this.dbforderItemClubFeeId;
        data["orderId"] = this.orderId;
        data["seasonId"] = this.seasonId;
        data["clubId"] = this.clubId;
        data["fee"] = this.fee;
        data["insurance"] = this.insurance;
        data["memberCount"] = this.memberCount;
        data["barometerLevel"] = this.barometerLevel;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        return data;
    }
}
export class DbforderItemLeagueRegistrationTeam {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dbforderItemLeagueRegistrationTeamId = _data["dbforderItemLeagueRegistrationTeamId"];
            this.orderId = _data["orderId"];
            this.clubId = _data["clubId"];
            this.leagueTeamId = _data["leagueTeamId"];
            this.leagueDivisionId = _data["leagueDivisionId"];
            this.leagueRegistrationTeamId = _data["leagueRegistrationTeamId"];
            this.fee = _data["fee"];
            this.refund = _data["refund"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.leagueDivision = _data["leagueDivision"] ? LeagueDivision.fromJS(_data["leagueDivision"]) : undefined;
            this.leagueRegistrationTeam = _data["leagueRegistrationTeam"] ? LeagueRegistrationTeam.fromJS(_data["leagueRegistrationTeam"]) : undefined;
            this.leagueTeam = _data["leagueTeam"] ? LeagueTeam.fromJS(_data["leagueTeam"]) : undefined;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbforderItemLeagueRegistrationTeam();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dbforderItemLeagueRegistrationTeamId"] = this.dbforderItemLeagueRegistrationTeamId;
        data["orderId"] = this.orderId;
        data["clubId"] = this.clubId;
        data["leagueTeamId"] = this.leagueTeamId;
        data["leagueDivisionId"] = this.leagueDivisionId;
        data["leagueRegistrationTeamId"] = this.leagueRegistrationTeamId;
        data["fee"] = this.fee;
        data["refund"] = this.refund;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["leagueDivision"] = this.leagueDivision ? this.leagueDivision.toJSON() : undefined;
        data["leagueRegistrationTeam"] = this.leagueRegistrationTeam ? this.leagueRegistrationTeam.toJSON() : undefined;
        data["leagueTeam"] = this.leagueTeam ? this.leagueTeam.toJSON() : undefined;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        return data;
    }
}
export class LeagueRegistrationTeam {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueRegistrationTeamId = _data["leagueRegistrationTeamId"];
            this.clubId = _data["clubId"];
            this.leagueTeamId = _data["leagueTeamId"];
            this.teamIndex = _data["teamIndex"];
            this.teamNumber = _data["teamNumber"];
            this.leagueDivisionId = _data["leagueDivisionId"];
            this.teamPoints = _data["teamPoints"];
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.modifiedTime = _data["modifiedTime"] ? new Date(_data["modifiedTime"].toString()) : undefined;
            this.player1Points = _data["player1Points"];
            this.player2Points = _data["player2Points"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.state = _data["state"];
            this.orderId = _data["orderId"];
            this.comment = _data["comment"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.leagueDivision = _data["leagueDivision"] ? LeagueDivision.fromJS(_data["leagueDivision"]) : undefined;
            this.leagueTeam = _data["leagueTeam"] ? LeagueTeam.fromJS(_data["leagueTeam"]) : undefined;
            this.modifiedByUser = _data["modifiedByUser"] ? User1.fromJS(_data["modifiedByUser"]) : undefined;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            if (Array.isArray(_data["dbfleagueRegistrationTeamPlayer"])) {
                this.dbfleagueRegistrationTeamPlayer = [];
                for (let item of _data["dbfleagueRegistrationTeamPlayer"])
                    this.dbfleagueRegistrationTeamPlayer.push(DbfleagueRegistrationTeamPlayer.fromJS(item));
            }
            if (Array.isArray(_data["dbforderItemLeagueRegistrationTeam"])) {
                this.dbforderItemLeagueRegistrationTeam = [];
                for (let item of _data["dbforderItemLeagueRegistrationTeam"])
                    this.dbforderItemLeagueRegistrationTeam.push(DbforderItemLeagueRegistrationTeam.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueRegistrationTeam();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueRegistrationTeamId"] = this.leagueRegistrationTeamId;
        data["clubId"] = this.clubId;
        data["leagueTeamId"] = this.leagueTeamId;
        data["teamIndex"] = this.teamIndex;
        data["teamNumber"] = this.teamNumber;
        data["leagueDivisionId"] = this.leagueDivisionId;
        data["teamPoints"] = this.teamPoints;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["modifiedTime"] = this.modifiedTime ? this.modifiedTime.toISOString() : undefined;
        data["player1Points"] = this.player1Points;
        data["player2Points"] = this.player2Points;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["state"] = this.state;
        data["orderId"] = this.orderId;
        data["comment"] = this.comment;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["leagueDivision"] = this.leagueDivision ? this.leagueDivision.toJSON() : undefined;
        data["leagueTeam"] = this.leagueTeam ? this.leagueTeam.toJSON() : undefined;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : undefined;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        if (Array.isArray(this.dbfleagueRegistrationTeamPlayer)) {
            data["dbfleagueRegistrationTeamPlayer"] = [];
            for (let item of this.dbfleagueRegistrationTeamPlayer)
                data["dbfleagueRegistrationTeamPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.dbforderItemLeagueRegistrationTeam)) {
            data["dbforderItemLeagueRegistrationTeam"] = [];
            for (let item of this.dbforderItemLeagueRegistrationTeam)
                data["dbforderItemLeagueRegistrationTeam"].push(item.toJSON());
        }
        return data;
    }
}
export class LeagueTeam {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueTeamId = _data["leagueTeamId"];
            this.regionId = _data["regionId"];
            this.name = _data["name"];
            this.active = _data["active"];
            this.unionId = _data["unionId"];
            this.updatedByUserId = _data["updatedByUserId"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : undefined;
            this.acronym = _data["acronym"];
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            this.updatedByUser = _data["updatedByUser"] ? User1.fromJS(_data["updatedByUser"]) : undefined;
            if (Array.isArray(_data["dbforderItemLeagueRegistrationTeam"])) {
                this.dbforderItemLeagueRegistrationTeam = [];
                for (let item of _data["dbforderItemLeagueRegistrationTeam"])
                    this.dbforderItemLeagueRegistrationTeam.push(DbforderItemLeagueRegistrationTeam.fromJS(item));
            }
            if (Array.isArray(_data["leagueGroupTeam"])) {
                this.leagueGroupTeam = [];
                for (let item of _data["leagueGroupTeam"])
                    this.leagueGroupTeam.push(LeagueGroupTeam.fromJS(item));
            }
            if (Array.isArray(_data["leagueRegistration"])) {
                this.leagueRegistration = [];
                for (let item of _data["leagueRegistration"])
                    this.leagueRegistration.push(LeagueRegistration.fromJS(item));
            }
            if (Array.isArray(_data["leagueRegistrationTeam"])) {
                this.leagueRegistrationTeam = [];
                for (let item of _data["leagueRegistrationTeam"])
                    this.leagueRegistrationTeam.push(LeagueRegistrationTeam.fromJS(item));
            }
            if (Array.isArray(_data["leagueTeamClub"])) {
                this.leagueTeamClub = [];
                for (let item of _data["leagueTeamClub"])
                    this.leagueTeamClub.push(LeagueTeamClub.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueTeam();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueTeamId"] = this.leagueTeamId;
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        data["active"] = this.active;
        data["unionId"] = this.unionId;
        data["updatedByUserId"] = this.updatedByUserId;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : undefined;
        data["acronym"] = this.acronym;
        data["region"] = this.region ? this.region.toJSON() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        data["updatedByUser"] = this.updatedByUser ? this.updatedByUser.toJSON() : undefined;
        if (Array.isArray(this.dbforderItemLeagueRegistrationTeam)) {
            data["dbforderItemLeagueRegistrationTeam"] = [];
            for (let item of this.dbforderItemLeagueRegistrationTeam)
                data["dbforderItemLeagueRegistrationTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueGroupTeam)) {
            data["leagueGroupTeam"] = [];
            for (let item of this.leagueGroupTeam)
                data["leagueGroupTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueRegistration)) {
            data["leagueRegistration"] = [];
            for (let item of this.leagueRegistration)
                data["leagueRegistration"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueRegistrationTeam)) {
            data["leagueRegistrationTeam"] = [];
            for (let item of this.leagueRegistrationTeam)
                data["leagueRegistrationTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueTeamClub)) {
            data["leagueTeamClub"] = [];
            for (let item of this.leagueTeamClub)
                data["leagueTeamClub"].push(item.toJSON());
        }
        return data;
    }
}
export class LeagueRegistration {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueRegistrationId = _data["leagueRegistrationId"];
            this.seasonId = _data["seasonId"];
            this.clubId = _data["clubId"];
            this.leagueTeamId = _data["leagueTeamId"];
            this.ageGroupId = _data["ageGroupId"];
            this.contactPerson = _data["contactPerson"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.userId = _data["userId"];
            this.modifiedTime = _data["modifiedTime"] ? new Date(_data["modifiedTime"].toString()) : undefined;
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.leagueTeam = _data["leagueTeam"] ? LeagueTeam.fromJS(_data["leagueTeam"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueRegistration();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueRegistrationId"] = this.leagueRegistrationId;
        data["seasonId"] = this.seasonId;
        data["clubId"] = this.clubId;
        data["leagueTeamId"] = this.leagueTeamId;
        data["ageGroupId"] = this.ageGroupId;
        data["contactPerson"] = this.contactPerson;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["userId"] = this.userId;
        data["modifiedTime"] = this.modifiedTime ? this.modifiedTime.toISOString() : undefined;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["leagueTeam"] = this.leagueTeam ? this.leagueTeam.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class LeagueTeamClub {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueTeamId = _data["leagueTeamId"];
            this.clubId = _data["clubId"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.leagueTeam = _data["leagueTeam"] ? LeagueTeam.fromJS(_data["leagueTeam"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueTeamClub();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueTeamId"] = this.leagueTeamId;
        data["clubId"] = this.clubId;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["leagueTeam"] = this.leagueTeam ? this.leagueTeam.toJSON() : undefined;
        return data;
    }
}
export class DbfleagueRegistrationTeamPlayer {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueRegistrationTeamId = _data["leagueRegistrationTeamId"];
            this.playerId = _data["playerId"];
            this.points = _data["points"];
            this.leagueRegistrationTeam = _data["leagueRegistrationTeam"] ? LeagueRegistrationTeam.fromJS(_data["leagueRegistrationTeam"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfleagueRegistrationTeamPlayer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueRegistrationTeamId"] = this.leagueRegistrationTeamId;
        data["playerId"] = this.playerId;
        data["points"] = this.points;
        data["leagueRegistrationTeam"] = this.leagueRegistrationTeam ? this.leagueRegistrationTeam.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        return data;
    }
}
export class DbforderItemTmpUnionMember {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dbforderItemTmpUnionMemberId = _data["dbforderItemTmpUnionMemberId"];
            this.orderId = _data["orderId"];
            this.seasonId = _data["seasonId"];
            this.clubId = _data["clubId"];
            this.regionId = _data["regionId"];
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
            this.userPhone = _data["userPhone"];
            this.clubName = _data["clubName"];
            this.clubEmail = _data["clubEmail"];
            this.clubPhone = _data["clubPhone"];
            this.amount = _data["amount"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbforderItemTmpUnionMember();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dbforderItemTmpUnionMemberId"] = this.dbforderItemTmpUnionMemberId;
        data["orderId"] = this.orderId;
        data["seasonId"] = this.seasonId;
        data["clubId"] = this.clubId;
        data["regionId"] = this.regionId;
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        data["userPhone"] = this.userPhone;
        data["clubName"] = this.clubName;
        data["clubEmail"] = this.clubEmail;
        data["clubPhone"] = this.clubPhone;
        data["amount"] = this.amount;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["region"] = this.region ? this.region.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        return data;
    }
}
export class OrderItemKidsClub {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orderItemKidsClubId = _data["orderItemKidsClubId"];
            this.orderId = _data["orderId"];
            this.price = _data["price"];
            this.seasonId = _data["seasonId"];
            this.playerId = _data["playerId"];
            this.paidAccessId = _data["paidAccessId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.paidAccess = _data["paidAccess"] ? PaidAccess.fromJS(_data["paidAccess"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemKidsClub();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["orderItemKidsClubId"] = this.orderItemKidsClubId;
        data["orderId"] = this.orderId;
        data["price"] = this.price;
        data["seasonId"] = this.seasonId;
        data["playerId"] = this.playerId;
        data["paidAccessId"] = this.paidAccessId;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["paidAccess"] = this.paidAccess ? this.paidAccess.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        return data;
    }
}
export class PaidAccess {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.paidAccessId = _data["paidAccessId"];
            this.paidAccessType = _data["paidAccessType"];
            this.unionId = _data["unionId"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.restrictedToSeasonId = _data["restrictedToSeasonId"];
            this.restrictedToSeason = _data["restrictedToSeason"] ? Season.fromJS(_data["restrictedToSeason"]) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            if (Array.isArray(_data["orderItemKidsClub"])) {
                this.orderItemKidsClub = [];
                for (let item of _data["orderItemKidsClub"])
                    this.orderItemKidsClub.push(OrderItemKidsClub.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaidAccess();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["paidAccessId"] = this.paidAccessId;
        data["paidAccessType"] = this.paidAccessType;
        data["unionId"] = this.unionId;
        data["name"] = this.name;
        data["price"] = this.price;
        data["restrictedToSeasonId"] = this.restrictedToSeasonId;
        data["restrictedToSeason"] = this.restrictedToSeason ? this.restrictedToSeason.toJSON() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        if (Array.isArray(this.orderItemKidsClub)) {
            data["orderItemKidsClub"] = [];
            for (let item of this.orderItemKidsClub)
                data["orderItemKidsClub"].push(item.toJSON());
        }
        return data;
    }
}
export class OrderItemRegistration {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orderItemRegistrationId = _data["orderItemRegistrationId"];
            this.orderId = _data["orderId"];
            this.tournamentEventId = _data["tournamentEventId"];
            this.tournamentRegistrationId = _data["tournamentRegistrationId"];
            this.price = _data["price"];
            this.administrationFee = _data["administrationFee"];
            this.refund = _data["refund"];
            this.refundTime = _data["refundTime"] ? new Date(_data["refundTime"].toString()) : undefined;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.tournamentEvent = _data["tournamentEvent"] ? TournamentEvent.fromJS(_data["tournamentEvent"]) : undefined;
            this.tournamentRegistration = _data["tournamentRegistration"] ? TournamentRegistration.fromJS(_data["tournamentRegistration"]) : undefined;
            this.orderItemRegistrationClub = _data["orderItemRegistrationClub"] ? OrderItemRegistrationClub.fromJS(_data["orderItemRegistrationClub"]) : undefined;
            if (Array.isArray(_data["orderItemRegistrationPlayer"])) {
                this.orderItemRegistrationPlayer = [];
                for (let item of _data["orderItemRegistrationPlayer"])
                    this.orderItemRegistrationPlayer.push(OrderItemRegistrationPlayer.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRegistrationClub"])) {
                this.tournamentRegistrationClub = [];
                for (let item of _data["tournamentRegistrationClub"])
                    this.tournamentRegistrationClub.push(TournamentRegistrationClub.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRegistrationPlayer"])) {
                this.tournamentRegistrationPlayer = [];
                for (let item of _data["tournamentRegistrationPlayer"])
                    this.tournamentRegistrationPlayer.push(TournamentRegistrationPlayer.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemRegistration();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["orderItemRegistrationId"] = this.orderItemRegistrationId;
        data["orderId"] = this.orderId;
        data["tournamentEventId"] = this.tournamentEventId;
        data["tournamentRegistrationId"] = this.tournamentRegistrationId;
        data["price"] = this.price;
        data["administrationFee"] = this.administrationFee;
        data["refund"] = this.refund;
        data["refundTime"] = this.refundTime ? this.refundTime.toISOString() : undefined;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["tournamentEvent"] = this.tournamentEvent ? this.tournamentEvent.toJSON() : undefined;
        data["tournamentRegistration"] = this.tournamentRegistration ? this.tournamentRegistration.toJSON() : undefined;
        data["orderItemRegistrationClub"] = this.orderItemRegistrationClub ? this.orderItemRegistrationClub.toJSON() : undefined;
        if (Array.isArray(this.orderItemRegistrationPlayer)) {
            data["orderItemRegistrationPlayer"] = [];
            for (let item of this.orderItemRegistrationPlayer)
                data["orderItemRegistrationPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRegistrationClub)) {
            data["tournamentRegistrationClub"] = [];
            for (let item of this.tournamentRegistrationClub)
                data["tournamentRegistrationClub"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRegistrationPlayer)) {
            data["tournamentRegistrationPlayer"] = [];
            for (let item of this.tournamentRegistrationPlayer)
                data["tournamentRegistrationPlayer"].push(item.toJSON());
        }
        return data;
    }
}
export class TournamentEvent {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentEventId = _data["tournamentEventId"];
            this.tournamentClassId = _data["tournamentClassId"];
            this.disciplineCode = _data["disciplineCode"];
            this.sortIndex = _data["sortIndex"];
            this.price = _data["price"];
            this.maxRegistrations = _data["maxRegistrations"];
            this.tournamentClass = _data["tournamentClass"] ? TournamentClass1.fromJS(_data["tournamentClass"]) : undefined;
            if (Array.isArray(_data["liveScoreTournamentMatch"])) {
                this.liveScoreTournamentMatch = [];
                for (let item of _data["liveScoreTournamentMatch"])
                    this.liveScoreTournamentMatch.push(LiveScoreTournamentMatch.fromJS(item));
            }
            if (Array.isArray(_data["orderItemRegistration"])) {
                this.orderItemRegistration = [];
                for (let item of _data["orderItemRegistration"])
                    this.orderItemRegistration.push(OrderItemRegistration.fromJS(item));
            }
            if (Array.isArray(_data["tournamentEventMatch"])) {
                this.tournamentEventMatch = [];
                for (let item of _data["tournamentEventMatch"])
                    this.tournamentEventMatch.push(TournamentEventMatch.fromJS(item));
            }
            if (Array.isArray(_data["tournamentEventPlayer"])) {
                this.tournamentEventPlayer = [];
                for (let item of _data["tournamentEventPlayer"])
                    this.tournamentEventPlayer.push(TournamentEventPlayer.fromJS(item));
            }
            if (Array.isArray(_data["tournamentImportBatchMatch"])) {
                this.tournamentImportBatchMatch = [];
                for (let item of _data["tournamentImportBatchMatch"])
                    this.tournamentImportBatchMatch.push(TournamentImportBatchMatch.fromJS(item));
            }
            if (Array.isArray(_data["tournamentImportBatchPlayer"])) {
                this.tournamentImportBatchPlayer = [];
                for (let item of _data["tournamentImportBatchPlayer"])
                    this.tournamentImportBatchPlayer.push(TournamentImportBatchPlayer.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRegistration"])) {
                this.tournamentRegistration = [];
                for (let item of _data["tournamentRegistration"])
                    this.tournamentRegistration.push(TournamentRegistration.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentEvent();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentEventId"] = this.tournamentEventId;
        data["tournamentClassId"] = this.tournamentClassId;
        data["disciplineCode"] = this.disciplineCode;
        data["sortIndex"] = this.sortIndex;
        data["price"] = this.price;
        data["maxRegistrations"] = this.maxRegistrations;
        data["tournamentClass"] = this.tournamentClass ? this.tournamentClass.toJSON() : undefined;
        if (Array.isArray(this.liveScoreTournamentMatch)) {
            data["liveScoreTournamentMatch"] = [];
            for (let item of this.liveScoreTournamentMatch)
                data["liveScoreTournamentMatch"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemRegistration)) {
            data["orderItemRegistration"] = [];
            for (let item of this.orderItemRegistration)
                data["orderItemRegistration"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentEventMatch)) {
            data["tournamentEventMatch"] = [];
            for (let item of this.tournamentEventMatch)
                data["tournamentEventMatch"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentEventPlayer)) {
            data["tournamentEventPlayer"] = [];
            for (let item of this.tournamentEventPlayer)
                data["tournamentEventPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentImportBatchMatch)) {
            data["tournamentImportBatchMatch"] = [];
            for (let item of this.tournamentImportBatchMatch)
                data["tournamentImportBatchMatch"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentImportBatchPlayer)) {
            data["tournamentImportBatchPlayer"] = [];
            for (let item of this.tournamentImportBatchPlayer)
                data["tournamentImportBatchPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRegistration)) {
            data["tournamentRegistration"] = [];
            for (let item of this.tournamentRegistration)
                data["tournamentRegistration"].push(item.toJSON());
        }
        return data;
    }
}
export class TournamentClass1 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentClassId = _data["tournamentClassId"];
            this.tournamentId = _data["tournamentId"];
            this.ageGroupId = _data["ageGroupId"];
            this.classId = _data["classId"];
            this.tournamentNumber = _data["tournamentNumber"];
            this.ageGroupCode = _data["ageGroupCode"];
            this.classCode = _data["classCode"];
            this.tournamentState = _data["tournamentState"];
            this.maxEvents = _data["maxEvents"];
            this.noValidateAgeGroup = _data["noValidateAgeGroup"];
            this.noValidateClass = _data["noValidateClass"];
            this.tournamentClassTitle = _data["tournamentClassTitle"];
            this.bornFrom = _data["bornFrom"] ? new Date(_data["bornFrom"].toString()) : undefined;
            this.bornTo = _data["bornTo"] ? new Date(_data["bornTo"].toString()) : undefined;
            this.tournamentClassInfo = _data["tournamentClassInfo"];
            this.classDateFrom = _data["classDateFrom"] ? new Date(_data["classDateFrom"].toString()) : undefined;
            this.classDateTo = _data["classDateTo"] ? new Date(_data["classDateTo"].toString()) : undefined;
            this.rankingPointsFromMale = _data["rankingPointsFromMale"];
            this.rankingPointsToMale = _data["rankingPointsToMale"];
            this.rankingPointsFromFemale = _data["rankingPointsFromFemale"];
            this.rankingPointsToFemale = _data["rankingPointsToFemale"];
            this.validationRule = _data["validationRule"];
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.class = _data["class"] ? Class.fromJS(_data["class"]) : undefined;
            this.tournament = _data["tournament"] ? Tournament1.fromJS(_data["tournament"]) : undefined;
            if (Array.isArray(_data["tournamentClassWildcard"])) {
                this.tournamentClassWildcard = [];
                for (let item of _data["tournamentClassWildcard"])
                    this.tournamentClassWildcard.push(TournamentClassWildcard.fromJS(item));
            }
            if (Array.isArray(_data["tournamentEvent"])) {
                this.tournamentEvent = [];
                for (let item of _data["tournamentEvent"])
                    this.tournamentEvent.push(TournamentEvent.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentClass1();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentClassId"] = this.tournamentClassId;
        data["tournamentId"] = this.tournamentId;
        data["ageGroupId"] = this.ageGroupId;
        data["classId"] = this.classId;
        data["tournamentNumber"] = this.tournamentNumber;
        data["ageGroupCode"] = this.ageGroupCode;
        data["classCode"] = this.classCode;
        data["tournamentState"] = this.tournamentState;
        data["maxEvents"] = this.maxEvents;
        data["noValidateAgeGroup"] = this.noValidateAgeGroup;
        data["noValidateClass"] = this.noValidateClass;
        data["tournamentClassTitle"] = this.tournamentClassTitle;
        data["bornFrom"] = this.bornFrom ? this.bornFrom.toISOString() : undefined;
        data["bornTo"] = this.bornTo ? this.bornTo.toISOString() : undefined;
        data["tournamentClassInfo"] = this.tournamentClassInfo;
        data["classDateFrom"] = this.classDateFrom ? this.classDateFrom.toISOString() : undefined;
        data["classDateTo"] = this.classDateTo ? this.classDateTo.toISOString() : undefined;
        data["rankingPointsFromMale"] = this.rankingPointsFromMale;
        data["rankingPointsToMale"] = this.rankingPointsToMale;
        data["rankingPointsFromFemale"] = this.rankingPointsFromFemale;
        data["rankingPointsToFemale"] = this.rankingPointsToFemale;
        data["validationRule"] = this.validationRule;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["class"] = this.class ? this.class.toJSON() : undefined;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined;
        if (Array.isArray(this.tournamentClassWildcard)) {
            data["tournamentClassWildcard"] = [];
            for (let item of this.tournamentClassWildcard)
                data["tournamentClassWildcard"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentEvent)) {
            data["tournamentEvent"] = [];
            for (let item of this.tournamentEvent)
                data["tournamentEvent"].push(item.toJSON());
        }
        return data;
    }
}
export class TournamentClassWildcard {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentClassId = _data["tournamentClassId"];
            this.playerId = _data["playerId"];
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.tournamentClass = _data["tournamentClass"] ? TournamentClass1.fromJS(_data["tournamentClass"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentClassWildcard();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentClassId"] = this.tournamentClassId;
        data["playerId"] = this.playerId;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["tournamentClass"] = this.tournamentClass ? this.tournamentClass.toJSON() : undefined;
        return data;
    }
}
export class LiveScoreTournamentMatch {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentId = _data["tournamentId"];
            this.matchId = _data["matchId"];
            this.tournamentEventId = _data["tournamentEventId"];
            this.level = _data["level"];
            this.group = _data["group"];
            this.playOffIndex = _data["playOffIndex"];
            this.playoffName = _data["playoffName"];
            this.players = _data["players"];
            this.score = _data["score"];
            this.walkOver = _data["walkOver"];
            this.winner = _data["winner"];
            this.updatedTime = _data["updatedTime"] ? new Date(_data["updatedTime"].toString()) : undefined;
            this.reserved = _data["reserved"];
            this.liveScoreUserId = _data["liveScoreUserId"];
            this.completed = _data["completed"];
            this.liveScoreUser = _data["liveScoreUser"] ? LiveScoreUser.fromJS(_data["liveScoreUser"]) : undefined;
            this.tournament = _data["tournament"] ? LiveScoreTournament.fromJS(_data["tournament"]) : undefined;
            this.tournamentEvent = _data["tournamentEvent"] ? TournamentEvent.fromJS(_data["tournamentEvent"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LiveScoreTournamentMatch();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentId"] = this.tournamentId;
        data["matchId"] = this.matchId;
        data["tournamentEventId"] = this.tournamentEventId;
        data["level"] = this.level;
        data["group"] = this.group;
        data["playOffIndex"] = this.playOffIndex;
        data["playoffName"] = this.playoffName;
        data["players"] = this.players;
        data["score"] = this.score;
        data["walkOver"] = this.walkOver;
        data["winner"] = this.winner;
        data["updatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : undefined;
        data["reserved"] = this.reserved;
        data["liveScoreUserId"] = this.liveScoreUserId;
        data["completed"] = this.completed;
        data["liveScoreUser"] = this.liveScoreUser ? this.liveScoreUser.toJSON() : undefined;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined;
        data["tournamentEvent"] = this.tournamentEvent ? this.tournamentEvent.toJSON() : undefined;
        return data;
    }
}
export class LiveScoreUser {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.liveScoreUserId = _data["liveScoreUserId"];
            this.userId = _data["userId"];
            this.browserName = _data["browserName"];
            this.browserVersion = _data["browserVersion"];
            this.browserPlatform = _data["browserPlatform"];
            this.createdTime = _data["createdTime"] ? new Date(_data["createdTime"].toString()) : undefined;
            this.ip = _data["ip"];
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
            if (Array.isArray(_data["liveScoreLeagueIndividualMatch"])) {
                this.liveScoreLeagueIndividualMatch = [];
                for (let item of _data["liveScoreLeagueIndividualMatch"])
                    this.liveScoreLeagueIndividualMatch.push(LiveScoreLeagueIndividualMatch.fromJS(item));
            }
            if (Array.isArray(_data["liveScoreTournamentMatch"])) {
                this.liveScoreTournamentMatch = [];
                for (let item of _data["liveScoreTournamentMatch"])
                    this.liveScoreTournamentMatch.push(LiveScoreTournamentMatch.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LiveScoreUser();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["liveScoreUserId"] = this.liveScoreUserId;
        data["userId"] = this.userId;
        data["browserName"] = this.browserName;
        data["browserVersion"] = this.browserVersion;
        data["browserPlatform"] = this.browserPlatform;
        data["createdTime"] = this.createdTime ? this.createdTime.toISOString() : undefined;
        data["ip"] = this.ip;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        if (Array.isArray(this.liveScoreLeagueIndividualMatch)) {
            data["liveScoreLeagueIndividualMatch"] = [];
            for (let item of this.liveScoreLeagueIndividualMatch)
                data["liveScoreLeagueIndividualMatch"].push(item.toJSON());
        }
        if (Array.isArray(this.liveScoreTournamentMatch)) {
            data["liveScoreTournamentMatch"] = [];
            for (let item of this.liveScoreTournamentMatch)
                data["liveScoreTournamentMatch"].push(item.toJSON());
        }
        return data;
    }
}
export class LiveScoreLeagueIndividualMatch {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueMatchIndividualMatchId = _data["leagueMatchIndividualMatchId"];
            this.liveScoreUserId = _data["liveScoreUserId"];
            this.score = _data["score"];
            this.walkOver = _data["walkOver"];
            this.winner = _data["winner"];
            this.updatedTime = _data["updatedTime"] ? new Date(_data["updatedTime"].toString()) : undefined;
            this.reserved = _data["reserved"];
            this.courtNo = _data["courtNo"];
            this.leagueMatchIndividualMatch = _data["leagueMatchIndividualMatch"] ? LeagueMatchIndividualMatch.fromJS(_data["leagueMatchIndividualMatch"]) : undefined;
            this.liveScoreUser = _data["liveScoreUser"] ? LiveScoreUser.fromJS(_data["liveScoreUser"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LiveScoreLeagueIndividualMatch();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueMatchIndividualMatchId"] = this.leagueMatchIndividualMatchId;
        data["liveScoreUserId"] = this.liveScoreUserId;
        data["score"] = this.score;
        data["walkOver"] = this.walkOver;
        data["winner"] = this.winner;
        data["updatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : undefined;
        data["reserved"] = this.reserved;
        data["courtNo"] = this.courtNo;
        data["leagueMatchIndividualMatch"] = this.leagueMatchIndividualMatch ? this.leagueMatchIndividualMatch.toJSON() : undefined;
        data["liveScoreUser"] = this.liveScoreUser ? this.liveScoreUser.toJSON() : undefined;
        return data;
    }
}
export class LiveScoreTournament {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentId = _data["tournamentId"];
            this.liveScore = _data["liveScore"];
            this.liveScoreCode = _data["liveScoreCode"];
            this.tournament = _data["tournament"] ? Tournament1.fromJS(_data["tournament"]) : undefined;
            if (Array.isArray(_data["liveScoreTournamentMatch"])) {
                this.liveScoreTournamentMatch = [];
                for (let item of _data["liveScoreTournamentMatch"])
                    this.liveScoreTournamentMatch.push(LiveScoreTournamentMatch.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LiveScoreTournament();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentId"] = this.tournamentId;
        data["liveScore"] = this.liveScore;
        data["liveScoreCode"] = this.liveScoreCode;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined;
        if (Array.isArray(this.liveScoreTournamentMatch)) {
            data["liveScoreTournamentMatch"] = [];
            for (let item of this.liveScoreTournamentMatch)
                data["liveScoreTournamentMatch"].push(item.toJSON());
        }
        return data;
    }
}
export class TournamentEventMatch {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentEventId = _data["tournamentEventId"];
            this.matchId = _data["matchId"];
            this.level = _data["level"];
            this.group = _data["group"];
            this.winnerProgramNumber = _data["winnerProgramNumber"];
            this.loserProgramNumber = _data["loserProgramNumber"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined;
            this.result = _data["result"];
            this.walkOver = _data["walkOver"];
            this.playOffIndex = _data["playOffIndex"];
            this.playoffName = _data["playoffName"];
            this.tournamentEvent = _data["tournamentEvent"] ? TournamentEvent.fromJS(_data["tournamentEvent"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentEventMatch();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentEventId"] = this.tournamentEventId;
        data["matchId"] = this.matchId;
        data["level"] = this.level;
        data["group"] = this.group;
        data["winnerProgramNumber"] = this.winnerProgramNumber;
        data["loserProgramNumber"] = this.loserProgramNumber;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined;
        data["result"] = this.result;
        data["walkOver"] = this.walkOver;
        data["playOffIndex"] = this.playOffIndex;
        data["playoffName"] = this.playoffName;
        data["tournamentEvent"] = this.tournamentEvent ? this.tournamentEvent.toJSON() : undefined;
        return data;
    }
}
export class TournamentEventPlayer {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentEventId = _data["tournamentEventId"];
            this.programNumber = _data["programNumber"];
            this.playerId = _data["playerId"];
            this.clubId = _data["clubId"];
            this.ranking = _data["ranking"];
            this.points = _data["points"];
            this.pointsCount = _data["pointsCount"];
            this.playOffIndex = _data["playOffIndex"];
            this.playoffName = _data["playoffName"];
            this.updatedByUserId = _data["updatedByUserId"];
            this.updatedTime = _data["updatedTime"] ? new Date(_data["updatedTime"].toString()) : undefined;
            this.tournamentEventPlayerId = _data["tournamentEventPlayerId"];
            this.deleted = _data["deleted"];
            this.points2 = _data["points2"];
            this.clubName = _data["clubName"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.tournamentEvent = _data["tournamentEvent"] ? TournamentEvent.fromJS(_data["tournamentEvent"]) : undefined;
            this.updatedByUser = _data["updatedByUser"] ? User1.fromJS(_data["updatedByUser"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentEventPlayer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentEventId"] = this.tournamentEventId;
        data["programNumber"] = this.programNumber;
        data["playerId"] = this.playerId;
        data["clubId"] = this.clubId;
        data["ranking"] = this.ranking;
        data["points"] = this.points;
        data["pointsCount"] = this.pointsCount;
        data["playOffIndex"] = this.playOffIndex;
        data["playoffName"] = this.playoffName;
        data["updatedByUserId"] = this.updatedByUserId;
        data["updatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : undefined;
        data["tournamentEventPlayerId"] = this.tournamentEventPlayerId;
        data["deleted"] = this.deleted;
        data["points2"] = this.points2;
        data["clubName"] = this.clubName;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["tournamentEvent"] = this.tournamentEvent ? this.tournamentEvent.toJSON() : undefined;
        data["updatedByUser"] = this.updatedByUser ? this.updatedByUser.toJSON() : undefined;
        return data;
    }
}
export class TournamentImportBatchMatch {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentImportBatchId = _data["tournamentImportBatchId"];
            this.tournamentEventId = _data["tournamentEventId"];
            this.matchId = _data["matchId"];
            this.level = _data["level"];
            this.group = _data["group"];
            this.winnerProgramNumber = _data["winnerProgramNumber"];
            this.loserProgramNumber = _data["loserProgramNumber"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined;
            this.result = _data["result"];
            this.walkOver = _data["walkOver"];
            this.playOffIndex = _data["playOffIndex"];
            this.playoffName = _data["playoffName"];
            this.tournamentImportBatchMatchId = _data["tournamentImportBatchMatchId"];
            this.tournamentEvent = _data["tournamentEvent"] ? TournamentEvent.fromJS(_data["tournamentEvent"]) : undefined;
            this.tournamentImportBatch = _data["tournamentImportBatch"] ? TournamentImportBatch.fromJS(_data["tournamentImportBatch"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentImportBatchMatch();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentImportBatchId"] = this.tournamentImportBatchId;
        data["tournamentEventId"] = this.tournamentEventId;
        data["matchId"] = this.matchId;
        data["level"] = this.level;
        data["group"] = this.group;
        data["winnerProgramNumber"] = this.winnerProgramNumber;
        data["loserProgramNumber"] = this.loserProgramNumber;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined;
        data["result"] = this.result;
        data["walkOver"] = this.walkOver;
        data["playOffIndex"] = this.playOffIndex;
        data["playoffName"] = this.playoffName;
        data["tournamentImportBatchMatchId"] = this.tournamentImportBatchMatchId;
        data["tournamentEvent"] = this.tournamentEvent ? this.tournamentEvent.toJSON() : undefined;
        data["tournamentImportBatch"] = this.tournamentImportBatch ? this.tournamentImportBatch.toJSON() : undefined;
        return data;
    }
}
export class TournamentImportBatch {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentImportBatchId = _data["tournamentImportBatchId"];
            this.unionId = _data["unionId"];
            this.tournamentNumber = _data["tournamentNumber"];
            this.timeStarted = _data["timeStarted"] ? new Date(_data["timeStarted"].toString()) : undefined;
            this.tournamentId = _data["tournamentId"];
            this.timeCompleted = _data["timeCompleted"] ? new Date(_data["timeCompleted"].toString()) : undefined;
            this.importState = _data["importState"];
            this.errorMessage = _data["errorMessage"];
            this.importFile = _data["importFile"];
            this.applicationFile = _data["applicationFile"];
            this.tournament = _data["tournament"] ? Tournament1.fromJS(_data["tournament"]) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            if (Array.isArray(_data["tournamentImportBatchMatch"])) {
                this.tournamentImportBatchMatch = [];
                for (let item of _data["tournamentImportBatchMatch"])
                    this.tournamentImportBatchMatch.push(TournamentImportBatchMatch.fromJS(item));
            }
            if (Array.isArray(_data["tournamentImportBatchPlayer"])) {
                this.tournamentImportBatchPlayer = [];
                for (let item of _data["tournamentImportBatchPlayer"])
                    this.tournamentImportBatchPlayer.push(TournamentImportBatchPlayer.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentImportBatch();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentImportBatchId"] = this.tournamentImportBatchId;
        data["unionId"] = this.unionId;
        data["tournamentNumber"] = this.tournamentNumber;
        data["timeStarted"] = this.timeStarted ? this.timeStarted.toISOString() : undefined;
        data["tournamentId"] = this.tournamentId;
        data["timeCompleted"] = this.timeCompleted ? this.timeCompleted.toISOString() : undefined;
        data["importState"] = this.importState;
        data["errorMessage"] = this.errorMessage;
        data["importFile"] = this.importFile;
        data["applicationFile"] = this.applicationFile;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        if (Array.isArray(this.tournamentImportBatchMatch)) {
            data["tournamentImportBatchMatch"] = [];
            for (let item of this.tournamentImportBatchMatch)
                data["tournamentImportBatchMatch"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentImportBatchPlayer)) {
            data["tournamentImportBatchPlayer"] = [];
            for (let item of this.tournamentImportBatchPlayer)
                data["tournamentImportBatchPlayer"].push(item.toJSON());
        }
        return data;
    }
}
export class TournamentImportBatchPlayer {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentImportBatchId = _data["tournamentImportBatchId"];
            this.tournamentEventId = _data["tournamentEventId"];
            this.programNumber = _data["programNumber"];
            this.playerNumber = _data["playerNumber"];
            this.name = _data["name"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined;
            this.gender = _data["gender"];
            this.clubNumber = _data["clubNumber"];
            this.ranking = _data["ranking"];
            this.points = _data["points"];
            this.playOffIndex = _data["playOffIndex"];
            this.playoffName = _data["playoffName"];
            this.playerId = _data["playerId"];
            this.clubId = _data["clubId"];
            this.pointsCount = _data["pointsCount"];
            this.points2 = _data["points2"];
            this.clubName = _data["clubName"];
            this.tournamentImportBatchPlayerId = _data["tournamentImportBatchPlayerId"];
            this.tournamentEvent = _data["tournamentEvent"] ? TournamentEvent.fromJS(_data["tournamentEvent"]) : undefined;
            this.tournamentImportBatch = _data["tournamentImportBatch"] ? TournamentImportBatch.fromJS(_data["tournamentImportBatch"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentImportBatchPlayer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentImportBatchId"] = this.tournamentImportBatchId;
        data["tournamentEventId"] = this.tournamentEventId;
        data["programNumber"] = this.programNumber;
        data["playerNumber"] = this.playerNumber;
        data["name"] = this.name;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined;
        data["gender"] = this.gender;
        data["clubNumber"] = this.clubNumber;
        data["ranking"] = this.ranking;
        data["points"] = this.points;
        data["playOffIndex"] = this.playOffIndex;
        data["playoffName"] = this.playoffName;
        data["playerId"] = this.playerId;
        data["clubId"] = this.clubId;
        data["pointsCount"] = this.pointsCount;
        data["points2"] = this.points2;
        data["clubName"] = this.clubName;
        data["tournamentImportBatchPlayerId"] = this.tournamentImportBatchPlayerId;
        data["tournamentEvent"] = this.tournamentEvent ? this.tournamentEvent.toJSON() : undefined;
        data["tournamentImportBatch"] = this.tournamentImportBatch ? this.tournamentImportBatch.toJSON() : undefined;
        return data;
    }
}
export class TournamentRegistration {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentRegistrationId = _data["tournamentRegistrationId"];
            this.tournamentEventId = _data["tournamentEventId"];
            this.userId = _data["userId"];
            this.registrationTime = _data["registrationTime"] ? new Date(_data["registrationTime"].toString()) : undefined;
            this.workId = _data["workId"];
            this.deleted = _data["deleted"];
            this.deletedByUserId = _data["deletedByUserId"];
            this.logMessage = _data["logMessage"];
            this.tournamentEvent = _data["tournamentEvent"] ? TournamentEvent.fromJS(_data["tournamentEvent"]) : undefined;
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
            this.tournamentRegistrationClub = _data["tournamentRegistrationClub"] ? TournamentRegistrationClub.fromJS(_data["tournamentRegistrationClub"]) : undefined;
            if (Array.isArray(_data["orderItemRegistration"])) {
                this.orderItemRegistration = [];
                for (let item of _data["orderItemRegistration"])
                    this.orderItemRegistration.push(OrderItemRegistration.fromJS(item));
            }
            if (Array.isArray(_data["tournamentRegistrationPlayer"])) {
                this.tournamentRegistrationPlayer = [];
                for (let item of _data["tournamentRegistrationPlayer"])
                    this.tournamentRegistrationPlayer.push(TournamentRegistrationPlayer.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentRegistration();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentRegistrationId"] = this.tournamentRegistrationId;
        data["tournamentEventId"] = this.tournamentEventId;
        data["userId"] = this.userId;
        data["registrationTime"] = this.registrationTime ? this.registrationTime.toISOString() : undefined;
        data["workId"] = this.workId;
        data["deleted"] = this.deleted;
        data["deletedByUserId"] = this.deletedByUserId;
        data["logMessage"] = this.logMessage;
        data["tournamentEvent"] = this.tournamentEvent ? this.tournamentEvent.toJSON() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["tournamentRegistrationClub"] = this.tournamentRegistrationClub ? this.tournamentRegistrationClub.toJSON() : undefined;
        if (Array.isArray(this.orderItemRegistration)) {
            data["orderItemRegistration"] = [];
            for (let item of this.orderItemRegistration)
                data["orderItemRegistration"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentRegistrationPlayer)) {
            data["tournamentRegistrationPlayer"] = [];
            for (let item of this.tournamentRegistrationPlayer)
                data["tournamentRegistrationPlayer"].push(item.toJSON());
        }
        return data;
    }
}
export class TournamentRegistrationClub {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentRegistrationId = _data["tournamentRegistrationId"];
            this.clubId = _data["clubId"];
            this.completed = _data["completed"];
            this.orderItemRegistrationId = _data["orderItemRegistrationId"];
            this.fieldValueList = _data["fieldValueList"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.orderItemRegistration = _data["orderItemRegistration"] ? OrderItemRegistration.fromJS(_data["orderItemRegistration"]) : undefined;
            this.tournamentRegistration = _data["tournamentRegistration"] ? TournamentRegistration.fromJS(_data["tournamentRegistration"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentRegistrationClub();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentRegistrationId"] = this.tournamentRegistrationId;
        data["clubId"] = this.clubId;
        data["completed"] = this.completed;
        data["orderItemRegistrationId"] = this.orderItemRegistrationId;
        data["fieldValueList"] = this.fieldValueList;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["orderItemRegistration"] = this.orderItemRegistration ? this.orderItemRegistration.toJSON() : undefined;
        data["tournamentRegistration"] = this.tournamentRegistration ? this.tournamentRegistration.toJSON() : undefined;
        return data;
    }
}
export class TournamentRegistrationPlayer {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentRegistrationId = _data["tournamentRegistrationId"];
            this.index = _data["index"];
            this.playerId = _data["playerId"];
            this.clubId = _data["clubId"];
            this.completed = _data["completed"];
            this.orderItemRegistrationId = _data["orderItemRegistrationId"];
            this.fieldValueList = _data["fieldValueList"];
            this.rejected = _data["rejected"];
            this.confirmedByUserId = _data["confirmedByUserId"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.confirmedByUser = _data["confirmedByUser"] ? User1.fromJS(_data["confirmedByUser"]) : undefined;
            this.orderItemRegistration = _data["orderItemRegistration"] ? OrderItemRegistration.fromJS(_data["orderItemRegistration"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.tournamentRegistration = _data["tournamentRegistration"] ? TournamentRegistration.fromJS(_data["tournamentRegistration"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentRegistrationPlayer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentRegistrationId"] = this.tournamentRegistrationId;
        data["index"] = this.index;
        data["playerId"] = this.playerId;
        data["clubId"] = this.clubId;
        data["completed"] = this.completed;
        data["orderItemRegistrationId"] = this.orderItemRegistrationId;
        data["fieldValueList"] = this.fieldValueList;
        data["rejected"] = this.rejected;
        data["confirmedByUserId"] = this.confirmedByUserId;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["confirmedByUser"] = this.confirmedByUser ? this.confirmedByUser.toJSON() : undefined;
        data["orderItemRegistration"] = this.orderItemRegistration ? this.orderItemRegistration.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["tournamentRegistration"] = this.tournamentRegistration ? this.tournamentRegistration.toJSON() : undefined;
        return data;
    }
}
export class OrderItemRegistrationClub {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orderItemRegistrationId = _data["orderItemRegistrationId"];
            this.clubId = _data["clubId"];
            this.price = _data["price"];
            this.complete = _data["complete"];
            this.administrationFee = _data["administrationFee"];
            this.fieldValueList = _data["fieldValueList"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.orderItemRegistration = _data["orderItemRegistration"] ? OrderItemRegistration.fromJS(_data["orderItemRegistration"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemRegistrationClub();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["orderItemRegistrationId"] = this.orderItemRegistrationId;
        data["clubId"] = this.clubId;
        data["price"] = this.price;
        data["complete"] = this.complete;
        data["administrationFee"] = this.administrationFee;
        data["fieldValueList"] = this.fieldValueList;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["orderItemRegistration"] = this.orderItemRegistration ? this.orderItemRegistration.toJSON() : undefined;
        return data;
    }
}
export class OrderItemRegistrationPlayer {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orderItemRegistrationId = _data["orderItemRegistrationId"];
            this.index = _data["index"];
            this.playerId = _data["playerId"];
            this.clubId = _data["clubId"];
            this.price = _data["price"];
            this.complete = _data["complete"];
            this.administrationFee = _data["administrationFee"];
            this.fieldValueList = _data["fieldValueList"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.orderItemRegistration = _data["orderItemRegistration"] ? OrderItemRegistration.fromJS(_data["orderItemRegistration"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemRegistrationPlayer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["orderItemRegistrationId"] = this.orderItemRegistrationId;
        data["index"] = this.index;
        data["playerId"] = this.playerId;
        data["clubId"] = this.clubId;
        data["price"] = this.price;
        data["complete"] = this.complete;
        data["administrationFee"] = this.administrationFee;
        data["fieldValueList"] = this.fieldValueList;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["orderItemRegistration"] = this.orderItemRegistration ? this.orderItemRegistration.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        return data;
    }
}
export class DbfrankingListPlayerExternPoint {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dbfrankingListPlayerExternPointId = _data["dbfrankingListPlayerExternPointId"];
            this.rankingListId = _data["rankingListId"];
            this.seasonId = _data["seasonId"];
            this.playerId = _data["playerId"];
            this.text = _data["text"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined;
            this.tournamentId = _data["tournamentId"];
            this.points = _data["points"];
            this.matchesWon = _data["matchesWon"];
            this.matchesLost = _data["matchesLost"];
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.rankingList = _data["rankingList"] ? RankingList.fromJS(_data["rankingList"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
            this.tournament = _data["tournament"] ? Tournament1.fromJS(_data["tournament"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfrankingListPlayerExternPoint();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dbfrankingListPlayerExternPointId"] = this.dbfrankingListPlayerExternPointId;
        data["rankingListId"] = this.rankingListId;
        data["seasonId"] = this.seasonId;
        data["playerId"] = this.playerId;
        data["text"] = this.text;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["tournamentId"] = this.tournamentId;
        data["points"] = this.points;
        data["matchesWon"] = this.matchesWon;
        data["matchesLost"] = this.matchesLost;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["rankingList"] = this.rankingList ? this.rankingList.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined;
        return data;
    }
}
export class RankingList {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListId = _data["rankingListId"];
            this.unionId = _data["unionId"];
            this.name = _data["name"];
            this.categoryCode = _data["categoryCode"];
            this.gender = _data["gender"];
            this.ageGroupId = _data["ageGroupId"];
            this.classId = _data["classId"];
            this.disciplineCode = _data["disciplineCode"];
            this.groupPlayers = _data["groupPlayers"];
            this.maxWeeks = _data["maxWeeks"];
            this.minResults = _data["minResults"];
            this.maxResults = _data["maxResults"];
            this.autoAddPlayers = _data["autoAddPlayers"];
            this.minPoints = _data["minPoints"];
            this.autoUpdatePoints = _data["autoUpdatePoints"];
            this.export = _data["export"];
            this.maxVersionDays = _data["maxVersionDays"];
            this.active = _data["active"];
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.class = _data["class"] ? Class.fromJS(_data["class"]) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            if (Array.isArray(_data["dbfrankingListPlayerExternPoint"])) {
                this.dbfrankingListPlayerExternPoint = [];
                for (let item of _data["dbfrankingListPlayerExternPoint"])
                    this.dbfrankingListPlayerExternPoint.push(DbfrankingListPlayerExternPoint.fromJS(item));
            }
            if (Array.isArray(_data["dbfratingAdjustment"])) {
                this.dbfratingAdjustment = [];
                for (let item of _data["dbfratingAdjustment"])
                    this.dbfratingAdjustment.push(DbfratingAdjustment.fromJS(item));
            }
            if (Array.isArray(_data["dbfratingListClassInterval"])) {
                this.dbfratingListClassInterval = [];
                for (let item of _data["dbfratingListClassInterval"])
                    this.dbfratingListClassInterval.push(DbfratingListClassInterval.fromJS(item));
            }
            if (Array.isArray(_data["dbfratingListStartPoints"])) {
                this.dbfratingListStartPoints = [];
                for (let item of _data["dbfratingListStartPoints"])
                    this.dbfratingListStartPoints.push(DbfratingListStartPoints.fromJS(item));
            }
            if (Array.isArray(_data["rankingListClassInterval"])) {
                this.rankingListClassInterval = [];
                for (let item of _data["rankingListClassInterval"])
                    this.rankingListClassInterval.push(RankingListClassInterval.fromJS(item));
            }
            if (Array.isArray(_data["rankingListPlayer"])) {
                this.rankingListPlayer = [];
                for (let item of _data["rankingListPlayer"])
                    this.rankingListPlayer.push(RankingListPlayer.fromJS(item));
            }
            if (Array.isArray(_data["rankingListPromotionNextRankingList"])) {
                this.rankingListPromotionNextRankingList = [];
                for (let item of _data["rankingListPromotionNextRankingList"])
                    this.rankingListPromotionNextRankingList.push(RankingListPromotion.fromJS(item));
            }
            if (Array.isArray(_data["rankingListPromotionRankingList"])) {
                this.rankingListPromotionRankingList = [];
                for (let item of _data["rankingListPromotionRankingList"])
                    this.rankingListPromotionRankingList.push(RankingListPromotion.fromJS(item));
            }
            if (Array.isArray(_data["rankingListVersion"])) {
                this.rankingListVersion = [];
                for (let item of _data["rankingListVersion"])
                    this.rankingListVersion.push(RankingListVersion.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RankingList();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListId"] = this.rankingListId;
        data["unionId"] = this.unionId;
        data["name"] = this.name;
        data["categoryCode"] = this.categoryCode;
        data["gender"] = this.gender;
        data["ageGroupId"] = this.ageGroupId;
        data["classId"] = this.classId;
        data["disciplineCode"] = this.disciplineCode;
        data["groupPlayers"] = this.groupPlayers;
        data["maxWeeks"] = this.maxWeeks;
        data["minResults"] = this.minResults;
        data["maxResults"] = this.maxResults;
        data["autoAddPlayers"] = this.autoAddPlayers;
        data["minPoints"] = this.minPoints;
        data["autoUpdatePoints"] = this.autoUpdatePoints;
        data["export"] = this.export;
        data["maxVersionDays"] = this.maxVersionDays;
        data["active"] = this.active;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["class"] = this.class ? this.class.toJSON() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        if (Array.isArray(this.dbfrankingListPlayerExternPoint)) {
            data["dbfrankingListPlayerExternPoint"] = [];
            for (let item of this.dbfrankingListPlayerExternPoint)
                data["dbfrankingListPlayerExternPoint"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfratingAdjustment)) {
            data["dbfratingAdjustment"] = [];
            for (let item of this.dbfratingAdjustment)
                data["dbfratingAdjustment"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfratingListClassInterval)) {
            data["dbfratingListClassInterval"] = [];
            for (let item of this.dbfratingListClassInterval)
                data["dbfratingListClassInterval"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfratingListStartPoints)) {
            data["dbfratingListStartPoints"] = [];
            for (let item of this.dbfratingListStartPoints)
                data["dbfratingListStartPoints"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListClassInterval)) {
            data["rankingListClassInterval"] = [];
            for (let item of this.rankingListClassInterval)
                data["rankingListClassInterval"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListPlayer)) {
            data["rankingListPlayer"] = [];
            for (let item of this.rankingListPlayer)
                data["rankingListPlayer"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListPromotionNextRankingList)) {
            data["rankingListPromotionNextRankingList"] = [];
            for (let item of this.rankingListPromotionNextRankingList)
                data["rankingListPromotionNextRankingList"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListPromotionRankingList)) {
            data["rankingListPromotionRankingList"] = [];
            for (let item of this.rankingListPromotionRankingList)
                data["rankingListPromotionRankingList"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListVersion)) {
            data["rankingListVersion"] = [];
            for (let item of this.rankingListVersion)
                data["rankingListVersion"].push(item.toJSON());
        }
        return data;
    }
}
export class DbfratingAdjustment {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankinglistId = _data["rankinglistId"];
            this.diff1 = _data["diff1"];
            this.diff2 = _data["diff2"];
            this.points1 = _data["points1"];
            this.points2 = _data["points2"];
            this.ageGroupId = _data["ageGroupId"];
            this.pointsWinner = _data["pointsWinner"];
            this.pointsLoser = _data["pointsLoser"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined;
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.rankinglist = _data["rankinglist"] ? RankingList.fromJS(_data["rankinglist"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfratingAdjustment();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankinglistId"] = this.rankinglistId;
        data["diff1"] = this.diff1;
        data["diff2"] = this.diff2;
        data["points1"] = this.points1;
        data["points2"] = this.points2;
        data["ageGroupId"] = this.ageGroupId;
        data["pointsWinner"] = this.pointsWinner;
        data["pointsLoser"] = this.pointsLoser;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["rankinglist"] = this.rankinglist ? this.rankinglist.toJSON() : undefined;
        return data;
    }
}
export class DbfratingListClassInterval {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankinglistId = _data["rankinglistId"];
            this.ageGroupId = _data["ageGroupId"];
            this.gender = _data["gender"];
            this.points1 = _data["points1"];
            this.points2 = _data["points2"];
            this.ranking1 = _data["ranking1"];
            this.ranking2 = _data["ranking2"];
            this.lowClassId = _data["lowClassId"];
            this.highClassId = _data["highClassId"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined;
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.highClass = _data["highClass"] ? Class.fromJS(_data["highClass"]) : undefined;
            this.lowClass = _data["lowClass"] ? Class.fromJS(_data["lowClass"]) : undefined;
            this.rankinglist = _data["rankinglist"] ? RankingList.fromJS(_data["rankinglist"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfratingListClassInterval();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankinglistId"] = this.rankinglistId;
        data["ageGroupId"] = this.ageGroupId;
        data["gender"] = this.gender;
        data["points1"] = this.points1;
        data["points2"] = this.points2;
        data["ranking1"] = this.ranking1;
        data["ranking2"] = this.ranking2;
        data["lowClassId"] = this.lowClassId;
        data["highClassId"] = this.highClassId;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["highClass"] = this.highClass ? this.highClass.toJSON() : undefined;
        data["lowClass"] = this.lowClass ? this.lowClass.toJSON() : undefined;
        data["rankinglist"] = this.rankinglist ? this.rankinglist.toJSON() : undefined;
        return data;
    }
}
export class DbfratingListStartPoints {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankinglistId = _data["rankinglistId"];
            this.ageGroupId = _data["ageGroupId"];
            this.gender = _data["gender"];
            this.startPoints = _data["startPoints"];
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.rankinglist = _data["rankinglist"] ? RankingList.fromJS(_data["rankinglist"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfratingListStartPoints();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankinglistId"] = this.rankinglistId;
        data["ageGroupId"] = this.ageGroupId;
        data["gender"] = this.gender;
        data["startPoints"] = this.startPoints;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["rankinglist"] = this.rankinglist ? this.rankinglist.toJSON() : undefined;
        return data;
    }
}
export class RankingListClassInterval {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListId = _data["rankingListId"];
            this.classId = _data["classId"];
            this.highRanking = _data["highRanking"];
            this.lowRanking = _data["lowRanking"];
            this.class = _data["class"] ? Class.fromJS(_data["class"]) : undefined;
            this.rankingList = _data["rankingList"] ? RankingList.fromJS(_data["rankingList"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RankingListClassInterval();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListId"] = this.rankingListId;
        data["classId"] = this.classId;
        data["highRanking"] = this.highRanking;
        data["lowRanking"] = this.lowRanking;
        data["class"] = this.class ? this.class.toJSON() : undefined;
        data["rankingList"] = this.rankingList ? this.rankingList.toJSON() : undefined;
        return data;
    }
}
export class RankingListPlayer {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListPlayerId = _data["rankingListPlayerId"];
            this.rankingListId = _data["rankingListId"];
            this.playerId = _data["playerId"];
            this.rankingListPlayerGroupId = _data["rankingListPlayerGroupId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.startPoints = _data["startPoints"];
            this.updatedByUserId = _data["updatedByUserId"];
            this.updatedTime = _data["updatedTime"] ? new Date(_data["updatedTime"].toString()) : undefined;
            this.deleted = _data["deleted"];
            this.validated = _data["validated"];
            this.comment = _data["comment"];
            this.seasonId = _data["seasonId"];
            this.promotedDate = _data["promotedDate"] ? new Date(_data["promotedDate"].toString()) : undefined;
            this.validatedDate = _data["validatedDate"] ? new Date(_data["validatedDate"].toString()) : undefined;
            this.startMatchCount = _data["startMatchCount"];
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.rankingList = _data["rankingList"] ? RankingList.fromJS(_data["rankingList"]) : undefined;
            this.rankingListPlayerGroup = _data["rankingListPlayerGroup"] ? RankingListPlayerGroup.fromJS(_data["rankingListPlayerGroup"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
            this.updatedByUser = _data["updatedByUser"] ? User1.fromJS(_data["updatedByUser"]) : undefined;
            this.dbfrankinglistPlayerRating = _data["dbfrankinglistPlayerRating"] ? DbfrankinglistPlayerRating.fromJS(_data["dbfrankinglistPlayerRating"]) : undefined;
            if (Array.isArray(_data["dbfrankingListPlayerClass"])) {
                this.dbfrankingListPlayerClass = [];
                for (let item of _data["dbfrankingListPlayerClass"])
                    this.dbfrankingListPlayerClass.push(DbfrankingListPlayerClass.fromJS(item));
            }
            if (Array.isArray(_data["dbfrankingListPlayerPoint"])) {
                this.dbfrankingListPlayerPoint = [];
                for (let item of _data["dbfrankingListPlayerPoint"])
                    this.dbfrankingListPlayerPoint.push(DbfrankingListPlayerPoint.fromJS(item));
            }
            if (Array.isArray(_data["dbfrankingListPlayerPointLeague"])) {
                this.dbfrankingListPlayerPointLeague = [];
                for (let item of _data["dbfrankingListPlayerPointLeague"])
                    this.dbfrankingListPlayerPointLeague.push(DbfrankingListPlayerPointLeague.fromJS(item));
            }
            if (Array.isArray(_data["rankingListPlayerPoint"])) {
                this.rankingListPlayerPoint = [];
                for (let item of _data["rankingListPlayerPoint"])
                    this.rankingListPlayerPoint.push(RankingListPlayerPoint.fromJS(item));
            }
            if (Array.isArray(_data["rankingListVersionPlayer"])) {
                this.rankingListVersionPlayer = [];
                for (let item of _data["rankingListVersionPlayer"])
                    this.rankingListVersionPlayer.push(RankingListVersionPlayer.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RankingListPlayer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListPlayerId"] = this.rankingListPlayerId;
        data["rankingListId"] = this.rankingListId;
        data["playerId"] = this.playerId;
        data["rankingListPlayerGroupId"] = this.rankingListPlayerGroupId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["startPoints"] = this.startPoints;
        data["updatedByUserId"] = this.updatedByUserId;
        data["updatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : undefined;
        data["deleted"] = this.deleted;
        data["validated"] = this.validated;
        data["comment"] = this.comment;
        data["seasonId"] = this.seasonId;
        data["promotedDate"] = this.promotedDate ? this.promotedDate.toISOString() : undefined;
        data["validatedDate"] = this.validatedDate ? this.validatedDate.toISOString() : undefined;
        data["startMatchCount"] = this.startMatchCount;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["rankingList"] = this.rankingList ? this.rankingList.toJSON() : undefined;
        data["rankingListPlayerGroup"] = this.rankingListPlayerGroup ? this.rankingListPlayerGroup.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        data["updatedByUser"] = this.updatedByUser ? this.updatedByUser.toJSON() : undefined;
        data["dbfrankinglistPlayerRating"] = this.dbfrankinglistPlayerRating ? this.dbfrankinglistPlayerRating.toJSON() : undefined;
        if (Array.isArray(this.dbfrankingListPlayerClass)) {
            data["dbfrankingListPlayerClass"] = [];
            for (let item of this.dbfrankingListPlayerClass)
                data["dbfrankingListPlayerClass"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfrankingListPlayerPoint)) {
            data["dbfrankingListPlayerPoint"] = [];
            for (let item of this.dbfrankingListPlayerPoint)
                data["dbfrankingListPlayerPoint"].push(item.toJSON());
        }
        if (Array.isArray(this.dbfrankingListPlayerPointLeague)) {
            data["dbfrankingListPlayerPointLeague"] = [];
            for (let item of this.dbfrankingListPlayerPointLeague)
                data["dbfrankingListPlayerPointLeague"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListPlayerPoint)) {
            data["rankingListPlayerPoint"] = [];
            for (let item of this.rankingListPlayerPoint)
                data["rankingListPlayerPoint"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListVersionPlayer)) {
            data["rankingListVersionPlayer"] = [];
            for (let item of this.rankingListVersionPlayer)
                data["rankingListVersionPlayer"].push(item.toJSON());
        }
        return data;
    }
}
export class RankingListPlayerGroup {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListPlayerGroupId = _data["rankingListPlayerGroupId"];
            this.playerIdlist = _data["playerIdlist"];
            if (Array.isArray(_data["rankingListPlayer"])) {
                this.rankingListPlayer = [];
                for (let item of _data["rankingListPlayer"])
                    this.rankingListPlayer.push(RankingListPlayer.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RankingListPlayerGroup();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListPlayerGroupId"] = this.rankingListPlayerGroupId;
        data["playerIdlist"] = this.playerIdlist;
        if (Array.isArray(this.rankingListPlayer)) {
            data["rankingListPlayer"] = [];
            for (let item of this.rankingListPlayer)
                data["rankingListPlayer"].push(item.toJSON());
        }
        return data;
    }
}
export class DbfrankinglistPlayerRating {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListPlayerId = _data["rankingListPlayerId"];
            this.isBeginner = _data["isBeginner"];
            this.rankingListPlayer = _data["rankingListPlayer"] ? RankingListPlayer.fromJS(_data["rankingListPlayer"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfrankinglistPlayerRating();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListPlayerId"] = this.rankingListPlayerId;
        data["isBeginner"] = this.isBeginner;
        data["rankingListPlayer"] = this.rankingListPlayer ? this.rankingListPlayer.toJSON() : undefined;
        return data;
    }
}
export class DbfrankingListPlayerClass {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListVersionId = _data["rankingListVersionId"];
            this.rankingListPlayerId = _data["rankingListPlayerId"];
            this.ageGroupId = _data["ageGroupId"];
            this.lowClassId = _data["lowClassId"];
            this.highClassId = _data["highClassId"];
            this.ranking = _data["ranking"];
            this.clubId = _data["clubId"];
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.highClass = _data["highClass"] ? Class.fromJS(_data["highClass"]) : undefined;
            this.lowClass = _data["lowClass"] ? Class.fromJS(_data["lowClass"]) : undefined;
            this.rankingListPlayer = _data["rankingListPlayer"] ? RankingListPlayer.fromJS(_data["rankingListPlayer"]) : undefined;
            this.rankingListVersion = _data["rankingListVersion"] ? RankingListVersion.fromJS(_data["rankingListVersion"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfrankingListPlayerClass();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListVersionId"] = this.rankingListVersionId;
        data["rankingListPlayerId"] = this.rankingListPlayerId;
        data["ageGroupId"] = this.ageGroupId;
        data["lowClassId"] = this.lowClassId;
        data["highClassId"] = this.highClassId;
        data["ranking"] = this.ranking;
        data["clubId"] = this.clubId;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["highClass"] = this.highClass ? this.highClass.toJSON() : undefined;
        data["lowClass"] = this.lowClass ? this.lowClass.toJSON() : undefined;
        data["rankingListPlayer"] = this.rankingListPlayer ? this.rankingListPlayer.toJSON() : undefined;
        data["rankingListVersion"] = this.rankingListVersion ? this.rankingListVersion.toJSON() : undefined;
        return data;
    }
}
export class RankingListVersion {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListVersionId = _data["rankingListVersionId"];
            this.rankingListId = _data["rankingListId"];
            this.seasonId = _data["seasonId"];
            this.versionDate = _data["versionDate"] ? new Date(_data["versionDate"].toString()) : undefined;
            this.updateTime = _data["updateTime"] ? new Date(_data["updateTime"].toString()) : undefined;
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined;
            this.active = _data["active"];
            this.text = _data["text"];
            this.rankingList = _data["rankingList"] ? RankingList.fromJS(_data["rankingList"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
            this.rankingListVersionLatest = _data["rankingListVersionLatest"] ? RankingListVersionLatest.fromJS(_data["rankingListVersionLatest"]) : undefined;
            if (Array.isArray(_data["dbfrankingListPlayerClass"])) {
                this.dbfrankingListPlayerClass = [];
                for (let item of _data["dbfrankingListPlayerClass"])
                    this.dbfrankingListPlayerClass.push(DbfrankingListPlayerClass.fromJS(item));
            }
            if (Array.isArray(_data["rankingListVersionPlayer"])) {
                this.rankingListVersionPlayer = [];
                for (let item of _data["rankingListVersionPlayer"])
                    this.rankingListVersionPlayer.push(RankingListVersionPlayer.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RankingListVersion();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListVersionId"] = this.rankingListVersionId;
        data["rankingListId"] = this.rankingListId;
        data["seasonId"] = this.seasonId;
        data["versionDate"] = this.versionDate ? this.versionDate.toISOString() : undefined;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : undefined;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined;
        data["active"] = this.active;
        data["text"] = this.text;
        data["rankingList"] = this.rankingList ? this.rankingList.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        data["rankingListVersionLatest"] = this.rankingListVersionLatest ? this.rankingListVersionLatest.toJSON() : undefined;
        if (Array.isArray(this.dbfrankingListPlayerClass)) {
            data["dbfrankingListPlayerClass"] = [];
            for (let item of this.dbfrankingListPlayerClass)
                data["dbfrankingListPlayerClass"].push(item.toJSON());
        }
        if (Array.isArray(this.rankingListVersionPlayer)) {
            data["rankingListVersionPlayer"] = [];
            for (let item of this.rankingListVersionPlayer)
                data["rankingListVersionPlayer"].push(item.toJSON());
        }
        return data;
    }
}
export class RankingListVersionLatest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListVersionId = _data["rankingListVersionId"];
            this.rankingListVersion = _data["rankingListVersion"] ? RankingListVersion.fromJS(_data["rankingListVersion"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RankingListVersionLatest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListVersionId"] = this.rankingListVersionId;
        data["rankingListVersion"] = this.rankingListVersion ? this.rankingListVersion.toJSON() : undefined;
        return data;
    }
}
export class RankingListVersionPlayer {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListVersionId = _data["rankingListVersionId"];
            this.rankingListPlayerId = _data["rankingListPlayerId"];
            this.points = _data["points"];
            this.ranking = _data["ranking"];
            this.lowClassId = _data["lowClassId"];
            this.highClassId = _data["highClassId"];
            this.pointsCount = _data["pointsCount"];
            this.clubId = _data["clubId"];
            this.points2 = _data["points2"];
            this.ranking2 = _data["ranking2"];
            this.rankingListVersionPlayerId = _data["rankingListVersionPlayerId"];
            this.ageGroupId = _data["ageGroupId"];
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.highClass = _data["highClass"] ? Class.fromJS(_data["highClass"]) : undefined;
            this.lowClass = _data["lowClass"] ? Class.fromJS(_data["lowClass"]) : undefined;
            this.rankingListPlayer = _data["rankingListPlayer"] ? RankingListPlayer.fromJS(_data["rankingListPlayer"]) : undefined;
            this.rankingListVersion = _data["rankingListVersion"] ? RankingListVersion.fromJS(_data["rankingListVersion"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RankingListVersionPlayer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListVersionId"] = this.rankingListVersionId;
        data["rankingListPlayerId"] = this.rankingListPlayerId;
        data["points"] = this.points;
        data["ranking"] = this.ranking;
        data["lowClassId"] = this.lowClassId;
        data["highClassId"] = this.highClassId;
        data["pointsCount"] = this.pointsCount;
        data["clubId"] = this.clubId;
        data["points2"] = this.points2;
        data["ranking2"] = this.ranking2;
        data["rankingListVersionPlayerId"] = this.rankingListVersionPlayerId;
        data["ageGroupId"] = this.ageGroupId;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["highClass"] = this.highClass ? this.highClass.toJSON() : undefined;
        data["lowClass"] = this.lowClass ? this.lowClass.toJSON() : undefined;
        data["rankingListPlayer"] = this.rankingListPlayer ? this.rankingListPlayer.toJSON() : undefined;
        data["rankingListVersion"] = this.rankingListVersion ? this.rankingListVersion.toJSON() : undefined;
        return data;
    }
}
export class DbfrankingListPlayerPoint {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListPlayerId = _data["rankingListPlayerId"];
            this.pointType = _data["pointType"];
            this.pointId = _data["pointId"];
            this.pointIndex = _data["pointIndex"];
            this.points = _data["points"];
            this.matchTime = _data["matchTime"] ? new Date(_data["matchTime"].toString()) : undefined;
            this.playerId2 = _data["playerId2"];
            this.rating = _data["rating"];
            this.rating2 = _data["rating2"];
            this.seasonId = _data["seasonId"];
            this.playerId12 = _data["playerId12"];
            this.playerId22 = _data["playerId22"];
            this.rating12 = _data["rating12"];
            this.rating22 = _data["rating22"];
            this.playerId2Navigation = _data["playerId2Navigation"] ? Player.fromJS(_data["playerId2Navigation"]) : undefined;
            this.rankingListPlayer = _data["rankingListPlayer"] ? RankingListPlayer.fromJS(_data["rankingListPlayer"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfrankingListPlayerPoint();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListPlayerId"] = this.rankingListPlayerId;
        data["pointType"] = this.pointType;
        data["pointId"] = this.pointId;
        data["pointIndex"] = this.pointIndex;
        data["points"] = this.points;
        data["matchTime"] = this.matchTime ? this.matchTime.toISOString() : undefined;
        data["playerId2"] = this.playerId2;
        data["rating"] = this.rating;
        data["rating2"] = this.rating2;
        data["seasonId"] = this.seasonId;
        data["playerId12"] = this.playerId12;
        data["playerId22"] = this.playerId22;
        data["rating12"] = this.rating12;
        data["rating22"] = this.rating22;
        data["playerId2Navigation"] = this.playerId2Navigation ? this.playerId2Navigation.toJSON() : undefined;
        data["rankingListPlayer"] = this.rankingListPlayer ? this.rankingListPlayer.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        return data;
    }
}
export class DbfrankingListPlayerPointLeague {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.seasonId = _data["seasonId"];
            this.rankingListPlayerId = _data["rankingListPlayerId"];
            this.pointId = _data["pointId"];
            this.winnerAgeGroupId1 = _data["winnerAgeGroupId1"];
            this.winnerClassId1 = _data["winnerClassId1"];
            this.winnerGender1 = _data["winnerGender1"];
            this.winnerAgeGroupId2 = _data["winnerAgeGroupId2"];
            this.winnerClassId2 = _data["winnerClassId2"];
            this.winnerGender2 = _data["winnerGender2"];
            this.loserAgeGroupId1 = _data["loserAgeGroupId1"];
            this.loserClassId1 = _data["loserClassId1"];
            this.loserGender1 = _data["loserGender1"];
            this.loserAgeGroupId2 = _data["loserAgeGroupId2"];
            this.loserClassId2 = _data["loserClassId2"];
            this.loserGender2 = _data["loserGender2"];
            this.wo = _data["wo"];
            this.rankingListPlayer = _data["rankingListPlayer"] ? RankingListPlayer.fromJS(_data["rankingListPlayer"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfrankingListPlayerPointLeague();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["seasonId"] = this.seasonId;
        data["rankingListPlayerId"] = this.rankingListPlayerId;
        data["pointId"] = this.pointId;
        data["winnerAgeGroupId1"] = this.winnerAgeGroupId1;
        data["winnerClassId1"] = this.winnerClassId1;
        data["winnerGender1"] = this.winnerGender1;
        data["winnerAgeGroupId2"] = this.winnerAgeGroupId2;
        data["winnerClassId2"] = this.winnerClassId2;
        data["winnerGender2"] = this.winnerGender2;
        data["loserAgeGroupId1"] = this.loserAgeGroupId1;
        data["loserClassId1"] = this.loserClassId1;
        data["loserGender1"] = this.loserGender1;
        data["loserAgeGroupId2"] = this.loserAgeGroupId2;
        data["loserClassId2"] = this.loserClassId2;
        data["loserGender2"] = this.loserGender2;
        data["wo"] = this.wo;
        data["rankingListPlayer"] = this.rankingListPlayer ? this.rankingListPlayer.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        return data;
    }
}
export class RankingListPlayerPoint {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListPlayerId = _data["rankingListPlayerId"];
            this.pointType = _data["pointType"];
            this.pointId = _data["pointId"];
            this.pointIndex = _data["pointIndex"];
            this.points = _data["points"];
            this.matchTime = _data["matchTime"] ? new Date(_data["matchTime"].toString()) : undefined;
            this.pointsCount = _data["pointsCount"];
            this.seasonId = _data["seasonId"];
            this.points2 = _data["points2"];
            this.rankingListPlayer = _data["rankingListPlayer"] ? RankingListPlayer.fromJS(_data["rankingListPlayer"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RankingListPlayerPoint();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListPlayerId"] = this.rankingListPlayerId;
        data["pointType"] = this.pointType;
        data["pointId"] = this.pointId;
        data["pointIndex"] = this.pointIndex;
        data["points"] = this.points;
        data["matchTime"] = this.matchTime ? this.matchTime.toISOString() : undefined;
        data["pointsCount"] = this.pointsCount;
        data["seasonId"] = this.seasonId;
        data["points2"] = this.points2;
        data["rankingListPlayer"] = this.rankingListPlayer ? this.rankingListPlayer.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        return data;
    }
}
export class RankingListPromotion {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListId = _data["rankingListId"];
            this.nextRankingListId = _data["nextRankingListId"];
            this.points = _data["points"];
            this.yearsFrom = _data["yearsFrom"];
            this.yearsTo = _data["yearsTo"];
            this.cutOffDay = _data["cutOffDay"];
            this.cutOffMonth = _data["cutOffMonth"];
            this.rankingListPromotionVersionId = _data["rankingListPromotionVersionId"];
            this.nextRankingList = _data["nextRankingList"] ? RankingList.fromJS(_data["nextRankingList"]) : undefined;
            this.rankingList = _data["rankingList"] ? RankingList.fromJS(_data["rankingList"]) : undefined;
            this.rankingListPromotionVersion = _data["rankingListPromotionVersion"] ? RankingListPromotionVersion.fromJS(_data["rankingListPromotionVersion"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RankingListPromotion();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListId"] = this.rankingListId;
        data["nextRankingListId"] = this.nextRankingListId;
        data["points"] = this.points;
        data["yearsFrom"] = this.yearsFrom;
        data["yearsTo"] = this.yearsTo;
        data["cutOffDay"] = this.cutOffDay;
        data["cutOffMonth"] = this.cutOffMonth;
        data["rankingListPromotionVersionId"] = this.rankingListPromotionVersionId;
        data["nextRankingList"] = this.nextRankingList ? this.nextRankingList.toJSON() : undefined;
        data["rankingList"] = this.rankingList ? this.rankingList.toJSON() : undefined;
        data["rankingListPromotionVersion"] = this.rankingListPromotionVersion ? this.rankingListPromotionVersion.toJSON() : undefined;
        return data;
    }
}
export class RankingListPromotionVersion {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListPromotionVersionId = _data["rankingListPromotionVersionId"];
            this.unionId = _data["unionId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            if (Array.isArray(_data["rankingListPromotion"])) {
                this.rankingListPromotion = [];
                for (let item of _data["rankingListPromotion"])
                    this.rankingListPromotion.push(RankingListPromotion.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RankingListPromotionVersion();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListPromotionVersionId"] = this.rankingListPromotionVersionId;
        data["unionId"] = this.unionId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        if (Array.isArray(this.rankingListPromotion)) {
            data["rankingListPromotion"] = [];
            for (let item of this.rankingListPromotion)
                data["rankingListPromotion"].push(item.toJSON());
        }
        return data;
    }
}
export class DbftmpUnionMember {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.seasonId = _data["seasonId"];
            this.clubId = _data["clubId"];
            this.regionId = _data["regionId"];
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
            this.userPhone = _data["userPhone"];
            this.clubName = _data["clubName"];
            this.clubEmail = _data["clubEmail"];
            this.clubPhone = _data["clubPhone"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbftmpUnionMember();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["seasonId"] = this.seasonId;
        data["clubId"] = this.clubId;
        data["regionId"] = this.regionId;
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        data["userPhone"] = this.userPhone;
        data["clubName"] = this.clubName;
        data["clubEmail"] = this.clubEmail;
        data["clubPhone"] = this.clubPhone;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["region"] = this.region ? this.region.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        return data;
    }
}
export class OrderItemLicense {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.playerId = _data["playerId"];
            this.seasonId = _data["seasonId"];
            this.ageGroupId = _data["ageGroupId"];
            this.classId = _data["classId"];
            this.price = _data["price"];
            this.clubId = _data["clubId"];
            this.licenseId = _data["licenseId"];
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.class = _data["class"] ? Class.fromJS(_data["class"]) : undefined;
            this.license = _data["license"] ? License.fromJS(_data["license"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemLicense();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["playerId"] = this.playerId;
        data["seasonId"] = this.seasonId;
        data["ageGroupId"] = this.ageGroupId;
        data["classId"] = this.classId;
        data["price"] = this.price;
        data["clubId"] = this.clubId;
        data["licenseId"] = this.licenseId;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["class"] = this.class ? this.class.toJSON() : undefined;
        data["license"] = this.license ? this.license.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        return data;
    }
}
export class PlayerClubTransfer {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.seasonId = _data["seasonId"];
            this.playerId = _data["playerId"];
            this.oldClubId = _data["oldClubId"];
            this.newClubId = _data["newClubId"];
            this.comment = _data["comment"];
            this.createdByClubId = _data["createdByClubId"];
            this.createdByUserId = _data["createdByUserId"];
            this.createdTime = _data["createdTime"] ? new Date(_data["createdTime"].toString()) : undefined;
            this.accepted = _data["accepted"];
            this.acceptedByUserId = _data["acceptedByUserId"];
            this.acceptedTime = _data["acceptedTime"] ? new Date(_data["acceptedTime"].toString()) : undefined;
            this.acceptedOld = _data["acceptedOld"];
            this.acceptedOldByUserId = _data["acceptedOldByUserId"];
            this.acceptedOldTime = _data["acceptedOldTime"] ? new Date(_data["acceptedOldTime"].toString()) : undefined;
            this.acceptedNew = _data["acceptedNew"];
            this.acceptedNewByUserId = _data["acceptedNewByUserId"];
            this.acceptedNewTime = _data["acceptedNewTime"] ? new Date(_data["acceptedNewTime"].toString()) : undefined;
            this.playerCategoryId = _data["playerCategoryId"];
            this.oldClubConfirmation = _data["oldClubConfirmation"];
            this.oldClubConfirmation2 = _data["oldClubConfirmation2"];
            this.licenseType = _data["licenseType"];
            this.oldClubComment = _data["oldClubComment"];
            this.relationType = _data["relationType"];
            this.playerClubTransferId = _data["playerClubTransferId"];
            this.acceptedByUser = _data["acceptedByUser"] ? User1.fromJS(_data["acceptedByUser"]) : undefined;
            this.acceptedNewByUser = _data["acceptedNewByUser"] ? User1.fromJS(_data["acceptedNewByUser"]) : undefined;
            this.acceptedOldByUser = _data["acceptedOldByUser"] ? User1.fromJS(_data["acceptedOldByUser"]) : undefined;
            this.createdByClub = _data["createdByClub"] ? Club2.fromJS(_data["createdByClub"]) : undefined;
            this.createdByUser = _data["createdByUser"] ? User1.fromJS(_data["createdByUser"]) : undefined;
            this.newClub = _data["newClub"] ? Club2.fromJS(_data["newClub"]) : undefined;
            this.oldClub = _data["oldClub"] ? Club2.fromJS(_data["oldClub"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerClubTransfer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["seasonId"] = this.seasonId;
        data["playerId"] = this.playerId;
        data["oldClubId"] = this.oldClubId;
        data["newClubId"] = this.newClubId;
        data["comment"] = this.comment;
        data["createdByClubId"] = this.createdByClubId;
        data["createdByUserId"] = this.createdByUserId;
        data["createdTime"] = this.createdTime ? this.createdTime.toISOString() : undefined;
        data["accepted"] = this.accepted;
        data["acceptedByUserId"] = this.acceptedByUserId;
        data["acceptedTime"] = this.acceptedTime ? this.acceptedTime.toISOString() : undefined;
        data["acceptedOld"] = this.acceptedOld;
        data["acceptedOldByUserId"] = this.acceptedOldByUserId;
        data["acceptedOldTime"] = this.acceptedOldTime ? this.acceptedOldTime.toISOString() : undefined;
        data["acceptedNew"] = this.acceptedNew;
        data["acceptedNewByUserId"] = this.acceptedNewByUserId;
        data["acceptedNewTime"] = this.acceptedNewTime ? this.acceptedNewTime.toISOString() : undefined;
        data["playerCategoryId"] = this.playerCategoryId;
        data["oldClubConfirmation"] = this.oldClubConfirmation;
        data["oldClubConfirmation2"] = this.oldClubConfirmation2;
        data["licenseType"] = this.licenseType;
        data["oldClubComment"] = this.oldClubComment;
        data["relationType"] = this.relationType;
        data["playerClubTransferId"] = this.playerClubTransferId;
        data["acceptedByUser"] = this.acceptedByUser ? this.acceptedByUser.toJSON() : undefined;
        data["acceptedNewByUser"] = this.acceptedNewByUser ? this.acceptedNewByUser.toJSON() : undefined;
        data["acceptedOldByUser"] = this.acceptedOldByUser ? this.acceptedOldByUser.toJSON() : undefined;
        data["createdByClub"] = this.createdByClub ? this.createdByClub.toJSON() : undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined;
        data["newClub"] = this.newClub ? this.newClub.toJSON() : undefined;
        data["oldClub"] = this.oldClub ? this.oldClub.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        return data;
    }
}
export class PlayerLicense {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.playerLicenseId = _data["playerLicenseId"];
            this.seasonId = _data["seasonId"];
            this.playerId = _data["playerId"];
            this.ageGroupId = _data["ageGroupId"];
            this.licenseId = _data["licenseId"];
            this.clubId = _data["clubId"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : undefined;
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.license = _data["license"] ? License.fromJS(_data["license"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
            if (Array.isArray(_data["playerLicensePrintBatchLicense"])) {
                this.playerLicensePrintBatchLicense = [];
                for (let item of _data["playerLicensePrintBatchLicense"])
                    this.playerLicensePrintBatchLicense.push(PlayerLicensePrintBatchLicense.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerLicense();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["playerLicenseId"] = this.playerLicenseId;
        data["seasonId"] = this.seasonId;
        data["playerId"] = this.playerId;
        data["ageGroupId"] = this.ageGroupId;
        data["licenseId"] = this.licenseId;
        data["clubId"] = this.clubId;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : undefined;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["license"] = this.license ? this.license.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        if (Array.isArray(this.playerLicensePrintBatchLicense)) {
            data["playerLicensePrintBatchLicense"] = [];
            for (let item of this.playerLicensePrintBatchLicense)
                data["playerLicensePrintBatchLicense"].push(item.toJSON());
        }
        return data;
    }
}
export class PlayerLicensePrintBatchLicense {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.playerLicensePrintBatchId = _data["playerLicensePrintBatchId"];
            this.playerLicenseId = _data["playerLicenseId"];
            this.playerLicense = _data["playerLicense"] ? PlayerLicense.fromJS(_data["playerLicense"]) : undefined;
            this.playerLicensePrintBatch = _data["playerLicensePrintBatch"] ? PlayerLicensePrintBatch.fromJS(_data["playerLicensePrintBatch"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerLicensePrintBatchLicense();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["playerLicensePrintBatchId"] = this.playerLicensePrintBatchId;
        data["playerLicenseId"] = this.playerLicenseId;
        data["playerLicense"] = this.playerLicense ? this.playerLicense.toJSON() : undefined;
        data["playerLicensePrintBatch"] = this.playerLicensePrintBatch ? this.playerLicensePrintBatch.toJSON() : undefined;
        return data;
    }
}
export class PlayerLicensePrintBatch {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.playerLicensePrintBatchId = _data["playerLicensePrintBatchId"];
            this.seasonId = _data["seasonId"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
            if (Array.isArray(_data["playerLicensePrintBatchLicense"])) {
                this.playerLicensePrintBatchLicense = [];
                for (let item of _data["playerLicensePrintBatchLicense"])
                    this.playerLicensePrintBatchLicense.push(PlayerLicensePrintBatchLicense.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerLicensePrintBatch();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["playerLicensePrintBatchId"] = this.playerLicensePrintBatchId;
        data["seasonId"] = this.seasonId;
        data["time"] = this.time ? this.time.toISOString() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        if (Array.isArray(this.playerLicensePrintBatchLicense)) {
            data["playerLicensePrintBatchLicense"] = [];
            for (let item of this.playerLicensePrintBatchLicense)
                data["playerLicensePrintBatchLicense"].push(item.toJSON());
        }
        return data;
    }
}
export class RankingListExternEvent {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListExternEventId = _data["rankingListExternEventId"];
            this.clubId = _data["clubId"];
            this.seasonId = _data["seasonId"];
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined;
            this.url = _data["url"];
            this.eventType = _data["eventType"];
            this.approved = _data["approved"];
            this.updatedUserId = _data["updatedUserId"];
            this.updatedTime = _data["updatedTime"] ? new Date(_data["updatedTime"].toString()) : undefined;
            this.updatedAdminUserId = _data["updatedAdminUserId"];
            this.updatedAdminTime = _data["updatedAdminTime"] ? new Date(_data["updatedAdminTime"].toString()) : undefined;
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.season = _data["season"] ? Season.fromJS(_data["season"]) : undefined;
            this.updatedAdminUser = _data["updatedAdminUser"] ? User1.fromJS(_data["updatedAdminUser"]) : undefined;
            this.updatedUser = _data["updatedUser"] ? User1.fromJS(_data["updatedUser"]) : undefined;
            if (Array.isArray(_data["rankingListExternPoint"])) {
                this.rankingListExternPoint = [];
                for (let item of _data["rankingListExternPoint"])
                    this.rankingListExternPoint.push(RankingListExternPoint.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RankingListExternEvent();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListExternEventId"] = this.rankingListExternEventId;
        data["clubId"] = this.clubId;
        data["seasonId"] = this.seasonId;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["url"] = this.url;
        data["eventType"] = this.eventType;
        data["approved"] = this.approved;
        data["updatedUserId"] = this.updatedUserId;
        data["updatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : undefined;
        data["updatedAdminUserId"] = this.updatedAdminUserId;
        data["updatedAdminTime"] = this.updatedAdminTime ? this.updatedAdminTime.toISOString() : undefined;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["season"] = this.season ? this.season.toJSON() : undefined;
        data["updatedAdminUser"] = this.updatedAdminUser ? this.updatedAdminUser.toJSON() : undefined;
        data["updatedUser"] = this.updatedUser ? this.updatedUser.toJSON() : undefined;
        if (Array.isArray(this.rankingListExternPoint)) {
            data["rankingListExternPoint"] = [];
            for (let item of this.rankingListExternPoint)
                data["rankingListExternPoint"].push(item.toJSON());
        }
        return data;
    }
}
export class RankingListExternPoint {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rankingListExternPointId = _data["rankingListExternPointId"];
            this.rankingListExternEventId = _data["rankingListExternEventId"];
            this.ageGroupId = _data["ageGroupId"];
            this.className = _data["className"];
            this.rankingCategoryId = _data["rankingCategoryId"];
            this.playerId = _data["playerId"];
            this.clubId = _data["clubId"];
            this.disciplineCode = _data["disciplineCode"];
            this.disciplineRanking = _data["disciplineRanking"];
            this.position = _data["position"];
            this.participants = _data["participants"];
            this.points = _data["points"];
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.rankingListExternEvent = _data["rankingListExternEvent"] ? RankingListExternEvent.fromJS(_data["rankingListExternEvent"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RankingListExternPoint();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rankingListExternPointId"] = this.rankingListExternPointId;
        data["rankingListExternEventId"] = this.rankingListExternEventId;
        data["ageGroupId"] = this.ageGroupId;
        data["className"] = this.className;
        data["rankingCategoryId"] = this.rankingCategoryId;
        data["playerId"] = this.playerId;
        data["clubId"] = this.clubId;
        data["disciplineCode"] = this.disciplineCode;
        data["disciplineRanking"] = this.disciplineRanking;
        data["position"] = this.position;
        data["participants"] = this.participants;
        data["points"] = this.points;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["rankingListExternEvent"] = this.rankingListExternEvent ? this.rankingListExternEvent.toJSON() : undefined;
        return data;
    }
}
export class TournamentRoundAgeGroupClass {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.seasonId = _data["seasonId"];
            this.roundId = _data["roundId"];
            this.ageGroupId = _data["ageGroupId"];
            this.classId = _data["classId"];
            this.tournamentApplication = _data["tournamentApplication"];
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.class = _data["class"] ? Class.fromJS(_data["class"]) : undefined;
            this.tournamentRound = _data["tournamentRound"] ? TournamentRound.fromJS(_data["tournamentRound"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentRoundAgeGroupClass();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["seasonId"] = this.seasonId;
        data["roundId"] = this.roundId;
        data["ageGroupId"] = this.ageGroupId;
        data["classId"] = this.classId;
        data["tournamentApplication"] = this.tournamentApplication;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["class"] = this.class ? this.class.toJSON() : undefined;
        data["tournamentRound"] = this.tournamentRound ? this.tournamentRound.toJSON() : undefined;
        return data;
    }
}
export class TournamentApplication {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentId = _data["tournamentId"];
            this.noOfCourts = _data["noOfCourts"];
            this.comment = _data["comment"];
            this.updateByUserId = _data["updateByUserId"];
            this.updatedTime = _data["updatedTime"] ? new Date(_data["updatedTime"].toString()) : undefined;
            this.alternativeRoundId = _data["alternativeRoundId"];
            this.clubUserId = _data["clubUserId"];
            this.regionUserId = _data["regionUserId"];
            this.recurring = _data["recurring"];
            this.weekChanged = _data["weekChanged"];
            this.option1 = _data["option1"];
            this.originalRoundId = _data["originalRoundId"];
            this.originalDateFrom = _data["originalDateFrom"] ? new Date(_data["originalDateFrom"].toString()) : undefined;
            this.originalDateTo = _data["originalDateTo"] ? new Date(_data["originalDateTo"].toString()) : undefined;
            this.clubUser = _data["clubUser"] ? User1.fromJS(_data["clubUser"]) : undefined;
            this.regionUser = _data["regionUser"] ? User1.fromJS(_data["regionUser"]) : undefined;
            this.tournament = _data["tournament"] ? Tournament1.fromJS(_data["tournament"]) : undefined;
            this.updateByUser = _data["updateByUser"] ? User1.fromJS(_data["updateByUser"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentApplication();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentId"] = this.tournamentId;
        data["noOfCourts"] = this.noOfCourts;
        data["comment"] = this.comment;
        data["updateByUserId"] = this.updateByUserId;
        data["updatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : undefined;
        data["alternativeRoundId"] = this.alternativeRoundId;
        data["clubUserId"] = this.clubUserId;
        data["regionUserId"] = this.regionUserId;
        data["recurring"] = this.recurring;
        data["weekChanged"] = this.weekChanged;
        data["option1"] = this.option1;
        data["originalRoundId"] = this.originalRoundId;
        data["originalDateFrom"] = this.originalDateFrom ? this.originalDateFrom.toISOString() : undefined;
        data["originalDateTo"] = this.originalDateTo ? this.originalDateTo.toISOString() : undefined;
        data["clubUser"] = this.clubUser ? this.clubUser.toJSON() : undefined;
        data["regionUser"] = this.regionUser ? this.regionUser.toJSON() : undefined;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined;
        data["updateByUser"] = this.updateByUser ? this.updateByUser.toJSON() : undefined;
        return data;
    }
}
export class OrderItemRegistrationOption {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orderItemRegistrationOptionId = _data["orderItemRegistrationOptionId"];
            this.orderId = _data["orderId"];
            this.tournamentId = _data["tournamentId"];
            this.formId = _data["formId"];
            this.playerId = _data["playerId"];
            this.clubId = _data["clubId"];
            this.price = _data["price"];
            this.administrationFee = _data["administrationFee"];
            this.fieldValueList = _data["fieldValueList"];
            this.leaderPrice = _data["leaderPrice"];
            this.refund = _data["refund"];
            this.refundTime = _data["refundTime"] ? new Date(_data["refundTime"].toString()) : undefined;
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.tournament = _data["tournament"] ? Tournament1.fromJS(_data["tournament"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemRegistrationOption();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["orderItemRegistrationOptionId"] = this.orderItemRegistrationOptionId;
        data["orderId"] = this.orderId;
        data["tournamentId"] = this.tournamentId;
        data["formId"] = this.formId;
        data["playerId"] = this.playerId;
        data["clubId"] = this.clubId;
        data["price"] = this.price;
        data["administrationFee"] = this.administrationFee;
        data["fieldValueList"] = this.fieldValueList;
        data["leaderPrice"] = this.leaderPrice;
        data["refund"] = this.refund;
        data["refundTime"] = this.refundTime ? this.refundTime.toISOString() : undefined;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined;
        return data;
    }
}
export class PlayerDeleted {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.unionId = _data["unionId"];
            this.playerId = _data["playerId"];
            this.playerNumber = _data["playerNumber"];
            this.name = _data["name"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined;
            this.newPlayerId = _data["newPlayerId"];
            this.newPlayerNumber = _data["newPlayerNumber"];
            this.tournamentId = _data["tournamentId"];
            this.tournament = _data["tournament"] ? Tournament1.fromJS(_data["tournament"]) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerDeleted();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["unionId"] = this.unionId;
        data["playerId"] = this.playerId;
        data["playerNumber"] = this.playerNumber;
        data["name"] = this.name;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined;
        data["newPlayerId"] = this.newPlayerId;
        data["newPlayerNumber"] = this.newPlayerNumber;
        data["tournamentId"] = this.tournamentId;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        return data;
    }
}
export class TournamentClassApplication {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentClassApplicationId = _data["tournamentClassApplicationId"];
            this.tournamentId = _data["tournamentId"];
            this.ageGroupId = _data["ageGroupId"];
            this.classId = _data["classId"];
            this.classCode = _data["classCode"];
            this.classDateFrom = _data["classDateFrom"] ? new Date(_data["classDateFrom"].toString()) : undefined;
            this.classDateTo = _data["classDateTo"] ? new Date(_data["classDateTo"].toString()) : undefined;
            this.ageGroup = _data["ageGroup"] ? AgeGroup.fromJS(_data["ageGroup"]) : undefined;
            this.class = _data["class"] ? Class.fromJS(_data["class"]) : undefined;
            this.tournament = _data["tournament"] ? Tournament1.fromJS(_data["tournament"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentClassApplication();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentClassApplicationId"] = this.tournamentClassApplicationId;
        data["tournamentId"] = this.tournamentId;
        data["ageGroupId"] = this.ageGroupId;
        data["classId"] = this.classId;
        data["classCode"] = this.classCode;
        data["classDateFrom"] = this.classDateFrom ? this.classDateFrom.toISOString() : undefined;
        data["classDateTo"] = this.classDateTo ? this.classDateTo.toISOString() : undefined;
        data["ageGroup"] = this.ageGroup ? this.ageGroup.toJSON() : undefined;
        data["class"] = this.class ? this.class.toJSON() : undefined;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined;
        return data;
    }
}
export class TournamentImportPlayer {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentId = _data["tournamentId"];
            this.playerId = _data["playerId"];
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.tournament = _data["tournament"] ? Tournament1.fromJS(_data["tournament"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentImportPlayer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentId"] = this.tournamentId;
        data["playerId"] = this.playerId;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined;
        return data;
    }
}
export class TournamentLateRegistrationUser {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentLateRegistrationUserId = _data["tournamentLateRegistrationUserId"];
            this.tournamentId = _data["tournamentId"];
            this.userId = _data["userId"];
            this.lastRegistration = _data["lastRegistration"] ? new Date(_data["lastRegistration"].toString()) : undefined;
            this.used = _data["used"];
            this.tournament = _data["tournament"] ? Tournament1.fromJS(_data["tournament"]) : undefined;
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentLateRegistrationUser();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentLateRegistrationUserId"] = this.tournamentLateRegistrationUserId;
        data["tournamentId"] = this.tournamentId;
        data["userId"] = this.userId;
        data["lastRegistration"] = this.lastRegistration ? this.lastRegistration.toISOString() : undefined;
        data["used"] = this.used;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class TournamentMessage {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentId = _data["tournamentId"];
            this.messageId = _data["messageId"];
            this.message = _data["message"] ? Message.fromJS(_data["message"]) : undefined;
            this.tournament = _data["tournament"] ? Tournament1.fromJS(_data["tournament"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentMessage();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentId"] = this.tournamentId;
        data["messageId"] = this.messageId;
        data["message"] = this.message ? this.message.toJSON() : undefined;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined;
        return data;
    }
}
export class TournamentOptionField {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentId = _data["tournamentId"];
            this.index = _data["index"];
            this.name = _data["name"];
            this.valueList = _data["valueList"];
            this.player = _data["player"];
            this.leader = _data["leader"];
            this.registration = _data["registration"];
            this.fieldType = _data["fieldType"];
            this.tournament = _data["tournament"] ? Tournament1.fromJS(_data["tournament"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentOptionField();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentId"] = this.tournamentId;
        data["index"] = this.index;
        data["name"] = this.name;
        data["valueList"] = this.valueList;
        data["player"] = this.player;
        data["leader"] = this.leader;
        data["registration"] = this.registration;
        data["fieldType"] = this.fieldType;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined;
        return data;
    }
}
export class TournamentRegion {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentId = _data["tournamentId"];
            this.regionId = _data["regionId"];
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined;
            this.tournament = _data["tournament"] ? Tournament1.fromJS(_data["tournament"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentRegion();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentId"] = this.tournamentId;
        data["regionId"] = this.regionId;
        data["region"] = this.region ? this.region.toJSON() : undefined;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined;
        return data;
    }
}
export class ClubRegion {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.regionId = _data["regionId"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClubRegion();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["regionId"] = this.regionId;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["region"] = this.region ? this.region.toJSON() : undefined;
        return data;
    }
}
export class LeagueDivisionRegion {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueDivisionId = _data["leagueDivisionId"];
            this.regionId = _data["regionId"];
            this.leagueDivision = _data["leagueDivision"] ? LeagueDivision.fromJS(_data["leagueDivision"]) : undefined;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueDivisionRegion();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueDivisionId"] = this.leagueDivisionId;
        data["regionId"] = this.regionId;
        data["leagueDivision"] = this.leagueDivision ? this.leagueDivision.toJSON() : undefined;
        data["region"] = this.region ? this.region.toJSON() : undefined;
        return data;
    }
}
export class TournamentApplicationRegionAccess {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.regionId = _data["regionId"];
            this.ageGroupId = _data["ageGroupId"];
            this.classId = _data["classId"];
            this.access = _data["access"];
            this.class = _data["class"] ? Class.fromJS(_data["class"]) : undefined;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentApplicationRegionAccess();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["ageGroupId"] = this.ageGroupId;
        data["classId"] = this.classId;
        data["access"] = this.access;
        data["class"] = this.class ? this.class.toJSON() : undefined;
        data["region"] = this.region ? this.region.toJSON() : undefined;
        return data;
    }
}
export class LeagueMatchPlanSchema {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueSchemaId = _data["leagueSchemaId"];
            this.roundIndex = _data["roundIndex"];
            this.matchIndex = _data["matchIndex"];
            this.homeTeamIndex = _data["homeTeamIndex"];
            this.awayTeamIndex = _data["awayTeamIndex"];
            this.organiserTeamIndex = _data["organiserTeamIndex"];
            this.leagueSchema = _data["leagueSchema"] ? LeagueSchema.fromJS(_data["leagueSchema"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchPlanSchema();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueSchemaId"] = this.leagueSchemaId;
        data["roundIndex"] = this.roundIndex;
        data["matchIndex"] = this.matchIndex;
        data["homeTeamIndex"] = this.homeTeamIndex;
        data["awayTeamIndex"] = this.awayTeamIndex;
        data["organiserTeamIndex"] = this.organiserTeamIndex;
        data["leagueSchema"] = this.leagueSchema ? this.leagueSchema.toJSON() : undefined;
        return data;
    }
}
export class LeagueMatchPoints {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueSchemaId = _data["leagueSchemaId"];
            this.score1 = _data["score1"];
            this.score2 = _data["score2"];
            this.points1 = _data["points1"];
            this.points2 = _data["points2"];
            this.leagueSchema = _data["leagueSchema"] ? LeagueSchema.fromJS(_data["leagueSchema"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchPoints();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueSchemaId"] = this.leagueSchemaId;
        data["score1"] = this.score1;
        data["score2"] = this.score2;
        data["points1"] = this.points1;
        data["points2"] = this.points2;
        data["leagueSchema"] = this.leagueSchema ? this.leagueSchema.toJSON() : undefined;
        return data;
    }
}
export class LeagueRankingPoints {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueSchemaId = _data["leagueSchemaId"];
            this.index = _data["index"];
            this.disciplineCode = _data["disciplineCode"];
            this.ranking = _data["ranking"];
            this.pointsWinner = _data["pointsWinner"];
            this.pointsLoser = _data["pointsLoser"];
            this.pointsEven = _data["pointsEven"];
            this.leagueSchema = _data["leagueSchema"] ? LeagueSchema.fromJS(_data["leagueSchema"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueRankingPoints();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueSchemaId"] = this.leagueSchemaId;
        data["index"] = this.index;
        data["disciplineCode"] = this.disciplineCode;
        data["ranking"] = this.ranking;
        data["pointsWinner"] = this.pointsWinner;
        data["pointsLoser"] = this.pointsLoser;
        data["pointsEven"] = this.pointsEven;
        data["leagueSchema"] = this.leagueSchema ? this.leagueSchema.toJSON() : undefined;
        return data;
    }
}
export class LeagueRound {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueSchemaId = _data["leagueSchemaId"];
            this.index = _data["index"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined;
            this.text = _data["text"];
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined;
            this.leagueSchema = _data["leagueSchema"] ? LeagueSchema.fromJS(_data["leagueSchema"]) : undefined;
            if (Array.isArray(_data["leagueMatch1"])) {
                this.leagueMatch1 = [];
                for (let item of _data["leagueMatch1"])
                    this.leagueMatch1.push(LeagueMatch.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueRound();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueSchemaId"] = this.leagueSchemaId;
        data["index"] = this.index;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["text"] = this.text;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined;
        data["leagueSchema"] = this.leagueSchema ? this.leagueSchema.toJSON() : undefined;
        if (Array.isArray(this.leagueMatch1)) {
            data["leagueMatch1"] = [];
            for (let item of this.leagueMatch1)
                data["leagueMatch1"].push(item.toJSON());
        }
        return data;
    }
}
export class LeagueStandingsRule {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueSchemaId = _data["leagueSchemaId"];
            this.index = _data["index"];
            this.rule = _data["rule"];
            this.leagueSchema = _data["leagueSchema"] ? LeagueSchema.fromJS(_data["leagueSchema"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueStandingsRule();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueSchemaId"] = this.leagueSchemaId;
        data["index"] = this.index;
        data["rule"] = this.rule;
        data["leagueSchema"] = this.leagueSchema ? this.leagueSchema.toJSON() : undefined;
        return data;
    }
}
export class LeagueTeamSchemaMatch {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueSchemaId = _data["leagueSchemaId"];
            this.index = _data["index"];
            this.disciplineCode = _data["disciplineCode"];
            this.ranking = _data["ranking"];
            this.group = _data["group"];
            this.selectPlayerType = _data["selectPlayerType"];
            this.text = _data["text"];
            this.playerTroopIndex1 = _data["playerTroopIndex1"];
            this.playerTroopIndex2 = _data["playerTroopIndex2"];
            this.gender = _data["gender"];
            this.leagueSchema = _data["leagueSchema"] ? LeagueSchema.fromJS(_data["leagueSchema"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueTeamSchemaMatch();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueSchemaId"] = this.leagueSchemaId;
        data["index"] = this.index;
        data["disciplineCode"] = this.disciplineCode;
        data["ranking"] = this.ranking;
        data["group"] = this.group;
        data["selectPlayerType"] = this.selectPlayerType;
        data["text"] = this.text;
        data["playerTroopIndex1"] = this.playerTroopIndex1;
        data["playerTroopIndex2"] = this.playerTroopIndex2;
        data["gender"] = this.gender;
        data["leagueSchema"] = this.leagueSchema ? this.leagueSchema.toJSON() : undefined;
        return data;
    }
}
export class LeagueGroup {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueGroupId = _data["leagueGroupId"];
            this.leagueDivisionId = _data["leagueDivisionId"];
            this.groupIndex = _data["groupIndex"];
            this.name = _data["name"];
            this.matchPlanRepetitions = _data["matchPlanRepetitions"];
            this.matchPlanComplete = _data["matchPlanComplete"];
            this.eventRounds = _data["eventRounds"];
            this.multiTeams = _data["multiTeams"];
            this.isPlayOff = _data["isPlayOff"];
            this.tournamentSystem = _data["tournamentSystem"];
            this.leagueDivision = _data["leagueDivision"] ? LeagueDivision.fromJS(_data["leagueDivision"]) : undefined;
            if (Array.isArray(_data["leagueGroupTeamLeagueGroup"])) {
                this.leagueGroupTeamLeagueGroup = [];
                for (let item of _data["leagueGroupTeamLeagueGroup"])
                    this.leagueGroupTeamLeagueGroup.push(LeagueGroupTeam.fromJS(item));
            }
            if (Array.isArray(_data["leagueGroupTeamTransferFromLeagueGroup"])) {
                this.leagueGroupTeamTransferFromLeagueGroup = [];
                for (let item of _data["leagueGroupTeamTransferFromLeagueGroup"])
                    this.leagueGroupTeamTransferFromLeagueGroup.push(LeagueGroupTeam.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueGroup();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueGroupId"] = this.leagueGroupId;
        data["leagueDivisionId"] = this.leagueDivisionId;
        data["groupIndex"] = this.groupIndex;
        data["name"] = this.name;
        data["matchPlanRepetitions"] = this.matchPlanRepetitions;
        data["matchPlanComplete"] = this.matchPlanComplete;
        data["eventRounds"] = this.eventRounds;
        data["multiTeams"] = this.multiTeams;
        data["isPlayOff"] = this.isPlayOff;
        data["tournamentSystem"] = this.tournamentSystem;
        data["leagueDivision"] = this.leagueDivision ? this.leagueDivision.toJSON() : undefined;
        if (Array.isArray(this.leagueGroupTeamLeagueGroup)) {
            data["leagueGroupTeamLeagueGroup"] = [];
            for (let item of this.leagueGroupTeamLeagueGroup)
                data["leagueGroupTeamLeagueGroup"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueGroupTeamTransferFromLeagueGroup)) {
            data["leagueGroupTeamTransferFromLeagueGroup"] = [];
            for (let item of this.leagueGroupTeamTransferFromLeagueGroup)
                data["leagueGroupTeamTransferFromLeagueGroup"].push(item.toJSON());
        }
        return data;
    }
}
export class DbfleagueRankingPointsYouth {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.agegroupId = _data["agegroupId"];
            this.classId = _data["classId"];
            this.points = _data["points"];
            this.agegroup = _data["agegroup"] ? AgeGroup.fromJS(_data["agegroup"]) : undefined;
            this.class = _data["class"] ? Class.fromJS(_data["class"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfleagueRankingPointsYouth();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["agegroupId"] = this.agegroupId;
        data["classId"] = this.classId;
        data["points"] = this.points;
        data["agegroup"] = this.agegroup ? this.agegroup.toJSON() : undefined;
        data["class"] = this.class ? this.class.toJSON() : undefined;
        return data;
    }
}
export class DbfrankinglistTournamentPoints {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.agegroupId = _data["agegroupId"];
            this.classId = _data["classId"];
            this.ranking = _data["ranking"];
            this.points = _data["points"];
            this.minCount = _data["minCount"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined;
            this.agegroup = _data["agegroup"] ? AgeGroup.fromJS(_data["agegroup"]) : undefined;
            this.class = _data["class"] ? Class.fromJS(_data["class"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfrankinglistTournamentPoints();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["agegroupId"] = this.agegroupId;
        data["classId"] = this.classId;
        data["ranking"] = this.ranking;
        data["points"] = this.points;
        data["minCount"] = this.minCount;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined;
        data["agegroup"] = this.agegroup ? this.agegroup.toJSON() : undefined;
        data["class"] = this.class ? this.class.toJSON() : undefined;
        return data;
    }
}
export class DbfappGameUser {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.appGameUserId = _data["appGameUserId"];
            this.unionId = _data["unionId"];
            this.phone = _data["phone"];
            this.name = _data["name"];
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            if (Array.isArray(_data["dbfappGameScore"])) {
                this.dbfappGameScore = [];
                for (let item of _data["dbfappGameScore"])
                    this.dbfappGameScore.push(DbfappGameScore.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfappGameUser();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["appGameUserId"] = this.appGameUserId;
        data["unionId"] = this.unionId;
        data["phone"] = this.phone;
        data["name"] = this.name;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        if (Array.isArray(this.dbfappGameScore)) {
            data["dbfappGameScore"] = [];
            for (let item of this.dbfappGameScore)
                data["dbfappGameScore"].push(item.toJSON());
        }
        return data;
    }
}
export class DbfappGameScore {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.appGameUserId = _data["appGameUserId"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : undefined;
            this.score = _data["score"];
            this.appGameUser = _data["appGameUser"] ? DbfappGameUser.fromJS(_data["appGameUser"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfappGameScore();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["appGameUserId"] = this.appGameUserId;
        data["time"] = this.time ? this.time.toISOString() : undefined;
        data["score"] = this.score;
        data["appGameUser"] = this.appGameUser ? this.appGameUser.toJSON() : undefined;
        return data;
    }
}
export class LiveScoreSubscriber {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.liveScoreSubscriberId = _data["liveScoreSubscriberId"];
            this.smspaymentId = _data["smspaymentId"];
            this.unionId = _data["unionId"];
            this.deviceType = _data["deviceType"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined;
            this.phone = _data["phone"];
            this.deviceId = _data["deviceId"];
            this.code = _data["code"];
            this.userId = _data["userId"];
            this.smspayment = _data["smspayment"] ? Smspayment.fromJS(_data["smspayment"]) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LiveScoreSubscriber();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["liveScoreSubscriberId"] = this.liveScoreSubscriberId;
        data["smspaymentId"] = this.smspaymentId;
        data["unionId"] = this.unionId;
        data["deviceType"] = this.deviceType;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined;
        data["phone"] = this.phone;
        data["deviceId"] = this.deviceId;
        data["code"] = this.code;
        data["userId"] = this.userId;
        data["smspayment"] = this.smspayment ? this.smspayment.toJSON() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class Smspayment {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.smspaymentId = _data["smspaymentId"];
            this.unionId = _data["unionId"];
            this.phoneNumber = _data["phoneNumber"];
            this.recvMessage = _data["recvMessage"];
            this.responseMessage = _data["responseMessage"];
            this.price = _data["price"];
            this.status = _data["status"];
            this.statusFields = _data["statusFields"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : undefined;
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            if (Array.isArray(_data["liveScoreSubscriber"])) {
                this.liveScoreSubscriber = [];
                for (let item of _data["liveScoreSubscriber"])
                    this.liveScoreSubscriber.push(LiveScoreSubscriber.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Smspayment();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["smspaymentId"] = this.smspaymentId;
        data["unionId"] = this.unionId;
        data["phoneNumber"] = this.phoneNumber;
        data["recvMessage"] = this.recvMessage;
        data["responseMessage"] = this.responseMessage;
        data["price"] = this.price;
        data["status"] = this.status;
        data["statusFields"] = this.statusFields;
        data["time"] = this.time ? this.time.toISOString() : undefined;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        if (Array.isArray(this.liveScoreSubscriber)) {
            data["liveScoreSubscriber"] = [];
            for (let item of this.liveScoreSubscriber)
                data["liveScoreSubscriber"].push(item.toJSON());
        }
        return data;
    }
}
export class LiveScoreSubscription {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.unionId = _data["unionId"];
            this.deviceType = _data["deviceType"];
            this.periodMonths = _data["periodMonths"];
            this.price = _data["price"];
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LiveScoreSubscription();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["unionId"] = this.unionId;
        data["deviceType"] = this.deviceType;
        data["periodMonths"] = this.periodMonths;
        data["price"] = this.price;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        return data;
    }
}
export class MailTemplate {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.unionId = _data["unionId"];
            this.mailTemplateType = _data["mailTemplateType"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.parameters = _data["parameters"];
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplate();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["unionId"] = this.unionId;
        data["mailTemplateType"] = this.mailTemplateType;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["parameters"] = this.parameters;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        return data;
    }
}
export class PlayerType {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.playerTypeId = _data["playerTypeId"];
            this.name = _data["name"];
            this.unionId = _data["unionId"];
            this.systemCode = _data["systemCode"];
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            if (Array.isArray(_data["playerPlayerType"])) {
                this.playerPlayerType = [];
                for (let item of _data["playerPlayerType"])
                    this.playerPlayerType.push(PlayerPlayerType.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["playerTypeId"] = this.playerTypeId;
        data["name"] = this.name;
        data["unionId"] = this.unionId;
        data["systemCode"] = this.systemCode;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        if (Array.isArray(this.playerPlayerType)) {
            data["playerPlayerType"] = [];
            for (let item of this.playerPlayerType)
                data["playerPlayerType"].push(item.toJSON());
        }
        return data;
    }
}
export class PlayerPlayerType {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerTypeId = _data["playerTypeId"];
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.playerType = _data["playerType"] ? PlayerType.fromJS(_data["playerType"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerPlayerType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerTypeId"] = this.playerTypeId;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["playerType"] = this.playerType ? this.playerType.toJSON() : undefined;
        return data;
    }
}
export class TournamentType1 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.unionId = _data["unionId"];
            this.tournamentTypeId = _data["tournamentTypeId"];
            this.name = _data["name"];
            this.deleted = _data["deleted"];
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentType1();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["unionId"] = this.unionId;
        data["tournamentTypeId"] = this.tournamentTypeId;
        data["name"] = this.name;
        data["deleted"] = this.deleted;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        return data;
    }
}
export class UnionSettings {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.unionId = _data["unionId"];
            this.settingsId = _data["settingsId"];
            this.value = _data["value"];
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UnionSettings();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["unionId"] = this.unionId;
        data["settingsId"] = this.settingsId;
        data["value"] = this.value;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        return data;
    }
}
export class Venue {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.venueId = _data["venueId"];
            this.unionId = _data["unionId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.countryCode = _data["countryCode"];
            this.updatedByUserId = _data["updatedByUserId"];
            this.updatedTime = _data["updatedTime"] ? new Date(_data["updatedTime"].toString()) : undefined;
            this.address2 = _data["address2"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.courts = _data["courts"];
            this.union = _data["union"] ? Union.fromJS(_data["union"]) : undefined;
            this.updatedByUser = _data["updatedByUser"] ? User1.fromJS(_data["updatedByUser"]) : undefined;
            if (Array.isArray(_data["leagueGroupTeam"])) {
                this.leagueGroupTeam = [];
                for (let item of _data["leagueGroupTeam"])
                    this.leagueGroupTeam.push(LeagueGroupTeam.fromJS(item));
            }
            if (Array.isArray(_data["leagueMatch1"])) {
                this.leagueMatch1 = [];
                for (let item of _data["leagueMatch1"])
                    this.leagueMatch1.push(LeagueMatch.fromJS(item));
            }
            if (Array.isArray(_data["venueClub"])) {
                this.venueClub = [];
                for (let item of _data["venueClub"])
                    this.venueClub.push(VenueClub.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Venue();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["unionId"] = this.unionId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["updatedByUserId"] = this.updatedByUserId;
        data["updatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : undefined;
        data["address2"] = this.address2;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["courts"] = this.courts;
        data["union"] = this.union ? this.union.toJSON() : undefined;
        data["updatedByUser"] = this.updatedByUser ? this.updatedByUser.toJSON() : undefined;
        if (Array.isArray(this.leagueGroupTeam)) {
            data["leagueGroupTeam"] = [];
            for (let item of this.leagueGroupTeam)
                data["leagueGroupTeam"].push(item.toJSON());
        }
        if (Array.isArray(this.leagueMatch1)) {
            data["leagueMatch1"] = [];
            for (let item of this.leagueMatch1)
                data["leagueMatch1"].push(item.toJSON());
        }
        if (Array.isArray(this.venueClub)) {
            data["venueClub"] = [];
            for (let item of this.venueClub)
                data["venueClub"].push(item.toJSON());
        }
        return data;
    }
}
export class VenueClub {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.venueId = _data["venueId"];
            this.clubId = _data["clubId"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.venue = _data["venue"] ? Venue.fromJS(_data["venue"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new VenueClub();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["clubId"] = this.clubId;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["venue"] = this.venue ? this.venue.toJSON() : undefined;
        return data;
    }
}
export class DbfvmrankingYouthPlayer {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.clubId = _data["clubId"];
            this.ranking = _data["ranking"];
            this.totalCount = _data["totalCount"];
            this.eventCount = _data["eventCount"];
            this.matchCount = _data["matchCount"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DbfvmrankingYouthPlayer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["clubId"] = this.clubId;
        data["ranking"] = this.ranking;
        data["totalCount"] = this.totalCount;
        data["eventCount"] = this.eventCount;
        data["matchCount"] = this.matchCount;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        return data;
    }
}
export class PlayerAddress {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.countryCode = _data["countryCode"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.phoneMobile = _data["phoneMobile"];
            this.phoneWork = _data["phoneWork"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : undefined;
            this.comment = _data["comment"];
            this.imageFileId = _data["imageFileId"];
            this.imageFile = _data["imageFile"] ? ImageFile.fromJS(_data["imageFile"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerAddress();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["phoneMobile"] = this.phoneMobile;
        data["phoneWork"] = this.phoneWork;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : undefined;
        data["comment"] = this.comment;
        data["imageFileId"] = this.imageFileId;
        data["imageFile"] = this.imageFile ? this.imageFile.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        return data;
    }
}
export class ImageFile {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.imageFileId = _data["imageFileId"];
            this.fileName = _data["fileName"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.imageData = _data["imageData"];
            if (Array.isArray(_data["clubSuit"])) {
                this.clubSuit = [];
                for (let item of _data["clubSuit"])
                    this.clubSuit.push(ClubSuit.fromJS(item));
            }
            if (Array.isArray(_data["playerAddress"])) {
                this.playerAddress = [];
                for (let item of _data["playerAddress"])
                    this.playerAddress.push(PlayerAddress.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ImageFile();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["imageFileId"] = this.imageFileId;
        data["fileName"] = this.fileName;
        data["width"] = this.width;
        data["height"] = this.height;
        data["imageData"] = this.imageData;
        if (Array.isArray(this.clubSuit)) {
            data["clubSuit"] = [];
            for (let item of this.clubSuit)
                data["clubSuit"].push(item.toJSON());
        }
        if (Array.isArray(this.playerAddress)) {
            data["playerAddress"] = [];
            for (let item of this.playerAddress)
                data["playerAddress"].push(item.toJSON());
        }
        return data;
    }
}
export class ClubSuit {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.description = _data["description"];
            this.imageFileId = _data["imageFileId"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.imageFile = _data["imageFile"] ? ImageFile.fromJS(_data["imageFile"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClubSuit();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["description"] = this.description;
        data["imageFileId"] = this.imageFileId;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["imageFile"] = this.imageFile ? this.imageFile.toJSON() : undefined;
        return data;
    }
}
export class ClubPlayerRelation {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.playerId = _data["playerId"];
            this.club = _data["club"] ? Club1.fromJS(_data["club"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClubPlayerRelation();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["playerId"] = this.playerId;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        return data;
    }
}
export class LeagueMatchPlayer {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueMatchIndividualMatchId = _data["leagueMatchIndividualMatchId"];
            this.leagueGroupTeamId = _data["leagueGroupTeamId"];
            this.playerIndex = _data["playerIndex"];
            this.playerId = _data["playerId"];
            this.noShow = _data["noShow"];
            this.unknown = _data["unknown"];
            this.rankingPoints = _data["rankingPoints"];
            this.rankingPointsCount = _data["rankingPointsCount"];
            this.checked = _data["checked"];
            this.leagueGroupTeam = _data["leagueGroupTeam"] ? LeagueGroupTeam.fromJS(_data["leagueGroupTeam"]) : undefined;
            this.leagueMatchIndividualMatch = _data["leagueMatchIndividualMatch"] ? LeagueMatchIndividualMatch.fromJS(_data["leagueMatchIndividualMatch"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchPlayer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueMatchIndividualMatchId"] = this.leagueMatchIndividualMatchId;
        data["leagueGroupTeamId"] = this.leagueGroupTeamId;
        data["playerIndex"] = this.playerIndex;
        data["playerId"] = this.playerId;
        data["noShow"] = this.noShow;
        data["unknown"] = this.unknown;
        data["rankingPoints"] = this.rankingPoints;
        data["rankingPointsCount"] = this.rankingPointsCount;
        data["checked"] = this.checked;
        data["leagueGroupTeam"] = this.leagueGroupTeam ? this.leagueGroupTeam.toJSON() : undefined;
        data["leagueMatchIndividualMatch"] = this.leagueMatchIndividualMatch ? this.leagueMatchIndividualMatch.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        return data;
    }
}
export class LeagueMatchPlayerLog {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueMatchIndividualMatchId = _data["leagueMatchIndividualMatchId"];
            this.leagueGroupTeamId = _data["leagueGroupTeamId"];
            this.playerIndex = _data["playerIndex"];
            this.playerId = _data["playerId"];
            this.noShow = _data["noShow"];
            this.oldPlayerId = _data["oldPlayerId"];
            this.oldNoShow = _data["oldNoShow"];
            this.leagueGroupTeam = _data["leagueGroupTeam"] ? LeagueGroupTeam.fromJS(_data["leagueGroupTeam"]) : undefined;
            this.leagueMatchIndividualMatch = _data["leagueMatchIndividualMatch"] ? LeagueMatchIndividualMatch.fromJS(_data["leagueMatchIndividualMatch"]) : undefined;
            this.oldPlayer = _data["oldPlayer"] ? Player.fromJS(_data["oldPlayer"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchPlayerLog();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueMatchIndividualMatchId"] = this.leagueMatchIndividualMatchId;
        data["leagueGroupTeamId"] = this.leagueGroupTeamId;
        data["playerIndex"] = this.playerIndex;
        data["playerId"] = this.playerId;
        data["noShow"] = this.noShow;
        data["oldPlayerId"] = this.oldPlayerId;
        data["oldNoShow"] = this.oldNoShow;
        data["leagueGroupTeam"] = this.leagueGroupTeam ? this.leagueGroupTeam.toJSON() : undefined;
        data["leagueMatchIndividualMatch"] = this.leagueMatchIndividualMatch ? this.leagueMatchIndividualMatch.toJSON() : undefined;
        data["oldPlayer"] = this.oldPlayer ? this.oldPlayer.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        return data;
    }
}
export class LeagueMatchReferee {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueMatchId = _data["leagueMatchId"];
            this.index = _data["index"];
            this.playerId = _data["playerId"];
            this.leagueMatch = _data["leagueMatch"] ? LeagueMatch.fromJS(_data["leagueMatch"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchReferee();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueMatchId"] = this.leagueMatchId;
        data["index"] = this.index;
        data["playerId"] = this.playerId;
        data["leagueMatch"] = this.leagueMatch ? this.leagueMatch.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        return data;
    }
}
export class LeagueMatchSubstitute {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueMatchId = _data["leagueMatchId"];
            this.leagueGroupTeamId = _data["leagueGroupTeamId"];
            this.playerId = _data["playerId"];
            this.substitutedPlayerId = _data["substitutedPlayerId"];
            this.leagueGroupTeam = _data["leagueGroupTeam"] ? LeagueGroupTeam.fromJS(_data["leagueGroupTeam"]) : undefined;
            this.leagueMatch = _data["leagueMatch"] ? LeagueMatch.fromJS(_data["leagueMatch"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.substitutedPlayer = _data["substitutedPlayer"] ? Player.fromJS(_data["substitutedPlayer"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchSubstitute();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueMatchId"] = this.leagueMatchId;
        data["leagueGroupTeamId"] = this.leagueGroupTeamId;
        data["playerId"] = this.playerId;
        data["substitutedPlayerId"] = this.substitutedPlayerId;
        data["leagueGroupTeam"] = this.leagueGroupTeam ? this.leagueGroupTeam.toJSON() : undefined;
        data["leagueMatch"] = this.leagueMatch ? this.leagueMatch.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["substitutedPlayer"] = this.substitutedPlayer ? this.substitutedPlayer.toJSON() : undefined;
        return data;
    }
}
export class LeagueMatchTroopPlayer {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueMatchId = _data["leagueMatchId"];
            this.gender = _data["gender"];
            this.leagueGroupTeamId = _data["leagueGroupTeamId"];
            this.playerIndex = _data["playerIndex"];
            this.playerId = _data["playerId"];
            this.noShow = _data["noShow"];
            this.leagueGroupTeam = _data["leagueGroupTeam"] ? LeagueGroupTeam.fromJS(_data["leagueGroupTeam"]) : undefined;
            this.leagueMatch = _data["leagueMatch"] ? LeagueMatch.fromJS(_data["leagueMatch"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchTroopPlayer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueMatchId"] = this.leagueMatchId;
        data["gender"] = this.gender;
        data["leagueGroupTeamId"] = this.leagueGroupTeamId;
        data["playerIndex"] = this.playerIndex;
        data["playerId"] = this.playerId;
        data["noShow"] = this.noShow;
        data["leagueGroupTeam"] = this.leagueGroupTeam ? this.leagueGroupTeam.toJSON() : undefined;
        data["leagueMatch"] = this.leagueMatch ? this.leagueMatch.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        return data;
    }
}
export class PlayerClub {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.relationType = _data["relationType"];
            this.clubId = _data["clubId"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerClub();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["relationType"] = this.relationType;
        data["clubId"] = this.clubId;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        return data;
    }
}
export class PlayerClubContact {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.contactTypeId = _data["contactTypeId"];
            this.clubId = _data["clubId"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.contactType = _data["contactType"] ? ContactType1.fromJS(_data["contactType"]) : undefined;
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerClubContact();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["contactTypeId"] = this.contactTypeId;
        data["clubId"] = this.clubId;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["contactType"] = this.contactType ? this.contactType.toJSON() : undefined;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        return data;
    }
}
export class ContactType1 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.contactTypeId = _data["contactTypeId"];
            this.name = _data["name"];
            this.showTextBox = _data["showTextBox"];
            if (Array.isArray(_data["clubContact1"])) {
                this.clubContact1 = [];
                for (let item of _data["clubContact1"])
                    this.clubContact1.push(ClubContact1.fromJS(item));
            }
            if (Array.isArray(_data["playerClubContact"])) {
                this.playerClubContact = [];
                for (let item of _data["playerClubContact"])
                    this.playerClubContact.push(PlayerClubContact.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContactType1();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["contactTypeId"] = this.contactTypeId;
        data["name"] = this.name;
        data["showTextBox"] = this.showTextBox;
        if (Array.isArray(this.clubContact1)) {
            data["clubContact1"] = [];
            for (let item of this.clubContact1)
                data["clubContact1"].push(item.toJSON());
        }
        if (Array.isArray(this.playerClubContact)) {
            data["playerClubContact"] = [];
            for (let item of this.playerClubContact)
                data["playerClubContact"].push(item.toJSON());
        }
        return data;
    }
}
export class ClubContact1 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubContactId = _data["clubContactId"];
            this.clubId = _data["clubId"];
            this.contactTypeId = _data["contactTypeId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.countryCode = _data["countryCode"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.phoneMobile = _data["phoneMobile"];
            this.phoneWork = _data["phoneWork"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.contactType = _data["contactType"] ? ContactType1.fromJS(_data["contactType"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClubContact1();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubContactId"] = this.clubContactId;
        data["clubId"] = this.clubId;
        data["contactTypeId"] = this.contactTypeId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["phoneMobile"] = this.phoneMobile;
        data["phoneWork"] = this.phoneWork;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["contactType"] = this.contactType ? this.contactType.toJSON() : undefined;
        return data;
    }
}
export class PlayerUser1 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.unionId = _data["unionId"];
            this.userId = _data["userId"];
            this.playerId = _data["playerId"];
            this.playerIndex = _data["playerIndex"];
            this.player = _data["player"] ? Player.fromJS(_data["player"]) : undefined;
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerUser1();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["unionId"] = this.unionId;
        data["userId"] = this.userId;
        data["playerId"] = this.playerId;
        data["playerIndex"] = this.playerIndex;
        data["player"] = this.player ? this.player.toJSON() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class Inbox {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.messageId = _data["messageId"];
            this.state = _data["state"];
            this.relationClubId = _data["relationClubId"];
            this.relationSortIndex = _data["relationSortIndex"];
            this.relationClubId2 = _data["relationClubId2"];
            this.message = _data["message"] ? Message.fromJS(_data["message"]) : undefined;
            this.relationClub = _data["relationClub"] ? Club1.fromJS(_data["relationClub"]) : undefined;
            this.relationClubId2Navigation = _data["relationClubId2Navigation"] ? Club1.fromJS(_data["relationClubId2Navigation"]) : undefined;
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Inbox();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["messageId"] = this.messageId;
        data["state"] = this.state;
        data["relationClubId"] = this.relationClubId;
        data["relationSortIndex"] = this.relationSortIndex;
        data["relationClubId2"] = this.relationClubId2;
        data["message"] = this.message ? this.message.toJSON() : undefined;
        data["relationClub"] = this.relationClub ? this.relationClub.toJSON() : undefined;
        data["relationClubId2Navigation"] = this.relationClubId2Navigation ? this.relationClubId2Navigation.toJSON() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class TournamentLog {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tournamentId = _data["tournamentId"];
            this.clubId = _data["clubId"];
            this.userId = _data["userId"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : undefined;
            this.message = _data["message"];
            this.tournamentLogId = _data["tournamentLogId"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentLog();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tournamentId"] = this.tournamentId;
        data["clubId"] = this.clubId;
        data["userId"] = this.userId;
        data["time"] = this.time ? this.time.toISOString() : undefined;
        data["message"] = this.message;
        data["tournamentLogId"] = this.tournamentLogId;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class UploadedFiles {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.uploadedFileName = _data["uploadedFileName"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileContent = _data["fileContent"];
            this.uploadedTimestamp = _data["uploadedTimestamp"] ? new Date(_data["uploadedTimestamp"].toString()) : undefined;
            this.uploadedByUserId = _data["uploadedByUserId"];
            this.uploadedByUser = _data["uploadedByUser"] ? User1.fromJS(_data["uploadedByUser"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadedFiles();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["uploadedFileName"] = this.uploadedFileName;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileContent"] = this.fileContent;
        data["uploadedTimestamp"] = this.uploadedTimestamp ? this.uploadedTimestamp.toISOString() : undefined;
        data["uploadedByUserId"] = this.uploadedByUserId;
        data["uploadedByUser"] = this.uploadedByUser ? this.uploadedByUser.toJSON() : undefined;
        return data;
    }
}
export class UserMailSent {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.mailTypeId = _data["mailTypeId"];
            this.lastSentTime = _data["lastSentTime"] ? new Date(_data["lastSentTime"].toString()) : undefined;
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserMailSent();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["mailTypeId"] = this.mailTypeId;
        data["lastSentTime"] = this.lastSentTime ? this.lastSentTime.toISOString() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class UserMailType {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.mailTypeId = _data["mailTypeId"];
            this.selected = _data["selected"];
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserMailType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["mailTypeId"] = this.mailTypeId;
        data["selected"] = this.selected;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class UserPortal {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.portalId = _data["portalId"];
            this.portal = _data["portal"] ? Portal.fromJS(_data["portal"]) : undefined;
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserPortal();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["portalId"] = this.portalId;
        data["portal"] = this.portal ? this.portal.toJSON() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class UserRole1 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.clubId = _data["clubId"];
            this.roleMask = _data["roleMask"];
            this.updatedByUserId = _data["updatedByUserId"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : undefined;
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
            this.updatedByUser = _data["updatedByUser"] ? User1.fromJS(_data["updatedByUser"]) : undefined;
            this.user = _data["user"] ? User1.fromJS(_data["user"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole1();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["clubId"] = this.clubId;
        data["roleMask"] = this.roleMask;
        data["updatedByUserId"] = this.updatedByUserId;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : undefined;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        data["updatedByUser"] = this.updatedByUser ? this.updatedByUser.toJSON() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class SaemailLog {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.email = _data["email"];
            this.emailSender = _data["emailSender"];
            this.messageId = _data["messageId"];
            this.toUserId = _data["toUserId"];
            this.sentByUserId = _data["sentByUserId"];
            this.portalId = _data["portalId"];
            this.sentTime = _data["sentTime"] ? new Date(_data["sentTime"].toString()) : undefined;
            this.hasError = _data["hasError"];
            this.errorMessage = _data["errorMessage"];
            this.saemailLogId = _data["saemailLogId"];
            this.message = _data["message"] ? Message.fromJS(_data["message"]) : undefined;
            this.portal = _data["portal"] ? Portal.fromJS(_data["portal"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaemailLog();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["emailSender"] = this.emailSender;
        data["messageId"] = this.messageId;
        data["toUserId"] = this.toUserId;
        data["sentByUserId"] = this.sentByUserId;
        data["portalId"] = this.portalId;
        data["sentTime"] = this.sentTime ? this.sentTime.toISOString() : undefined;
        data["hasError"] = this.hasError;
        data["errorMessage"] = this.errorMessage;
        data["saemailLogId"] = this.saemailLogId;
        data["message"] = this.message ? this.message.toJSON() : undefined;
        data["portal"] = this.portal ? this.portal.toJSON() : undefined;
        return data;
    }
}
export class PortalDomain {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.domain = _data["domain"];
            this.portalId = _data["portalId"];
            this.shopId = _data["shopId"];
            this.shopMainUrl = _data["shopMainUrl"];
            this.ssl = _data["ssl"];
            this.cmsId = _data["cmsId"];
            this.cmsMainUrl = _data["cmsMainUrl"];
            this.redirectUrl = _data["redirectUrl"];
            this.portal = _data["portal"] ? Portal.fromJS(_data["portal"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PortalDomain();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        data["portalId"] = this.portalId;
        data["shopId"] = this.shopId;
        data["shopMainUrl"] = this.shopMainUrl;
        data["ssl"] = this.ssl;
        data["cmsId"] = this.cmsId;
        data["cmsMainUrl"] = this.cmsMainUrl;
        data["redirectUrl"] = this.redirectUrl;
        data["portal"] = this.portal ? this.portal.toJSON() : undefined;
        return data;
    }
}
export class ClubCategory {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.categoryId = _data["categoryId"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClubCategory();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["categoryId"] = this.categoryId;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        return data;
    }
}
export class ClubField {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.fieldType = _data["fieldType"];
            this.value = _data["value"];
            this.club = _data["club"] ? Club2.fromJS(_data["club"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClubField();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["fieldType"] = this.fieldType;
        data["value"] = this.value;
        data["club"] = this.club ? this.club.toJSON() : undefined;
        return data;
    }
}
export class LeagueMatchMultiTeam {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueMatchMultiTeamId = _data["leagueMatchMultiTeamId"];
            this.leagueMatchId = _data["leagueMatchId"];
            this.index = _data["index"];
            this.leagueGroupTeamId = _data["leagueGroupTeamId"];
            this.points = _data["points"];
            this.score = _data["score"];
            this.setsWon = _data["setsWon"];
            this.setPointsWon = _data["setPointsWon"];
            this.leagueGroupTeam = _data["leagueGroupTeam"] ? LeagueGroupTeam.fromJS(_data["leagueGroupTeam"]) : undefined;
            this.leagueMatch = _data["leagueMatch"] ? LeagueMatch.fromJS(_data["leagueMatch"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchMultiTeam();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueMatchMultiTeamId"] = this.leagueMatchMultiTeamId;
        data["leagueMatchId"] = this.leagueMatchId;
        data["index"] = this.index;
        data["leagueGroupTeamId"] = this.leagueGroupTeamId;
        data["points"] = this.points;
        data["score"] = this.score;
        data["setsWon"] = this.setsWon;
        data["setPointsWon"] = this.setPointsWon;
        data["leagueGroupTeam"] = this.leagueGroupTeam ? this.leagueGroupTeam.toJSON() : undefined;
        data["leagueMatch"] = this.leagueMatch ? this.leagueMatch.toJSON() : undefined;
        return data;
    }
}
export class LiveScoreLeagueMatch {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueMatchId = _data["leagueMatchId"];
            this.score1 = _data["score1"];
            this.score2 = _data["score2"];
            this.leagueMatch = _data["leagueMatch"] ? LeagueMatch.fromJS(_data["leagueMatch"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LiveScoreLeagueMatch();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueMatchId"] = this.leagueMatchId;
        data["score1"] = this.score1;
        data["score2"] = this.score2;
        data["leagueMatch"] = this.leagueMatch ? this.leagueMatch.toJSON() : undefined;
        return data;
    }
}
export class LeagueMatchSet {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leagueMatchIndividualMatchId = _data["leagueMatchIndividualMatchId"];
            this.setIndex = _data["setIndex"];
            this.points1 = _data["points1"];
            this.points2 = _data["points2"];
            this.teamIndex1 = _data["teamIndex1"];
            this.teamIndex2 = _data["teamIndex2"];
            this.leagueMatchIndividualMatch = _data["leagueMatchIndividualMatch"] ? LeagueMatchIndividualMatch.fromJS(_data["leagueMatchIndividualMatch"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchSet();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leagueMatchIndividualMatchId"] = this.leagueMatchIndividualMatchId;
        data["setIndex"] = this.setIndex;
        data["points1"] = this.points1;
        data["points2"] = this.points2;
        data["teamIndex1"] = this.teamIndex1;
        data["teamIndex2"] = this.teamIndex2;
        data["leagueMatchIndividualMatch"] = this.leagueMatchIndividualMatch ? this.leagueMatchIndividualMatch.toJSON() : undefined;
        return data;
    }
}
export class LeagueMatchSubstitutesViewModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.substitute = _data["substitute"] ? LeagueMatchSubstitute.fromJS(_data["substitute"]) : undefined;
            this.player1 = _data["player1"] ? LeagueMatchSubstitutePlayerViewModel.fromJS(_data["player1"]) : undefined;
            this.substitutedPlayer = _data["substitutedPlayer"] ? LeagueMatchSubstitutePlayerViewModel.fromJS(_data["substitutedPlayer"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchSubstitutesViewModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["substitute"] = this.substitute ? this.substitute.toJSON() : undefined;
        data["player1"] = this.player1 ? this.player1.toJSON() : undefined;
        data["substitutedPlayer"] = this.substitutedPlayer ? this.substitutedPlayer.toJSON() : undefined;
        return data;
    }
}
export class LeagueMatchSubstitutePlayerViewModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerNumber = _data["playerNumber"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchSubstitutePlayerViewModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerNumber"] = this.playerNumber;
        data["name"] = this.name;
        return data;
    }
}
export class RegionViewModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.regionId = _data["regionId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RegionViewModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["regionId"] = this.regionId;
        return data;
    }
}
export class LeagueMatchSettingsViewModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.showDraftButton = _data["showDraftButton"];
            this.showResetButton = _data["showResetButton"];
            this.showCancelResetButton = _data["showCancelResetButton"];
            this.showPostponeMatchButton = _data["showPostponeMatchButton"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeagueMatchSettingsViewModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["showDraftButton"] = this.showDraftButton;
        data["showResetButton"] = this.showResetButton;
        data["showCancelResetButton"] = this.showCancelResetButton;
        data["showPostponeMatchButton"] = this.showPostponeMatchButton;
        return data;
    }
}
export var LeagueMatchReportingType;
(function (LeagueMatchReportingType) {
    LeagueMatchReportingType[LeagueMatchReportingType["AllResults"] = 0] = "AllResults";
    LeagueMatchReportingType[LeagueMatchReportingType["CombinedResults"] = 1] = "CombinedResults";
    LeagueMatchReportingType[LeagueMatchReportingType["RostersOnly"] = 2] = "RostersOnly";
    LeagueMatchReportingType[LeagueMatchReportingType["LiveScore"] = 3] = "LiveScore";
    LeagueMatchReportingType[LeagueMatchReportingType["PlayersAwayOnly"] = 4] = "PlayersAwayOnly";
    LeagueMatchReportingType[LeagueMatchReportingType["PlayersHomeOnly"] = 5] = "PlayersHomeOnly";
})(LeagueMatchReportingType || (LeagueMatchReportingType = {}));
export class ProblemDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {};
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions[key] = _data["extensions"][key];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key];
            }
        }
        return data;
    }
}
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
